import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Pipe, EventEmitter, Input, ViewChild, Output, NgModule } from '@angular/core';
import * as copyAddressLists from 'app-models';
import { possibleDateFormats, acceptedFileTypes, HAIRCOLORS, EYECOLORS } from 'app-models';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { take, takeUntil, map as map$1, distinctUntilChanged } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import * as i2$2 from '@angular/forms';
import { Validators, FormControl, FormGroup, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as moment from 'moment';
import moment__default from 'moment';
import * as i1 from '@angular/common/http';
import * as i2 from 'web-storage';
import { __rest } from 'tslib';
import * as errorUtils from 'error-message-utility';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { HelpVideoOverlayLibraryComponent, HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import * as i2$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i1$1 from 'reference-library';
import * as i9 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from 'ngx-image-cropper';
import { ImageCropperModule } from 'ngx-image-cropper';
import * as i13 from 'custom-questionnaire';
import { CustomQuestionnaireComponent, CustomQuestionnaireModule } from 'custom-questionnaire';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i3 from 'cache-country-list';
import * as i4$1 from 'ngx-toastr';
import * as i6 from '@ngrx/store';
import * as i7 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i10 from 'primeng/accordion';
import { AccordionModule } from 'primeng/accordion';
import * as i11 from 'primeng/api';
import * as i12 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i14 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i15 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import * as i16 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i17 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i18 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i19 from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import * as i20 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i21 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i22 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i23 from 'primeng/radiobutton';
import * as i24 from 'primeng/inputswitch';
import * as i25 from 'file-upload-deafult-library';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import * as i26 from 'primeng/tooltip';
import * as i27 from 'primeng/checkbox';
import * as i28 from 'simple-file-upload';
import { SimpleFileUploadModule } from 'simple-file-upload';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { PrimengLibraryModule } from 'primeng-library';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { SaveAsDraftModule } from 'save-as-draft';

class GenericBeneficiaryPersonalDetailsLibraryService {
    constructor(http, webStorage) {
        this.http = http;
        this.webStorage = webStorage;
        this.isExpired = false;
        this.statusChangeSubScriptionSubjectStep = new BehaviorSubject(1);
        this.formIsDirtySubject = new BehaviorSubject({ dirty: false, formName: '', formNumber: 1 });
        this.isExperienceChanged = new Subject();
        this.onLifeStorySubTabs = new Subject();
        this.deletedfile$ = new BehaviorSubject({});
        this.showBeneficiary = new BehaviorSubject(false);
        this.countryDataSource = new BehaviorSubject({ listCountries: [] });
        this.uploaded$ = new BehaviorSubject({});
        this.profilePicUpdated = new BehaviorSubject(false); //im-3899
        // public profilePicUpdate = new BehaviorSubject<boolean>(false);//IM-3763
        this.profilePicUpdate = new BehaviorSubject({ hasImage: false, image: '' }); //IM-3763
        this.dependentProfileSubject = new BehaviorSubject({});
        this.selfBeneficiaryDetailChange = new Subject();
        this.newSubDependentCreated = new Subject();
        this.selfDetailsSaved = new Subject();
        this.currentUserSubject = new BehaviorSubject(this.webStorage.getWebStorageItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    imageProfileUpdated(noUpdateFlag) {
        this.profilePicUpdated.next(noUpdateFlag); // im-3899
    }
    hasProfileImage(obj) {
        this.profilePicUpdate.next(obj); // IM-3763
    }
    checkValidity() {
        return this.isExpired; /////
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    onUnSubscribe(subcriptions) {
        subcriptions.forEach(subcription => {
            if (subcription) {
                subcription.unsubscribe();
            }
        });
    }
    changeDependentProfileID(dependentId, beneficiaryType) {
        this.dependentProfileSubject.next({
            dependentId: dependentId,
            beneficiaryType: beneficiaryType,
        });
    }
    triggerSelfDetailsSaved() {
        this.selfDetailsSaved.next("success");
    }
    checkBeneEditPermission() {
        const permission = JSON.parse(sessionStorage.getItem('currentUser'));
        return permission ? permission['permissions'].length > 0 && permission['permissions'].find(x => x === 'EDIT_BENEFICIARY') ? true : false : false;
        // return permission['permissions'].length>0 && permission['permissions'].find(x=> x === 'DELETE_BENEFICIARY')? true : false;
    }
    experienceChanged(data) {
        this.isExperienceChanged.next(data);
    }
    parseToDate(dateString) {
        if (!dateString)
            return null;
        const parsedDate = moment(dateString, possibleDateFormats, true);
        return parsedDate.isValid() ? parsedDate.toDate() : null;
    }
    parseToISOString(dateString) {
        if (!dateString)
            return null;
        const parsedDate = moment(dateString, possibleDateFormats, true);
        return parsedDate.isValid() ? parsedDate.toISOString() : null;
    }
    getStates(countryCode) {
        return this.http.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
    getCountry() {
        return this.http.get('/countries').pipe(map((response) => {
            if (response.data) {
                this.countryDataSource.next({ listCountries: response.data });
                return response.data;
            }
        }));
    }
    getCachedCountryList() {
        return this.countryDataSource.asObservable();
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    getFBEmployeeDetails(fbEmployeeId) {
        return this.http.get(`/vd/formBuilder/fbInviteEmployee/${fbEmployeeId}/employee`).pipe(map((response) => response.data));
    }
    getBeneficiaryDetails(beneficiaryId, type, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/${type}${profileFamilyString}`).pipe(map((response) => response.data));
    }
    saveEmployeeFB(payload) {
        return this.http.post(`/vd/formBuilder/invite/employee`, payload).pipe(map((response) => response));
    }
    saveBeneficiaryDetails(beneficiaryId, type, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/${type}${profileFamilyString}`, payload).pipe(map((response) => response));
    }
    getEmployeeFBDetails(moduleId, pageFormId, companyId, beneficiaryId) {
        return this.http.get(`/vd/formBuilder/module/${moduleId}/pageForm/${pageFormId}/company/${companyId}/beneficiary/${beneficiaryId}/employee
    `).pipe(map((response) => response.data));
    }
    saveBeneficiaryFamilyDetails(beneficiaryId, type, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/${type}`, payload).pipe(map((response) => response));
    }
    saveSimpleBeneficiaryDetails(beneficiaryId, type, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/${type}?isSimplifiedProfile=true${profileFamilyString}`, payload).pipe(map((response) => response));
    }
    postSignatureImageBen(beneficiaryId, payload) {
        // console.log('post data', payload);
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/signpic`, payload).pipe(map((data) => {
            // console.log('from servpicpost', data);
            return data;
        }));
    }
    postFamilySignatureImageBen(beneficiaryId, familyId, payload) {
        // console.log('post data', payload);
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/family/${familyId}/signPic`, payload).pipe(map((data) => {
            // console.log('from servpicpost', data);
            return data;
        }));
    }
    updateProfilePic(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/self/profileimage`, payload).pipe(map((response) => response));
    }
    updateFamilyProfilePic(beneficiaryId, familyId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/family/${familyId}/profileimage`, payload).pipe(map((response) => response));
    }
    getSignatureImageBen(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/signpic`).pipe(map((data) => {
            // console.log('from servpicget', data);
            return data;
        }));
    }
    getFamilySignatureImageBen(beneficiaryId, familyId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/family/${familyId}/signpic`).pipe(map((data) => {
            // console.log('from servpicget', data);
            return data;
        }));
    }
    frmToValidation(frmDt, toDt) {
        return true;
    }
    MinDateValidate(inputDt, MaxDt) {
        return inputDt < MaxDt;
    }
    MaxDateValidate(inputDt, MaxDt) {
        return inputDt > MaxDt;
    }
    currentDateValidator(currentDate) {
        return (control) => {
            // console.log("$$$$ service",control.value, currentDate)
            if (control.value !== undefined && (control.value > currentDate)) {
                return { 'currentDateError': true };
            }
            // if(control.value !== undefined && !moment(control.value, 'MM-DD-YYYY').isValid()){
            // return { 'patternError': true };
            // }
            return null;
        };
    }
    dynamicRequiredValidator(formName, visaType, fieldNames) {
        fieldNames.addRequiredValidator.forEach(field => {
            const fieldName = field;
            if (fieldName) {
                fieldName.setValidators([Validators.required]);
                fieldName.updateValueAndValidity();
            }
        });
        fieldNames.removeAllValidator.forEach(field => {
            const fieldName = field;
            if (fieldName) {
                fieldName.clearValidators();
                fieldName.updateValueAndValidity();
            }
        });
    }
}
GenericBeneficiaryPersonalDetailsLibraryService.ɵfac = function GenericBeneficiaryPersonalDetailsLibraryService_Factory(t) { return new (t || GenericBeneficiaryPersonalDetailsLibraryService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ImagilityWebStorage)); };
GenericBeneficiaryPersonalDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: GenericBeneficiaryPersonalDetailsLibraryService, factory: GenericBeneficiaryPersonalDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryPersonalDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ImagilityWebStorage }]; }, null); })();

function SignatureUploadComponent_div_9_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1, ", file size should be less than 10MB");
    i0.ɵɵelementEnd();
} }
function SignatureUploadComponent_div_9_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1, " Unaccepted format!. Please upload a 'png' format file ");
    i0.ɵɵelementEnd();
} }
function SignatureUploadComponent_div_9_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1, " Please upload a file size less than 10MB ");
    i0.ɵɵelementEnd();
} }
function SignatureUploadComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "label", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵelement(3, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 13);
    i0.ɵɵlistener("change", function SignatureUploadComponent_div_9_Template_input_change_4_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.fileChangeEvent($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 14);
    i0.ɵɵelementStart(6, "sup");
    i0.ɵɵtext(7, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 15);
    i0.ɵɵtext(9, "png format only");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, SignatureUploadComponent_div_9_span_10_Template, 2, 0, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, SignatureUploadComponent_div_9_div_11_Template, 2, 0, "div", 17);
    i0.ɵɵtemplate(12, SignatureUploadComponent_div_9_div_12_Template, 2, 0, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r0.currentIconItem);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.unacceptedFormat);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.unacceptedFormat && ctx_r0.currentIconItem);
} }
function SignatureUploadComponent_div_10_div_1_img_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 30);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", ctx_r8.croppedImage, i0.ɵɵsanitizeUrl);
} }
function SignatureUploadComponent_div_10_div_1_button_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2, "Save Photo");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("mat-dialog-close", ctx_r9.croppedImage);
} }
function SignatureUploadComponent_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "image-cropper", 21);
    i0.ɵɵlistener("imageCropped", function SignatureUploadComponent_div_10_div_1_Template_image_cropper_imageCropped_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.imageCropped($event); })("imageLoaded", function SignatureUploadComponent_div_10_div_1_Template_image_cropper_imageLoaded_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.imageLoaded(); })("cropperReady", function SignatureUploadComponent_div_10_div_1_Template_image_cropper_cropperReady_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.cropperReady(); })("loadImageFailed", function SignatureUploadComponent_div_10_div_1_Template_image_cropper_loadImageFailed_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.loadImageFailed(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "input", 22);
    i0.ɵɵlistener("ngModelChange", function SignatureUploadComponent_div_10_div_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.zoom($event); })("ngModelChange", function SignatureUploadComponent_div_10_div_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.zoomVal = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 2);
    i0.ɵɵelementStart(4, "div", 23);
    i0.ɵɵelementStart(5, "i", 24);
    i0.ɵɵlistener("click", function SignatureUploadComponent_div_10_div_1_Template_i_click_5_listener() { i0.ɵɵrestoreView(_r11); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.rotateLeft(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 25);
    i0.ɵɵelementStart(7, "button", 26);
    i0.ɵɵlistener("click", function SignatureUploadComponent_div_10_div_1_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r11); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.resetImage(); });
    i0.ɵɵelementStart(8, "span", 15);
    i0.ɵɵtext(9, "Reset");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 27);
    i0.ɵɵtemplate(11, SignatureUploadComponent_div_10_div_1_img_11_Template, 1, 1, "img", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 27);
    i0.ɵɵtemplate(13, SignatureUploadComponent_div_10_div_1_button_13_Template, 3, 1, "button", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("imageChangedEvent", ctx_r7.imageChangedEvent)("maintainAspectRatio", false)("aspectRatio", 4 / 2)("onlyScaleDown", true)("canvasRotation", ctx_r7.canvasRotation)("transform", ctx_r7.transform)("alignImage", "left");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r7.zoomVal);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r7.croppedImage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.croppedImage);
} }
function SignatureUploadComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SignatureUploadComponent_div_10_div_1_Template, 14, 10, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showCropperSection);
} }
class SignatureUploadComponent {
    constructor(referenceLibraryService, dialogRef, data) {
        this.referenceLibraryService = referenceLibraryService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.canvasRotation = 0;
        this.rotation = 0;
        this.scale = 1;
        this.showCropper = false;
        this.containWithinAspectRatio = false;
        this.transform = {};
        this.showCropperSection = true;
        this.showFileUploadSection = true;
        this.zoomVal = 1;
        this.unacceptedFormat = false;
        this.currentIconItem = false;
        this.previousVal = this.zoomVal;
        if (data == "iconUpload") {
            this.currentIconItem = true;
        }
    }
    ngOnInit() {
        this.translet();
    }
    onNoClick() {
        this.dialogRef.close();
    }
    uploadProfileImage() {
        this.showCropperSection = false;
    }
    fileChangeEvent(event) {
        this.imageChangedEvent = event;
        const type = 'image/png';
        if (this.currentIconItem) {
            this.currentItemSize = (this.imageChangedEvent.target.files[0].size / 1024 / 1024).toFixed(2);
        }
        if (!this.imageChangedEvent.target.files[0].type.match(type) || (this.currentItemSize > 5)) {
            this.unacceptedFormat = true;
            this.showFileUploadSection = true;
            this.translet();
            return;
        }
        this.showFileUploadSection = false;
        this.translet();
    }
    imageCropped(event) {
        this.croppedImage = event.base64;
        // this.croppedImage = base64ToFile(event.base64);
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    imageLoaded() {
        // show cropper
        //console.log("image ready");
    }
    cropperReady() {
        // cropper ready
        //console.log("cropper ready");
    }
    loadImageFailed() {
        // show message
    }
    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }
    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }
    flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = Object.assign(Object.assign({}, this.transform), { flipH: flippedV, flipV: flippedH });
    }
    flipHorizontal() {
        this.transform = Object.assign(Object.assign({}, this.transform), { flipH: !this.transform.flipH });
    }
    flipVertical() {
        this.transform = Object.assign(Object.assign({}, this.transform), { flipV: !this.transform.flipV });
    }
    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
    }
    zoom(event) {
        if (this.previousVal > event) {
            this.zoomOut();
        }
        else {
            this.zoomIn();
        }
        this.previousVal = event; //IM-4239
    }
    zoomOut() {
        this.scale -= .1;
        this.transform = Object.assign(Object.assign({}, this.transform), { scale: this.scale });
    }
    zoomIn() {
        this.scale += .1;
        this.transform = Object.assign(Object.assign({}, this.transform), { scale: this.scale });
    }
    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }
    updateRotation() {
        this.transform = Object.assign(Object.assign({}, this.transform), { rotate: this.rotation });
    }
}
SignatureUploadComponent.ɵfac = function SignatureUploadComponent_Factory(t) { return new (t || SignatureUploadComponent)(i0.ɵɵdirectiveInject(i1$1.ReferenceLibraryService), i0.ɵɵdirectiveInject(i2$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
SignatureUploadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SignatureUploadComponent, selectors: [["app-signature-upload"]], decls: 11, vars: 2, consts: [[1, "modalBoxContainer"], [1, "modelTitleBox"], [1, "row"], [1, "col-11", "common-bene-class-for-translation"], [1, "col-1", "rounded-circle"], [1, "fa", "fa-close", 2, "font-size", "24px", "font-weight", "500", 3, "mat-dialog-close"], [1, "dialogContentBox"], ["style", "height: 313px;", 4, "ngIf"], [4, "ngIf"], [2, "height", "313px"], ["for", "file-input"], [1, "center-icon"], [1, "fa", "fa-cloud-upload", 2, "font-size", "96px", "color", "blue"], ["id", "file-input", "type", "file", 1, "hiddenFile", 3, "change"], [1, "hint"], [1, "common-bene-class-for-translation"], ["class", "common-bene-class-for-translation", 4, "ngIf"], ["class", "error common-bene-class-for-translation", 4, "ngIf"], [1, "error", "common-bene-class-for-translation"], ["style", "width:100%;height:206px", 4, "ngIf"], [2, "width", "100%", "height", "206px"], ["format", "png", 3, "imageChangedEvent", "maintainAspectRatio", "aspectRatio", "onlyScaleDown", "canvasRotation", "transform", "alignImage", "imageCropped", "imageLoaded", "cropperReady", "loadImageFailed"], ["type", "range", "id", "customRange1", 1, "custom-range", 3, "ngModel", "ngModelChange"], [1, "col-1"], [1, "fa", "fa-rotate-right", 2, "font-size", "24px", 3, "click"], [1, "col-3"], [1, "btn", "btn-primary", 3, "click"], [1, "col-4"], ["class", "", 3, "src", 4, "ngIf"], ["class", "btn btn-primary", 3, "mat-dialog-close", 4, "ngIf"], [1, "", 3, "src"], [1, "btn", "btn-primary", 3, "mat-dialog-close"]], template: function SignatureUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h3");
        i0.ɵɵtext(5, "Upload Files");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelement(7, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, SignatureUploadComponent_div_9_Template, 13, 3, "div", 7);
        i0.ɵɵtemplate(10, SignatureUploadComponent_div_10_Template, 2, 1, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.showFileUploadSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showFileUploadSection);
    } }, directives: [i2$1.MatDialogClose, i9.NgIf, i4.ImageCropperComponent, i2$2.RangeValueAccessor, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.NgModel], styles: [".modalBoxContainer[_ngcontent-%COMP%]{padding:10px!important}.modalBoxContainer[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]{display:block!important;font-size:12px;color:red}.modalBoxContainer[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-size:12px;color:red;text-align:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignatureUploadComponent, [{
        type: Component,
        args: [{
                selector: 'app-signature-upload',
                templateUrl: './signature-upload.component.html',
                styleUrls: ['./signature-upload.component.scss']
            }]
    }], function () { return [{ type: i1$1.ReferenceLibraryService }, { type: i2$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

function ProfilePictureUploadComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "Please select an image less than 1 mb");
    i0.ɵɵelementEnd();
} }
function ProfilePictureUploadComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "label", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵelement(3, "i", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 15);
    i0.ɵɵelementStart(5, "sup");
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 16);
    i0.ɵɵtext(8, "png,jpg,jpeg format only");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 17);
    i0.ɵɵlistener("change", function ProfilePictureUploadComponent_div_10_Template_input_change_9_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.fileChangeEvent($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ProfilePictureUploadComponent_div_11_div_1_img_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 30);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", ctx_r6.croppedImage, i0.ɵɵsanitizeUrl);
} }
function ProfilePictureUploadComponent_div_11_div_1_button_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵelementStart(1, "span", 26);
    i0.ɵɵtext(2, "Save Photo");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("mat-dialog-close", ctx_r7.croppedImage);
} }
function ProfilePictureUploadComponent_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "image-cropper", 20);
    i0.ɵɵlistener("imageCropped", function ProfilePictureUploadComponent_div_11_div_1_Template_image_cropper_imageCropped_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.imageCropped($event); })("imageLoaded", function ProfilePictureUploadComponent_div_11_div_1_Template_image_cropper_imageLoaded_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.imageLoaded(); })("cropperReady", function ProfilePictureUploadComponent_div_11_div_1_Template_image_cropper_cropperReady_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.cropperReady(); })("loadImageFailed", function ProfilePictureUploadComponent_div_11_div_1_Template_image_cropper_loadImageFailed_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.loadImageFailed(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "input", 21);
    i0.ɵɵlistener("ngModelChange", function ProfilePictureUploadComponent_div_11_div_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.zoom($event); })("ngModelChange", function ProfilePictureUploadComponent_div_11_div_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.zoomVal = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 2);
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵelementStart(5, "i", 23);
    i0.ɵɵlistener("click", function ProfilePictureUploadComponent_div_11_div_1_Template_i_click_5_listener() { i0.ɵɵrestoreView(_r9); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.rotateLeft(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 24);
    i0.ɵɵelementStart(7, "button", 25);
    i0.ɵɵlistener("click", function ProfilePictureUploadComponent_div_11_div_1_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r9); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.resetImage(); });
    i0.ɵɵelementStart(8, "span", 26);
    i0.ɵɵtext(9, "Reset");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 27);
    i0.ɵɵtemplate(11, ProfilePictureUploadComponent_div_11_div_1_img_11_Template, 1, 1, "img", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 27);
    i0.ɵɵtemplate(13, ProfilePictureUploadComponent_div_11_div_1_button_13_Template, 3, 1, "button", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("imageChangedEvent", ctx_r5.imageChangedEvent)("maintainAspectRatio", false)("aspectRatio", 2 / 2)("onlyScaleDown", true)("canvasRotation", ctx_r5.canvasRotation)("transform", ctx_r5.transform)("alignImage", "left")("cropper", ctx_r5.cropper);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r5.zoomVal);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r5.croppedImage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.croppedImage);
} }
function ProfilePictureUploadComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ProfilePictureUploadComponent_div_11_div_1_Template, 14, 11, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showCropperSection);
} }
class ProfilePictureUploadComponent {
    constructor(referenceLibraryService, dialogRef, data) {
        this.referenceLibraryService = referenceLibraryService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.canvasRotation = 0;
        this.rotation = 0;
        this.scale = 1;
        this.showCropper = false;
        this.containWithinAspectRatio = false;
        this.transform = {};
        this.showCropperSection = true;
        this.showFileUploadSection = true;
        this.zoomVal = 1;
        this.original_width = 0;
        this.original_height = 0;
        this.cropper = {
            x1: 0,
            y1: 0,
            x2: 100,
            y2: 100
        }; //initial
    }
    ngOnInit() {
        this.translet();
    }
    onNoClick() {
        this.dialogRef.close();
    }
    uploadProfileImage() {
        this.showCropperSection = false;
    }
    fileChangeEvent(event) {
        this.imageChangedEvent = event;
        this.showFileUploadSection = false;
        //IM-3616
        this.imageSizeLimit = false;
        this.showFileUploadSection = false;
        /* dimension of the image*/
        let imageDimensionPromise = new Promise((resolve, reject) => {
            let reader = new FileReader();
            let result = { width: 0, height: 0 };
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = function (e) {
                let image = new Image();
                image.src = e.target['result'];
                image.onload = function () {
                    result.height = this.height;
                    result.width = this.width;
                    resolve(result);
                };
            };
        });
        imageDimensionPromise.then(result => {
            this.original_height = result['height'];
            this.original_width = result['width'];
        });
        /**/
        let filesize = (event.target.files[0].size / 1024) / 1024;
        if (filesize > 1) {
            this.imageSizeLimit = true;
            this.showFileUploadSection = true;
        }
        this.translet();
    }
    imageCropped(event) {
        this.imageSizeLimit ? this.croppedImage = '' : this.croppedImage = event.base64;
    }
    imageLoaded() {
        // show cropper
        //console.log("image ready");
    }
    cropperReady() { }
    loadImageFailed() {
        // show message
    }
    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }
    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }
    flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = Object.assign(Object.assign({}, this.transform), { flipH: flippedV, flipV: flippedH });
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    flipHorizontal() {
        this.transform = Object.assign(Object.assign({}, this.transform), { flipH: !this.transform.flipH });
    }
    flipVertical() {
        this.transform = Object.assign(Object.assign({}, this.transform), { flipV: !this.transform.flipV });
    }
    resetImage() {
        this.scale = 1;
        this.zoomVal = 0;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
        this.cropper = {
            x1: 0,
            y1: 0,
            x2: this.original_width,
            y2: this.original_height
        };
    }
    zoom(event) {
        if (this.zoomVal > event) {
            this.zoomOut();
        }
        else {
            this.zoomIn();
        }
        this.zoomVal = event; //IM-4239
    }
    zoomOut() {
        this.scale -= .1;
        this.transform = Object.assign(Object.assign({}, this.transform), { scale: this.scale });
    }
    zoomIn() {
        this.scale += .1;
        this.transform = Object.assign(Object.assign({}, this.transform), { scale: this.scale });
    }
    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }
    updateRotation() {
        this.transform = Object.assign(Object.assign({}, this.transform), { rotate: this.rotation });
    }
    imageDimensionDetecion(file) {
    }
}
ProfilePictureUploadComponent.ɵfac = function ProfilePictureUploadComponent_Factory(t) { return new (t || ProfilePictureUploadComponent)(i0.ɵɵdirectiveInject(i1$1.ReferenceLibraryService), i0.ɵɵdirectiveInject(i2$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ProfilePictureUploadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ProfilePictureUploadComponent, selectors: [["app-profile-picture-upload"]], decls: 12, vars: 3, consts: [[1, "modalBoxContainer"], [1, "modelTitleBox"], [1, "row"], [1, "col-11", "common-bene-class-for-translation"], [1, "col-1", "rounded-circle"], [1, "fa", "fa-close", 2, "font-size", "24px", "font-weight", "500", 3, "mat-dialog-close"], [1, "dialogContentBox"], ["class", "error common-bene-class-for-translation", 4, "ngIf"], ["style", "height: 313px;", 4, "ngIf"], [4, "ngIf"], [1, "error", "common-bene-class-for-translation"], [2, "height", "313px"], ["for", "file-input"], [1, "center-icon"], [1, "fa", "fa-cloud-upload", 2, "font-size", "96px", "color", "blue"], [1, "hint"], [1, "hint", "common-bene-class-for-translation"], ["id", "file-input", "type", "file", 1, "hiddenFile", "mt-10", 3, "change"], ["style", "width:100%;height:auto;min-width:200px;", 4, "ngIf"], [2, "width", "100%", "height", "auto", "min-width", "200px"], ["format", "png", 3, "imageChangedEvent", "maintainAspectRatio", "aspectRatio", "onlyScaleDown", "canvasRotation", "transform", "alignImage", "cropper", "imageCropped", "imageLoaded", "cropperReady", "loadImageFailed"], ["type", "range", "id", "customRange1", 1, "custom-range", 3, "ngModel", "ngModelChange"], [1, "col-1"], [1, "fa", "fa-rotate-right", 2, "font-size", "24px", 3, "click"], [1, "col-3"], [1, "btn", "btn-primary", 3, "click"], [1, "common-bene-class-for-translation"], [1, "col-4"], ["class", "rounded-circle small-profile-img", 3, "src", 4, "ngIf"], ["class", "btn btn-primary", 3, "mat-dialog-close", 4, "ngIf"], [1, "rounded-circle", "small-profile-img", 3, "src"], [1, "btn", "btn-primary", 3, "mat-dialog-close"]], template: function ProfilePictureUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h3");
        i0.ɵɵtext(5, "Upload Files");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelement(7, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, ProfilePictureUploadComponent_span_9_Template, 2, 0, "span", 7);
        i0.ɵɵtemplate(10, ProfilePictureUploadComponent_div_10_Template, 10, 0, "div", 8);
        i0.ɵɵtemplate(11, ProfilePictureUploadComponent_div_11_Template, 2, 1, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.imageSizeLimit);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showFileUploadSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showFileUploadSection);
    } }, directives: [i2$1.MatDialogClose, i9.NgIf, i4.ImageCropperComponent, i2$2.RangeValueAccessor, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.NgModel], styles: [".modalBoxContainer[_ngcontent-%COMP%]{padding:10px!important}.modalBoxContainer[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]{display:block!important;font-size:12px;color:red;margin-top:-13px}.modalBoxContainer[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-size:12px;color:red;text-align:center}.modalBoxContainer[_ngcontent-%COMP%]   .mt-10[_ngcontent-%COMP%]{margin-top:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfilePictureUploadComponent, [{
        type: Component,
        args: [{
                selector: 'app-profile-picture-upload',
                templateUrl: './profile-picture-upload.component.html',
                styleUrls: ['./profile-picture-upload.component.scss']
            }]
    }], function () { return [{ type: i1$1.ReferenceLibraryService }, { type: i2$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class ImgDateFormatPipe {
    transform(value) {
        return (value ? moment(value).format('MM/DD/YYYY') : '');
    }
}
ImgDateFormatPipe.ɵfac = function ImgDateFormatPipe_Factory(t) { return new (t || ImgDateFormatPipe)(); };
ImgDateFormatPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "ImgDateFormat", type: ImgDateFormatPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgDateFormatPipe, [{
        type: Pipe,
        args: [{ name: 'ImgDateFormat' }]
    }], null, null); })();

function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 65);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_1_ng_container_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(3); return ctx_r30.handleEdit(); });
    i0.ɵɵelement(2, "i", 66);
    i0.ɵɵelementStart(3, "span", 67);
    i0.ɵɵtext(4, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r29.isEditDisabled);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 64);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_1_ng_container_2_Template, 5, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.viewMode && ctx_r3.showEditButton);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_4_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 76);
    i0.ɵɵelement(2, "img", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r32.profilePic ? ctx_r32.profilePic : "../../../../../assets/cameraIcon.png", i0.ɵɵsanitizeUrl);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_4_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵelement(1, "img", 77);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r34.profilePic ? ctx_r34.profilePic : "../../../../../assets/cameraIcon.png", i0.ɵɵsanitizeUrl);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵelementStart(1, "div", 69);
    i0.ɵɵelementStart(2, "mat-card", 70);
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_4_ng_container_3_Template, 3, 1, "ng-container", 71);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_4_ng_template_4_Template, 2, 1, "ng-template", null, 72, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 73);
    i0.ɵɵelementStart(7, "label", 74);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "label", 74);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "label", 74);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "p", 75);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r33 = i0.ɵɵreference(5);
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r4.viewMode)("ngIfElse", _r33);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.beneficiaryData == null ? null : ctx_r4.beneficiaryData.fName) ? ctx_r4.beneficiaryData == null ? null : ctx_r4.beneficiaryData.fName : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.beneficiaryData == null ? null : ctx_r4.beneficiaryData.mName) ? ctx_r4.beneficiaryData == null ? null : ctx_r4.beneficiaryData.mName : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.beneficiaryData == null ? null : ctx_r4.beneficiaryData.lName) ? ctx_r4.beneficiaryData == null ? null : ctx_r4.beneficiaryData.lName : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r4.beneficiaryData == null ? null : ctx_r4.beneficiaryData.emailContacts[0] == null ? null : ctx_r4.beneficiaryData.emailContacts[0].email) ? ctx_r4.beneficiaryData == null ? null : ctx_r4.beneficiaryData.emailContacts[0] == null ? null : ctx_r4.beneficiaryData.emailContacts[0].email : "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵtext(1, " Missing ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵtext(1, " Missing ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "p", 79);
    i0.ɵɵtext(2, "Social Security Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r7.beneficiaryData == null ? null : ctx_r7.beneficiaryData.ssn) ? ctx_r7.maskify(ctx_r7.beneficiaryData == null ? null : ctx_r7.beneficiaryData.ssn) : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵtext(1, " Missing ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "p", 80);
    i0.ɵɵtext(3, "Are you a Lawful Permanent Resident?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 21);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r9.beneficiaryData == null ? null : ctx_r9.beneficiaryData.isLpr) ? "Yes" : "No");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_68_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r10.beneficiaryData == null ? null : ctx_r10.beneficiaryData.birthStateProvinceCode) ? ctx_r10.getStateName(ctx_r10.beneficiaryData == null ? null : ctx_r10.beneficiaryData.birthStateProvinceCode, "Birth") : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_69_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r11.beneficiaryData == null ? null : ctx_r11.beneficiaryData.birthStateProvinceName) ? ctx_r11.beneficiaryData == null ? null : ctx_r11.beneficiaryData.birthStateProvinceName : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_120_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r12.beneficiaryData == null ? null : ctx_r12.beneficiaryData.address[0] == null ? null : ctx_r12.beneficiaryData.address[0].stateProvinceCode) ? ctx_r12.getStateName(ctx_r12.beneficiaryData == null ? null : ctx_r12.beneficiaryData.address[0] == null ? null : ctx_r12.beneficiaryData.address[0].stateProvinceCode, "Current") : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_121_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r13.beneficiaryData == null ? null : ctx_r13.beneficiaryData.address[0] == null ? null : ctx_r13.beneficiaryData.address[0].stateProvinceName) ? ctx_r13.beneficiaryData == null ? null : ctx_r13.beneficiaryData.address[0] == null ? null : ctx_r13.beneficiaryData.address[0].stateProvinceName : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_175_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r14.beneficiaryData == null ? null : ctx_r14.beneficiaryData.address[1] == null ? null : ctx_r14.beneficiaryData.address[1].stateProvinceCode) ? ctx_r14.getStateName(ctx_r14.beneficiaryData == null ? null : ctx_r14.beneficiaryData.address[1] == null ? null : ctx_r14.beneficiaryData.address[1].stateProvinceCode, "Mailing") : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_176_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r15.beneficiaryData == null ? null : ctx_r15.beneficiaryData.address[1] == null ? null : ctx_r15.beneficiaryData.address[1].stateProvinceName) ? ctx_r15.beneficiaryData == null ? null : ctx_r15.beneficiaryData.address[1] == null ? null : ctx_r15.beneficiaryData.address[1].stateProvinceName : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_198_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "h5", 81);
    i0.ɵɵtext(2, "Passport Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 82);
    i0.ɵɵelementStart(4, "p", 83);
    i0.ɵɵtext(5, "Passport No.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "label", 9);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 82);
    i0.ɵɵelementStart(9, "p", 84);
    i0.ɵɵtext(10, "Issuing Authority");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "label", 9);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 82);
    i0.ɵɵelementStart(14, "p", 85);
    i0.ɵɵtext(15, "Date of Issue");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "label", 9);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 82);
    i0.ɵɵelementStart(20, "p", 86);
    i0.ɵɵtext(21, "Date of Expiry");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "label", 9);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate((ctx_r16.beneficiaryData == null ? null : ctx_r16.beneficiaryData.passport[0] == null ? null : ctx_r16.beneficiaryData.passport[0].passportNo) ? ctx_r16.beneficiaryData == null ? null : ctx_r16.beneficiaryData.passport[0] == null ? null : ctx_r16.beneficiaryData.passport[0].passportNo : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r16.beneficiaryData == null ? null : ctx_r16.beneficiaryData.passport[0] == null ? null : ctx_r16.beneficiaryData.passport[0].issueCountryCode == null ? null : ctx_r16.beneficiaryData.passport[0].issueCountryCode.countryName) ? ctx_r16.beneficiaryData == null ? null : ctx_r16.beneficiaryData.passport[0] == null ? null : ctx_r16.beneficiaryData.passport[0].issueCountryCode == null ? null : ctx_r16.beneficiaryData.passport[0].issueCountryCode.countryName : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r16.datesStoredArrayForDisplay["issueDate"] ? i0.ɵɵpipeBind1(18, 4, ctx_r16.datesStoredArrayForDisplay["issueDate"]) : "--");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r16.datesStoredArrayForDisplay["expiryDate"] ? i0.ɵɵpipeBind1(24, 6, ctx_r16.datesStoredArrayForDisplay["expiryDate"]) : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_ng_container_199_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 89);
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", ctx_r35.signatureImage, i0.ɵɵsanitizeUrl);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_ng_container_199_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h5", 32);
    i0.ɵɵtext(2, "Signature");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 87);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_ng_container_199_img_4_Template, 1, 1, "img", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !!ctx_r17.signatureImage);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "lib-custom-questionnaire", 93);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isNewPortion", false)("viewQuestions", true)("loadedIn", "Personal Details")("beneficiaryId", ctx_r41.beneficiaryId)("isSection", true)("familyId", ctx_r41.currentFamilyId);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_div_1_div_1_div_1_div_1_Template, 2, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r40 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r40 == null ? null : item_r40.key) == "QTPROFILEBEN" && item_r40.selected == true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_div_1_div_1_div_1_Template, 2, 1, "div", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r37 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ques_r37.stakeHoldersSelected);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_div_1_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r37 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ques_r37.name == "Personal Details");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_div_1_Template, 2, 1, "div", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r18.customQuestions == null ? null : ctx_r18.customQuestions.sectionList);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "lib-custom-questionnaire", 93);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isNewPortion", false)("viewQuestions", true)("loadedIn", "Personal Details")("beneficiaryId", ctx_r48.beneficiaryId)("isSection", true)("familyId", ctx_r48.currentFamilyId);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_div_1_div_1_div_1_div_1_Template, 2, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r47 = ctx.$implicit;
    const ctx_r46 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r46.detailsAbout == null ? null : ctx_r46.detailsAbout.dependentType == null ? null : ctx_r46.detailsAbout.dependentType.code) == item_r47.key && item_r47.selected == true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_div_1_div_1_div_1_Template, 2, 1, "div", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r44 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ques_r44.stakeHoldersSelected);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_div_1_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r44 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ques_r44.name == "Personal Details");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 94);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_div_1_Template, 2, 1, "div", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r19.customQuestions == null ? null : ctx_r19.customQuestions.sectionList);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_233_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r20.beneficiaryData == null ? null : ctx_r20.beneficiaryData.address[2] == null ? null : ctx_r20.beneficiaryData.address[2].stateProvinceCode) ? ctx_r20.getStateName(ctx_r20.beneficiaryData == null ? null : ctx_r20.beneficiaryData.address[2] == null ? null : ctx_r20.beneficiaryData.address[2].stateProvinceCode, "Foreign") : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_234_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r21.beneficiaryData == null ? null : ctx_r21.beneficiaryData.address[2] == null ? null : ctx_r21.beneficiaryData.address[2].stateProvinceName) ? ctx_r21.beneficiaryData == null ? null : ctx_r21.beneficiaryData.address[2] == null ? null : ctx_r21.beneficiaryData.address[2].stateProvinceName : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_271_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r22.beneficiaryData == null ? null : ctx_r22.beneficiaryData.address[3] == null ? null : ctx_r22.beneficiaryData.address[3].stateProvinceCode) ? ctx_r22.getStateName(ctx_r22.beneficiaryData == null ? null : ctx_r22.beneficiaryData.address[3] == null ? null : ctx_r22.beneficiaryData.address[3].stateProvinceCode, "Permanent") : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_272_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((ctx_r23.beneficiaryData == null ? null : ctx_r23.beneficiaryData.address[3] == null ? null : ctx_r23.beneficiaryData.address[3].stateProvinceName) ? ctx_r23.beneficiaryData == null ? null : ctx_r23.beneficiaryData.address[3] == null ? null : ctx_r23.beneficiaryData.address[3].stateProvinceName : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_h5_283_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 95);
    i0.ɵɵtext(1, "Biographic Information");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_284_label_9_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_284_label_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_284_label_9_span_3_Template, 2, 0, "span", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r52 = ctx.$implicit;
    const last_r53 = ctx.last;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i_r52 == null ? null : i_r52.raceId == null ? null : i_r52.raceId.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !last_r53);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_284_small_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 103);
    i0.ɵɵtext(1, "Pounds");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_284_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "p", 96);
    i0.ɵɵtext(3, "Ethnicity");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵelementStart(7, "p", 97);
    i0.ɵɵtext(8, "Race");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_284_label_9_Template, 4, 2, "label", 98);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 7);
    i0.ɵɵelementStart(11, "p", 99);
    i0.ɵɵtext(12, "Hair Color");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "label", 9);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 7);
    i0.ɵɵelementStart(16, "p", 100);
    i0.ɵɵtext(17, "Eyes Color");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "label", 9);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 7);
    i0.ɵɵelementStart(21, "p", 101);
    i0.ɵɵtext(22, "Weight");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "label", 9);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_284_small_25_Template, 2, 0, "small", 102);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.ethnicity == null ? null : ctx_r25.beneficiaryData.ethnicity.name) ? ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.ethnicity == null ? null : ctx_r25.beneficiaryData.ethnicity.name : "--");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.race);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.hairColor) ? ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.hairColor : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.eyeColor) ? ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.eyeColor : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.weight) ? ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.weight : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.beneficiaryData == null ? null : ctx_r25.beneficiaryData.weight);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_285_small_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 107);
    i0.ɵɵtext(1, "Inches");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_285_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "p", 104);
    i0.ɵɵtext(3, "Height");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_285_small_6_Template, 2, 0, "small", 105);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵelementStart(8, "p", 106);
    i0.ɵɵtext(9, "Marks of identification ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "label", 9);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", (ctx_r26.beneficiaryData == null ? null : ctx_r26.beneficiaryData.height) ? ctx_r26.beneficiaryData == null ? null : ctx_r26.beneficiaryData.height : "--", " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.beneficiaryData == null ? null : ctx_r26.beneficiaryData.height);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r26.beneficiaryData == null ? null : ctx_r26.beneficiaryData.identificationMark) ? ctx_r26.beneficiaryData == null ? null : ctx_r26.beneficiaryData.identificationMark : "--");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_h5_286_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 108);
    i0.ɵɵtext(1, "Additional Info");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_button_295_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 109);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_button_295_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(2); return ctx_r56.handleVerify(); });
    i0.ɵɵelementStart(1, "span", 67);
    i0.ɵɵtext(2, "VERIFY");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r28.isEditDisabled);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_1_Template, 3, 1, "div", 3);
    i0.ɵɵelementStart(2, "h5", 4);
    i0.ɵɵtext(3, "About");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_4_Template, 15, 6, "div", 5);
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵelementStart(7, "p", 8);
    i0.ɵɵtext(8, "User Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "label", 9);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 7);
    i0.ɵɵelementStart(12, "p", 10);
    i0.ɵɵtext(13, "First Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "label", 9);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_16_Template, 2, 0, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 7);
    i0.ɵɵelementStart(18, "p", 12);
    i0.ɵɵtext(19, "Middle Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "label", 9);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 7);
    i0.ɵɵelementStart(23, "p", 13);
    i0.ɵɵtext(24, "Last Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "label", 9);
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_27_Template, 2, 0, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 7);
    i0.ɵɵelementStart(29, "p", 14);
    i0.ɵɵtext(30, "Date of Birth");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "label", 9);
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 7);
    i0.ɵɵelementStart(35, "p", 15);
    i0.ɵɵtext(36, "Gender");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "label", 9);
    i0.ɵɵtext(38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 7);
    i0.ɵɵelementStart(40, "p", 16);
    i0.ɵɵtext(41, "Country Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "label", 9);
    i0.ɵɵtext(43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 7);
    i0.ɵɵelementStart(45, "p", 17);
    i0.ɵɵtext(46, "Mobile No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "label", 9);
    i0.ɵɵtext(48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(49, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_49_Template, 5, 1, "div", 18);
    i0.ɵɵelementStart(50, "div", 19);
    i0.ɵɵelementStart(51, "p", 20);
    i0.ɵɵtext(52, "Email Id");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "label", 21);
    i0.ɵɵtext(54);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(55, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_55_Template, 2, 0, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(56, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_56_Template, 6, 1, "div", 3);
    i0.ɵɵelementStart(57, "h5", 22);
    i0.ɵɵtext(58, "Place of Birth");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 6);
    i0.ɵɵelementStart(60, "div", 7);
    i0.ɵɵelementStart(61, "p", 23);
    i0.ɵɵtext(62, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(63, "label", 9);
    i0.ɵɵtext(64);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(65, "div", 7);
    i0.ɵɵelementStart(66, "p", 24);
    i0.ɵɵtext(67, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(68, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_68_Template, 2, 1, "label", 25);
    i0.ɵɵtemplate(69, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_69_Template, 2, 1, "label", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(70, "div", 7);
    i0.ɵɵelementStart(71, "p", 26);
    i0.ɵɵtext(72, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(73, "label", 9);
    i0.ɵɵtext(74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "div", 7);
    i0.ɵɵelementStart(76, "p", 27);
    i0.ɵɵtext(77, "Citizenship");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "label", 9);
    i0.ɵɵtext(79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(80, "h5", 28);
    i0.ɵɵtext(81, "Marital Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(82, "div", 29);
    i0.ɵɵelementStart(83, "div", 30);
    i0.ɵɵelementStart(84, "p", 31);
    i0.ɵɵtext(85, "What is your current marital status?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(86, "label", 21);
    i0.ɵɵtext(87);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(88, "h5", 32);
    i0.ɵɵtext(89, "Physical Address Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(90, "div", 6);
    i0.ɵɵelementStart(91, "div", 33);
    i0.ɵɵelementStart(92, "p", 34);
    i0.ɵɵtext(93, "Care Of");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(94, "label", 9);
    i0.ɵɵtext(95);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(96, "div", 6);
    i0.ɵɵelementStart(97, "div", 33);
    i0.ɵɵelementStart(98, "p", 34);
    i0.ɵɵtext(99, "Address 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(100, "label", 9);
    i0.ɵɵtext(101);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(102, "div", 33);
    i0.ɵɵelementStart(103, "p", 34);
    i0.ɵɵtext(104, "Address 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(105, "label", 9);
    i0.ɵɵtext(106);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(107, "div", 7);
    i0.ɵɵelementStart(108, "p", 34);
    i0.ɵɵtext(109, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(110, "label", 9);
    i0.ɵɵtext(111);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(112, "div", 7);
    i0.ɵɵelementStart(113, "p", 34);
    i0.ɵɵtext(114, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(115, "label", 9);
    i0.ɵɵtext(116);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(117, "div", 7);
    i0.ɵɵelementStart(118, "p", 34);
    i0.ɵɵtext(119, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(120, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_120_Template, 2, 1, "label", 25);
    i0.ɵɵtemplate(121, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_121_Template, 2, 1, "label", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(122, "div", 7);
    i0.ɵɵelementStart(123, "p", 34);
    i0.ɵɵtext(124, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(125, "label", 9);
    i0.ɵɵtext(126);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(127, "div", 7);
    i0.ɵɵelementStart(128, "p", 34);
    i0.ɵɵtext(129, "Zip / Postal code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(130, "label", 9);
    i0.ɵɵtext(131);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(132, "div", 7);
    i0.ɵɵelementStart(133, "p", 34);
    i0.ɵɵtext(134, "County");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(135, "label", 9);
    i0.ɵɵtext(136);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(137, "div", 7);
    i0.ɵɵelementStart(138, "p", 34);
    i0.ɵɵtext(139, "Effective Date From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(140, "label", 9);
    i0.ɵɵtext(141);
    i0.ɵɵpipe(142, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(143, "h5", 35);
    i0.ɵɵtext(144, "Mailing Address Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(145, "div", 6);
    i0.ɵɵelementStart(146, "div", 33);
    i0.ɵɵelementStart(147, "p", 34);
    i0.ɵɵtext(148, "Care Of");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(149, "label", 9);
    i0.ɵɵtext(150);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(151, "div", 6);
    i0.ɵɵelementStart(152, "div", 33);
    i0.ɵɵelementStart(153, "p", 36);
    i0.ɵɵtext(154, "Address 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(155, "label", 9);
    i0.ɵɵtext(156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(157, "div", 33);
    i0.ɵɵelementStart(158, "p", 37);
    i0.ɵɵtext(159, "Address 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(160, "label", 9);
    i0.ɵɵtext(161);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(162, "div", 7);
    i0.ɵɵelementStart(163, "p", 38);
    i0.ɵɵtext(164, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(165, "label", 9);
    i0.ɵɵtext(166);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(167, "div", 7);
    i0.ɵɵelementStart(168, "p", 39);
    i0.ɵɵtext(169, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(170, "label", 9);
    i0.ɵɵtext(171);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(172, "div", 7);
    i0.ɵɵelementStart(173, "p", 40);
    i0.ɵɵtext(174, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(175, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_175_Template, 2, 1, "label", 25);
    i0.ɵɵtemplate(176, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_176_Template, 2, 1, "label", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(177, "div", 7);
    i0.ɵɵelementStart(178, "p", 41);
    i0.ɵɵtext(179, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(180, "label", 9);
    i0.ɵɵtext(181);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(182, "div", 7);
    i0.ɵɵelementStart(183, "p", 42);
    i0.ɵɵtext(184, "Zip / Postal code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(185, "label", 9);
    i0.ɵɵtext(186);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(187, "div", 7);
    i0.ɵɵelementStart(188, "p", 34);
    i0.ɵɵtext(189, "County");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(190, "label", 9);
    i0.ɵɵtext(191);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(192, "div", 7);
    i0.ɵɵelementStart(193, "p", 34);
    i0.ɵɵtext(194, "Effective Date From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(195, "label", 9);
    i0.ɵɵtext(196);
    i0.ɵɵpipe(197, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(198, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_198_Template, 25, 8, "div", 43);
    i0.ɵɵtemplate(199, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_ng_container_199_Template, 5, 1, "ng-container", 0);
    i0.ɵɵtemplate(200, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_200_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(201, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_201_Template, 2, 1, "div", 44);
    i0.ɵɵelementStart(202, "p-accordion", 45);
    i0.ɵɵelementStart(203, "p-accordionTab", 46);
    i0.ɵɵelementStart(204, "p-header");
    i0.ɵɵelementStart(205, "span", 47);
    i0.ɵɵtext(206, "Advanced Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(207, "h5", 48);
    i0.ɵɵtext(208, "Foreign Address Details ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(209, "div", 6);
    i0.ɵɵelementStart(210, "div", 33);
    i0.ɵɵelementStart(211, "p", 49);
    i0.ɵɵtext(212, "Address 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(213, "label", 9);
    i0.ɵɵtext(214);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(215, "div", 33);
    i0.ɵɵelementStart(216, "p", 50);
    i0.ɵɵtext(217, "Address 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(218, "label", 9);
    i0.ɵɵtext(219);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(220, "div", 7);
    i0.ɵɵelementStart(221, "p", 51);
    i0.ɵɵtext(222, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(223, "label", 9);
    i0.ɵɵtext(224);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(225, "div", 7);
    i0.ɵɵelementStart(226, "p", 52);
    i0.ɵɵtext(227, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(228, "label", 9);
    i0.ɵɵtext(229);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(230, "div", 7);
    i0.ɵɵelementStart(231, "p", 53);
    i0.ɵɵtext(232, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(233, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_233_Template, 2, 1, "label", 54);
    i0.ɵɵtemplate(234, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_234_Template, 2, 1, "label", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(235, "div", 7);
    i0.ɵɵelementStart(236, "p", 55);
    i0.ɵɵtext(237, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(238, "label", 9);
    i0.ɵɵtext(239);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(240, "div", 7);
    i0.ɵɵelementStart(241, "p", 56);
    i0.ɵɵtext(242, "Zip / Postal code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(243, "label", 9);
    i0.ɵɵtext(244);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(245, "h5", 32);
    i0.ɵɵtext(246, "Permanent Address Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(247, "div", 6);
    i0.ɵɵelementStart(248, "div", 33);
    i0.ɵɵelementStart(249, "p", 34);
    i0.ɵɵtext(250, "Address 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(251, "label", 9);
    i0.ɵɵtext(252);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(253, "div", 33);
    i0.ɵɵelementStart(254, "p", 34);
    i0.ɵɵtext(255, "Address 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(256, "label", 9);
    i0.ɵɵtext(257);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(258, "div", 7);
    i0.ɵɵelementStart(259, "p", 34);
    i0.ɵɵtext(260, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(261, "label", 9);
    i0.ɵɵtext(262);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(263, "div", 7);
    i0.ɵɵelementStart(264, "p", 34);
    i0.ɵɵtext(265, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(266, "label", 9);
    i0.ɵɵtext(267);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(268, "div", 7);
    i0.ɵɵelementStart(269, "p", 34);
    i0.ɵɵtext(270, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(271, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_271_Template, 2, 1, "label", 25);
    i0.ɵɵtemplate(272, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_label_272_Template, 2, 1, "label", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(273, "div", 7);
    i0.ɵɵelementStart(274, "p", 34);
    i0.ɵɵtext(275, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(276, "label", 9);
    i0.ɵɵtext(277);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(278, "div", 7);
    i0.ɵɵelementStart(279, "p", 34);
    i0.ɵɵtext(280, "Zip / Postal code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(281, "label", 9);
    i0.ɵɵtext(282);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(283, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_h5_283_Template, 2, 0, "h5", 57);
    i0.ɵɵtemplate(284, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_284_Template, 26, 6, "div", 43);
    i0.ɵɵtemplate(285, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_div_285_Template, 12, 3, "div", 43);
    i0.ɵɵtemplate(286, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_h5_286_Template, 2, 0, "h5", 58);
    i0.ɵɵelementStart(287, "div", 59);
    i0.ɵɵelementStart(288, "div", 60);
    i0.ɵɵelementStart(289, "p", 61);
    i0.ɵɵtext(290, "Visa Sponsor");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(291, "label", 9);
    i0.ɵɵtext(292);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(293, "div", 29);
    i0.ɵɵelementStart(294, "div", 62);
    i0.ɵɵtemplate(295, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_button_295_Template, 3, 1, "button", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isExternalEmployeeId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.isShowProfilePic);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.userName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.userName : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.fName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.fName : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!ctx_r0.beneficiaryData || (ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.fName == null ? null : ctx_r0.beneficiaryData.fName.length) <= 0) && (ctx_r0.requiredFields == null ? null : ctx_r0.requiredFields.fName));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.mName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.mName : "--", "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.lName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.lName : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!ctx_r0.beneficiaryData || (ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.lName == null ? null : ctx_r0.beneficiaryData.lName.length) <= 0) && (ctx_r0.requiredFields == null ? null : ctx_r0.requiredFields.lName));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.datesStoredArrayForDisplay["dob"] ? i0.ɵɵpipeBind1(33, 72, ctx_r0.datesStoredArrayForDisplay["dob"]) : "--");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.gender == null ? null : ctx_r0.beneficiaryData.gender.name) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.gender == null ? null : ctx_r0.beneficiaryData.gender.name : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2("", (ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.phoneContacts[0] == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].countryCode == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].countryCode.countryCode) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.phoneContacts[0] == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].countryCode == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].countryCode.countryCode : "--", " - ", (ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.phoneContacts[0] == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].countryCode == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].countryCode.phoneCode) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.phoneContacts[0] == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].countryCode == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].countryCode.phoneCode : "--", "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.phoneContacts[0] == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].phoneNo) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.phoneContacts[0] == null ? null : ctx_r0.beneficiaryData.phoneContacts[0].phoneNo : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.emailContacts[0] == null ? null : ctx_r0.beneficiaryData.emailContacts[0].email) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.emailContacts[0] == null ? null : ctx_r0.beneficiaryData.emailContacts[0].email : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!ctx_r0.beneficiaryData || (ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.emailContacts[0] == null ? null : ctx_r0.beneficiaryData.emailContacts[0].email.length) <= 0) && (ctx_r0.requiredFields == null ? null : ctx_r0.requiredFields.email));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.countryCode) ? (ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.countryCode == null ? null : ctx_r0.beneficiaryData.countryCode.countryName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.countryCode == null ? null : ctx_r0.beneficiaryData.countryCode.countryName : "--" : "--");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesBirth.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesBirth.length <= 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.birthCity) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.birthCity : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.ctznshipCountryCode == null ? null : ctx_r0.beneficiaryData.ctznshipCountryCode.countryName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.ctznshipCountryCode == null ? null : ctx_r0.beneficiaryData.ctznshipCountryCode.countryName : "--");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.maritalStatus == null ? null : ctx_r0.beneficiaryData.maritalStatus.name);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].inCareOfName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].inCareOfName : "--");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].addressLine1) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].addressLine1 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].addressLine2) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].addressLine2 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].locality) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].locality : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].countryCode == null ? null : ctx_r0.beneficiaryData.address[0].countryCode.countryName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].countryCode == null ? null : ctx_r0.beneficiaryData.address[0].countryCode.countryName : "--");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesCurrent.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesCurrent.length <= 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].city) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].city : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].postCode) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].postCode : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].county) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].county : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].dateRangeFrom) ? i0.ɵɵpipeBind2(142, 74, ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[0] == null ? null : ctx_r0.beneficiaryData.address[0].dateRangeFrom, "MM/dd/yyyy") : "--");
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].inCareOfName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].inCareOfName : "--");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].addressLine1) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].addressLine1 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].addressLine2) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].addressLine2 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].locality) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].locality : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].countryCode == null ? null : ctx_r0.beneficiaryData.address[1].countryCode.countryName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].countryCode == null ? null : ctx_r0.beneficiaryData.address[1].countryCode.countryName : "--");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesMailing.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesMailing.length <= 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].city) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].city : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].postCode) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].postCode : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].county) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].county : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].dateRangeFrom) ? i0.ɵɵpipeBind2(197, 77, ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[1] == null ? null : ctx_r0.beneficiaryData.address[1].dateRangeFrom, "MM/dd/yyyy") : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.onlyFormBuilder !== "FB" && (ctx_r0.beneficiaryData && ctx_r0.beneficiaryData.id > 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.detailsAbout.showDetailFor == "self");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.detailsAbout.showDetailFor !== "self");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selected", false);
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].addressLine1) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].addressLine1 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].addressLine2) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].addressLine2 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].locality) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].locality : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].countryCode == null ? null : ctx_r0.beneficiaryData.address[2].countryCode.countryName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].countryCode == null ? null : ctx_r0.beneficiaryData.address[2].countryCode.countryName : "--");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesForeign.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesForeign.length <= 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].city) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].city : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].postCode) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[2] == null ? null : ctx_r0.beneficiaryData.address[2].postCode : "--");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].addressLine1) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].addressLine1 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].addressLine2) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].addressLine2 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].locality) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].locality : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].countryCode == null ? null : ctx_r0.beneficiaryData.address[3].countryCode.countryName) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].countryCode == null ? null : ctx_r0.beneficiaryData.address[3].countryCode.countryName : "--");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesPermanent.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStatesPermanent.length <= 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].city) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].city : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].postCode) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.address[3] == null ? null : ctx_r0.beneficiaryData.address[3].postCode : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", (ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.visaSponsor) ? ctx_r0.beneficiaryData == null ? null : ctx_r0.beneficiaryData.visaSponsor : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.editDetails && ctx_r0.isShowVerify);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 149);
    i0.ɵɵelement(2, "i", 145);
    i0.ɵɵelementStart(3, "span", 67);
    i0.ɵɵtext(4, " Save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 64);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_2_ng_container_2_Template, 5, 0, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r61.viewMode && ctx_r61.showEditButton);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r112 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 76);
    i0.ɵɵelementStart(2, "img", 150);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_ng_container_3_Template_img_click_2_listener() { i0.ɵɵrestoreView(_r112); const ctx_r111 = i0.ɵɵnextContext(4); return ctx_r111.uploadProfile(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 151);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_ng_container_3_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r112); const ctx_r113 = i0.ɵɵnextContext(4); return ctx_r113.uploadProfile(); });
    i0.ɵɵtext(4, "upload_file");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r108 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r108.profilePic ? ctx_r108.profilePic : "../../../../../assets/cameraIcon.png", i0.ɵɵsanitizeUrl);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r115 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵelement(1, "img", 77);
    i0.ɵɵelementStart(2, "span", 151);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_ng_template_4_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r115); const ctx_r114 = i0.ɵɵnextContext(4); return ctx_r114.uploadProfile(); });
    i0.ɵɵtext(3, "upload_file");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r110.profilePic ? ctx_r110.profilePic : "../../../../../assets/cameraIcon.png", i0.ɵɵsanitizeUrl);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵelementStart(1, "div", 69);
    i0.ɵɵelementStart(2, "mat-card", 70);
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_ng_container_3_Template, 5, 1, "ng-container", 71);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_ng_template_4_Template, 4, 1, "ng-template", null, 72, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 73);
    i0.ɵɵelementStart(7, "label", 74);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "label", 74);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "label", 74);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "p", 75);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r109 = i0.ɵɵreference(5);
    const ctx_r62 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r62.viewMode)("ngIfElse", _r109);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r62.beneficiaryData == null ? null : ctx_r62.beneficiaryData.fName) ? ctx_r62.beneficiaryData == null ? null : ctx_r62.beneficiaryData.fName : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (ctx_r62.beneficiaryData == null ? null : ctx_r62.beneficiaryData.mName) ? ctx_r62.beneficiaryData == null ? null : ctx_r62.beneficiaryData.mName : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (ctx_r62.beneficiaryData == null ? null : ctx_r62.beneficiaryData.lName) ? ctx_r62.beneficiaryData == null ? null : ctx_r62.beneficiaryData.lName : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r62.beneficiaryData == null ? null : ctx_r62.beneficiaryData.emailContacts[0] == null ? null : ctx_r62.beneficiaryData.emailContacts[0].email) ? ctx_r62.beneficiaryData == null ? null : ctx_r62.beneficiaryData.emailContacts[0] == null ? null : ctx_r62.beneficiaryData.emailContacts[0].email : "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_11_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r117 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r117.name, " ");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_11_ng_template_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 156);
    i0.ɵɵtext(1, "Select Title");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_11_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_11_ng_template_4_ng_container_0_Template, 2, 1, "ng-container", 71);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_11_ng_template_4_ng_template_1_Template, 2, 0, "ng-template", null, 155, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const item_r117 = ctx.$implicit;
    const _r119 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngIf", item_r117.code)("ngIfElse", _r119);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵelementStart(1, "p", 152);
    i0.ɵɵtext(2, "Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 153);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_11_ng_template_4_Template, 3, 2, "ng-template", 154);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r63.listTitle);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 161);
    i0.ɵɵtext(1, "First Name");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r122 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("required", ctx_r122.beneficiaryType === "self");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 161);
    i0.ɵɵtext(1, "First Name");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 163);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r124 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r124.getGlobalErrorMessages("REQUIRED"));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 164);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r125 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r125.getGlobalErrorMessages("ALPHABETS_SPLCHARS"), "");
} }
const _c0 = function (a0) { return { "im-input-error": a0 }; };
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_p_1_Template, 2, 2, "p", 157);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_p_2_Template, 2, 0, "p", 158);
    i0.ɵɵelement(3, "input", 159);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_span_4_Template, 3, 1, "span", 160);
    i0.ɵɵtemplate(5, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_span_5_Template, 3, 1, "span", 160);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r64.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r64.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0, (ctx_r64.beneSelfDetailsForm.get("fName").touched || ctx_r64.submitted) && (ctx_r64.beneSelfDetailsForm.get("fName").errors == null ? null : ctx_r64.beneSelfDetailsForm.get("fName").errors.required) && !ctx_r64.iscaseRequest));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r64.beneSelfDetailsForm.get("fName").touched || ctx_r64.submitted) && (ctx_r64.beneSelfDetailsForm.get("fName").errors == null ? null : ctx_r64.beneSelfDetailsForm.get("fName").errors.required) && !ctx_r64.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r64.beneSelfDetailsForm.get("fName").touched || ctx_r64.submitted) && (ctx_r64.beneSelfDetailsForm.get("fName").errors == null ? null : ctx_r64.beneSelfDetailsForm.get("fName").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_13_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 167);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r126 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r126.getGlobalErrorMessages("ALPHABETS_SPLCHARS"), "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵelementStart(1, "p", 165);
    i0.ɵɵtext(2, "Middle Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 166);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_13_span_4_Template, 3, 1, "span", 160);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r65 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, (ctx_r65.beneSelfDetailsForm.get("mName").touched || ctx_r65.submitted) && (ctx_r65.beneSelfDetailsForm.get("mName").errors == null ? null : ctx_r65.beneSelfDetailsForm.get("mName").errors.pattern)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r65.beneSelfDetailsForm.get("mName").touched || ctx_r65.submitted) && (ctx_r65.beneSelfDetailsForm.get("mName").errors == null ? null : ctx_r65.beneSelfDetailsForm.get("mName").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 171);
    i0.ɵɵtext(1, "Last Name");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r127 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("required", ctx_r127.beneficiaryType === "self");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 171);
    i0.ɵɵtext(1, "Last Name");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 172);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r129 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r129.getGlobalErrorMessages("REQUIRED"), "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 173);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r130 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r130.getGlobalErrorMessages("ALPHABETS_SPLCHARS"), "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_p_1_Template, 2, 2, "p", 168);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_p_2_Template, 2, 0, "p", 169);
    i0.ɵɵelement(3, "input", 170);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_span_4_Template, 3, 1, "span", 160);
    i0.ɵɵtemplate(5, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_span_5_Template, 3, 1, "span", 160);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r66.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r66.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0, (ctx_r66.beneSelfDetailsForm.get("lName").touched || ctx_r66.submitted) && (ctx_r66.beneSelfDetailsForm.get("lName").errors == null ? null : ctx_r66.beneSelfDetailsForm.get("lName").errors.required) && !ctx_r66.iscaseRequest));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r66.beneSelfDetailsForm.get("lName").touched || ctx_r66.submitted) && (ctx_r66.beneSelfDetailsForm.get("lName").errors == null ? null : ctx_r66.beneSelfDetailsForm.get("lName").errors.required) && !ctx_r66.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r66.beneSelfDetailsForm.get("lName").touched || ctx_r66.submitted) && (ctx_r66.beneSelfDetailsForm.get("lName").errors == null ? null : ctx_r66.beneSelfDetailsForm.get("lName").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r134 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "mat-checkbox", 176);
    i0.ɵɵlistener("change", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_div_1_Template_mat_checkbox_change_1_listener($event) { i0.ɵɵrestoreView(_r134); const ctx_r133 = i0.ɵɵnextContext(4); return ctx_r133.toggleAlias($event); });
    i0.ɵɵelementStart(2, "span", 177);
    i0.ɵɵtext(3, "Do you have any other name?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r131 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r131.showAliasName);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_div_2_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 187);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const title_r136 = ctx.$implicit;
    i0.ɵɵproperty("value", title_r136.name);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", title_r136.name, " ");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 178);
    i0.ɵɵelementStart(1, "div", 179);
    i0.ɵɵelementStart(2, "div", 180);
    i0.ɵɵelementStart(3, "mat-form-field");
    i0.ɵɵelementStart(4, "p", 181);
    i0.ɵɵtext(5, "Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "mat-select", 182);
    i0.ɵɵtemplate(7, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_div_2_mat_option_7_Template, 2, 2, "mat-option", 183);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 184);
    i0.ɵɵelementStart(9, "p", 185);
    i0.ɵɵtext(10, "Alias Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "input", 186);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r132 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r132.listTitle);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_div_1_Template, 4, 1, "div", 174);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_div_2_Template, 12, 1, "div", 175);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r67.editDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r67.showAliasName);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 188);
    i0.ɵɵelementStart(1, "p", 189);
    i0.ɵɵtext(2, "Gender");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 190);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r68.listGender);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r139 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵelementStart(1, "p", 191);
    i0.ɵɵtext(2, "Date of Birth");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 192);
    i0.ɵɵelementStart(4, "input", 193);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_18_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r139); const _r137 = i0.ɵɵreference(7); return _r137.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker-toggle", 194);
    i0.ɵɵelement(6, "mat-datepicker", null, 195);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r137 = i0.ɵɵreference(7);
    const ctx_r69 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("max", ctx_r69.currentDate)("matDatepicker", _r137);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r137);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_ng_container_2_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 206);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r143 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r143.getGlobalErrorMessages("INVALID_NUMBER"), "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_ng_container_2_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 207);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r144 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r144.getGlobalErrorMessages("MAXLENGTH") + "10", "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_ng_container_2_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 208);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r145 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r145.getGlobalErrorMessages("MINLENGTH") + "10 Numbers", "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 198);
    i0.ɵɵelementStart(2, "div", 199);
    i0.ɵɵelementStart(3, "p", 200);
    i0.ɵɵtext(4, "Country Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "p-dropdown", 201);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 196);
    i0.ɵɵelementStart(7, "p", 202);
    i0.ɵɵelementStart(8, "span", 203);
    i0.ɵɵtext(9, "Mobile No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "small", 204);
    i0.ɵɵtext(11, " (10 digits)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 205);
    i0.ɵɵtemplate(13, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_ng_container_2_span_13_Template, 3, 1, "span", 160);
    i0.ɵɵtemplate(14, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_ng_container_2_span_14_Template, 3, 1, "span", 160);
    i0.ɵɵtemplate(15, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_ng_container_2_span_15_Template, 3, 1, "span", 160);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const x_r141 = ctx.$implicit;
    const i_r142 = ctx.index;
    const ctx_r140 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r142);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r140.listCountryCode)("filter", true);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, (x_r141.get("phoneNo").touched || ctx_r140.submitted) && x_r141.get("phoneNo").hasError("pattern") || (x_r141.get("phoneNo").touched || ctx_r140.submitted) && !ctx_r140.iscaseRequest));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (x_r141.get("phoneNo").touched || ctx_r140.submitted) && x_r141.get("phoneNo").hasError("pattern"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", x_r141.get("phoneNo").errors == null ? null : x_r141.get("phoneNo").errors.maxlength);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", x_r141.get("phoneNo").errors == null ? null : x_r141.get("phoneNo").errors.minlength);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 196);
    i0.ɵɵelementStart(1, "div", 197);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_ng_container_2_Template, 16, 9, "ng-container", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r70.beneSelfDetailsForm.get("phoneContacts")["controls"]);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 212);
    i0.ɵɵtext(1, "Email Id");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r146 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("required", ctx_r146.beneficiaryType === "self");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 212);
    i0.ɵɵtext(1, "Email Id");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_ng_container_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 215);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r151 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r151.getGlobalErrorMessages("REQUIRED"), "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_ng_container_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 162);
    i0.ɵɵelementStart(1, "span", 216);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r152 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r152.getGlobalErrorMessages("INVALID_EMAIL"), "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 213);
    i0.ɵɵelement(2, "input", 214);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_ng_container_3_span_3_Template, 3, 1, "span", 160);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_ng_container_3_span_4_Template, 3, 1, "span", 160);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const x_r149 = ctx.$implicit;
    const i_r150 = ctx.index;
    const ctx_r148 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r150);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, (x_r149.get("email").touched || ctx_r148.submitted) && x_r149.get("email").hasError("pattern") || (x_r149.get("email").touched || ctx_r148.submitted) && x_r149.get("email").hasError("required") && !ctx_r148.iscaseRequest));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (x_r149.get("email").touched || ctx_r148.submitted) && x_r149.get("email").hasError("required") && !ctx_r148.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (x_r149.get("email").touched || ctx_r148.submitted) && x_r149.get("email").hasError("pattern"));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 209);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_p_1_Template, 2, 2, "p", 210);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_p_2_Template, 2, 0, "p", 211);
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_ng_container_3_Template, 5, 6, "ng-container", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r71.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r71.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r71.beneSelfDetailsForm.get("emailContacts")["controls"]);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_22_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 222);
    i0.ɵɵtext(1, " Please Enter 9 Digits ");
    i0.ɵɵelementEnd();
} }
const _c1 = function (a0) { return { "ssn-input-hide": a0 }; };
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r155 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵelementStart(1, "p", 217);
    i0.ɵɵtext(2, "Social Security Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 218);
    i0.ɵɵelement(4, "input", 219);
    i0.ɵɵelementStart(5, "mat-icon", 220);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_22_Template_mat_icon_click_5_listener() { i0.ɵɵrestoreView(_r155); const ctx_r154 = i0.ɵɵnextContext(3); return ctx_r154.ssn_hide = !ctx_r154.ssn_hide; });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_22_span_7_Template, 2, 0, "span", 221);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1, !ctx_r72.ssn_hide));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r72.ssn_hide ? "visibility" : "visibility_off", "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r72.beneSelfDetailsForm.get("ssn").touched || ctx_r72.submitted) && (ctx_r72.beneSelfDetailsForm.get("ssn").errors == null ? null : ctx_r72.beneSelfDetailsForm.get("ssn").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 223);
    i0.ɵɵtext(1, " Please Enter Numbers Only. ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_33_div_14_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 237);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r157 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r157.getGlobalErrorMessages("INVALID_FORMAT"), " ");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_33_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 232);
    i0.ɵɵelementStart(2, "span", 233);
    i0.ɵɵtext(3, "Green Card Number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "small", 234);
    i0.ɵɵtext(5, "(Ex.XXX0000000000)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 235);
    i0.ɵɵtemplate(7, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_33_div_14_span_7_Template, 2, 1, "span", 236);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r156 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, (ctx_r156.beneSelfDetailsForm.get("greenCardNo").touched || ctx_r156.submitted) && (ctx_r156.beneSelfDetailsForm.get("greenCardNo").errors == null ? null : ctx_r156.beneSelfDetailsForm.get("greenCardNo").errors.pattern)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r156.beneSelfDetailsForm.get("greenCardNo").touched || ctx_r156.submitted) && (ctx_r156.beneSelfDetailsForm.get("greenCardNo").errors == null ? null : ctx_r156.beneSelfDetailsForm.get("greenCardNo").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r159 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵelementStart(1, "div", 116);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "p", 224);
    i0.ɵɵtext(4, "Are you a Lawful Permanent Resident? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 225);
    i0.ɵɵelementStart(6, "div", 226);
    i0.ɵɵelementStart(7, "p-radioButton", 227);
    i0.ɵɵlistener("onClick", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_33_Template_p_radioButton_onClick_7_listener() { i0.ɵɵrestoreView(_r159); const ctx_r158 = i0.ɵɵnextContext(3); return ctx_r158.handleIsLprChanges(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 228);
    i0.ɵɵtext(9, "Yes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 226);
    i0.ɵɵelementStart(11, "p-radioButton", 229);
    i0.ɵɵlistener("onClick", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_33_Template_p_radioButton_onClick_11_listener() { i0.ɵɵrestoreView(_r159); const ctx_r160 = i0.ɵɵnextContext(3); return ctx_r160.handleIsLprChanges(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "label", 230);
    i0.ɵɵtext(13, "No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_33_div_14_Template, 8, 4, "div", 129);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("value", 1);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("value", 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r74.beneSelfDetailsForm.get("isLpr").value == 1 && (ctx_r74.iscaseRequest ? ctx_r74.currentItemDisplay.includes("GRNCARDDTLS") ? true : false : true));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_34_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 245);
    i0.ɵɵtext(1, "Add photocopy of your Green Card");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r163 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "div", 238);
    i0.ɵɵelementStart(3, "div", 239);
    i0.ɵɵtext(4, " Did you gain lawful permanent resident status through marriage to the U.S Citizen or Lawful Permanent resident? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 240);
    i0.ɵɵelementStart(6, "p-inputSwitch", 241);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_34_Template_p_inputSwitch_onChange_6_listener() { i0.ɵɵrestoreView(_r163); const ctx_r162 = i0.ɵɵnextContext(3); return ctx_r162.handleLawfulSwitchChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 242);
    i0.ɵɵtemplate(8, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_34_p_8_Template, 2, 0, "p", 243);
    i0.ɵɵelement(9, "file-upload-deafult-library", 244);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", !ctx_r75.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("configurations", ctx_r75.fileUploadConfigurations);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 246);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "h5", 247);
    i0.ɵɵtext(3, "Place of Birth");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_37_Template(rf, ctx) { if (rf & 1) {
    const _r165 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 248);
    i0.ɵɵelementStart(1, "p", 249);
    i0.ɵɵtext(2, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 250);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_37_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r165); const ctx_r164 = i0.ɵɵnextContext(3); ctx_r164.resetBirthStateOnCountryChange(); return ctx_r164.handleCountryChange($event.value, "Birth"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r77.listCountry)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 251);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 252);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r78.listStatesBirth)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_39_input_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 255);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_39_input_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 255);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 253);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_39_input_3_Template, 1, 0, "input", 254);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_39_input_4_Template, 1, 0, "input", 254);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r79.isBirthStateRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r79.isBirthStateRequired);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 256);
    i0.ɵɵtext(2, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 257);
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r169 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "div", 258);
    i0.ɵɵelementStart(2, "p", 259);
    i0.ɵɵtext(3, "Citizenship");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 250);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_42_Template_p_dropdown_onChange_4_listener($event) { i0.ɵɵrestoreView(_r169); const ctx_r168 = i0.ɵɵnextContext(3); return ctx_r168.updateCountry($event.value, "issueCountryCode"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r81.listCountry)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 266);
    i0.ɵɵtext(1, "My Citizenship was acquired through:");
    i0.ɵɵelementEnd();
} }
const _c2 = function (a0) { return { "mr-3": a0 }; };
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 267);
    i0.ɵɵelement(1, "p-radioButton", 268);
    i0.ɵɵelementStart(2, "label", 269);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r173 = ctx.$implicit;
    const i_r174 = ctx.index;
    const ctx_r171 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2, i_r174 < ctx_r171.citizenshipAcquiredArr.length - 1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputId", item_r173.id)("value", item_r173.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "citizenshipAcquiredArr", i_r174, "");
    i0.ɵɵproperty("for", item_r173.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r173.name);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r177 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 231);
    i0.ɵɵelementStart(2, "p", 270);
    i0.ɵɵtext(3, "Certificate Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 271);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 231);
    i0.ɵɵelementStart(6, "p", 272);
    i0.ɵɵtext(7, "Place of Issuance");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 273);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 231);
    i0.ɵɵelementStart(10, "p", 274);
    i0.ɵɵtext(11, "Date of Issuance");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "mat-form-field", 192);
    i0.ɵɵelementStart(13, "input", 275);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_div_13_Template_input_click_13_listener() { i0.ɵɵrestoreView(_r177); const _r175 = i0.ɵɵreference(16); return _r175.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "mat-datepicker-toggle", 194);
    i0.ɵɵelement(15, "mat-datepicker", null, 276);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r175 = i0.ɵɵreference(16);
    const ctx_r172 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("max", ctx_r172.currentDate)("matDatepicker", _r175);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r175);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_Template(rf, ctx) { if (rf & 1) {
    const _r179 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 68);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵelementStart(3, "div", 260);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_p_4_Template, 2, 0, "p", 261);
    i0.ɵɵtemplate(5, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_div_5_Template, 4, 8, "div", 262);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 29);
    i0.ɵɵelementStart(7, "div", 30);
    i0.ɵɵelementStart(8, "div", 263);
    i0.ɵɵelementStart(9, "div", 264);
    i0.ɵɵtext(10, " Have you obtained certificate of Naturalization or Certificate of Citizenship? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 240);
    i0.ɵɵelementStart(12, "p-inputSwitch", 265);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_Template_p_inputSwitch_onChange_12_listener() { i0.ɵɵrestoreView(_r179); const ctx_r178 = i0.ɵɵnextContext(3); return ctx_r178.handleCitizenshipSwitchChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_div_13_Template, 17, 3, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r82.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r82.citizenshipAcquiredArr);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r82.beneSelfDetailsForm.get("hasCtznCrtfct").value == 1);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 246);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "h5", 277);
    i0.ɵɵtext(3, "Marital Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r184 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵelementStart(1, "div", 278);
    i0.ɵɵelementStart(2, "h5", 279);
    i0.ɵɵtext(3, "What is your current marital status?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 280);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_2_Template_p_dropdown_onChange_4_listener() { i0.ɵɵrestoreView(_r184); const ctx_r183 = i0.ɵɵnextContext(4); return ctx_r183.translet(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r181 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r181.maritalStatusArr)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r193 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 282);
    i0.ɵɵtext(2, "Date of Marriage");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 192);
    i0.ɵɵelementStart(4, "input", 283);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_2_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r193); const _r191 = i0.ɵɵreference(7); return _r191.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker-toggle", 194);
    i0.ɵɵelement(6, "mat-datepicker", null, 284);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r191 = i0.ɵɵreference(7);
    const ctx_r185 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("max", ctx_r185.currentDate)("matDatepicker", _r191);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r191);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 246);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "h6", 285);
    i0.ɵɵtext(3, "Place of Marriage");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r195 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 286);
    i0.ɵɵelementStart(1, "p", 287);
    i0.ɵɵtext(2, "Country of Marriage");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 250);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_5_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r195); const ctx_r194 = i0.ɵɵnextContext(5); return ctx_r194.handleCountryChange($event.value, "Marriage"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r187 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r187.listCountryMarriage)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r197 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 288);
    i0.ɵɵtext(2, "State of Marriage");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 289);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_6_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r197); const ctx_r196 = i0.ɵɵnextContext(5); return ctx_r196.handleStateChange($event.value, 1); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r188 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r188.listStatesMarriage)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 288);
    i0.ɵɵtext(2, "State of Marriage");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 290);
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 291);
    i0.ɵɵtext(2, "City of Marriage");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 292);
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 68);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_2_Template, 8, 3, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_3_Template, 4, 0, "div", 112);
    i0.ɵɵelementStart(4, "div", 29);
    i0.ɵɵtemplate(5, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_5_Template, 4, 2, "div", 281);
    i0.ɵɵtemplate(6, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_6_Template, 4, 2, "div", 129);
    i0.ɵɵtemplate(7, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_7_Template, 4, 0, "div", 129);
    i0.ɵɵtemplate(8, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_div_8_Template, 4, 0, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r182 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r182.iscaseRequest ? ctx_r182.currentItemDisplay.includes("MRGDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r182.iscaseRequest ? ctx_r182.currentItemDisplay.includes("MRGDTLS") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r182.iscaseRequest ? ctx_r182.currentItemDisplay.includes("MRGDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r182.listStatesMarriage.length > 0 && (ctx_r182.iscaseRequest ? ctx_r182.currentItemDisplay.includes("MRGDTLS") ? true : false : true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r182.listStatesMarriage.length <= 0 && (ctx_r182.iscaseRequest ? ctx_r182.currentItemDisplay.includes("MRGDTLS") ? true : false : true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r182.iscaseRequest ? ctx_r182.currentItemDisplay.includes("MRGDTLS") ? true : false : true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_1_Template, 4, 0, "div", 112);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_2_Template, 5, 2, "div", 5);
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_div_3_Template, 9, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r83 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.iscaseRequest ? ctx_r83.currentItemDisplay.includes("MRGDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.iscaseRequest ? ctx_r83.currentItemDisplay.includes("MRGDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.beneSelfDetailsForm.get("maritalStatus").get("id").value && ctx_r83.beneSelfDetailsForm.get("maritalStatus").get("id").value != 10);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 246);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "h5", 293);
    i0.ɵɵtext(3, "Physical Address Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r203 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 301);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 309);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_div_27_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r203); const ctx_r202 = i0.ɵɵnextContext(4); return ctx_r202.handleStateChange($event.value, 0); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r198 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r198.listStatesCurrent)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 295);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 310);
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_span_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 311);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r200 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r200.getGlobalErrorMessages("ZIPCODE_ONLY"), " ");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_Template(rf, ctx) { if (rf & 1) {
    const _r205 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 213);
    i0.ɵɵelementStart(1, "div", 68);
    i0.ɵɵelementStart(2, "div", 294);
    i0.ɵɵelementStart(3, "p", 295);
    i0.ɵɵtext(4, "In care of (optional)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "input", 296);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 68);
    i0.ɵɵelementStart(7, "div", 294);
    i0.ɵɵelementStart(8, "p", 295);
    i0.ɵɵtext(9, "Address 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "input", 297);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 68);
    i0.ɵɵelementStart(12, "div", 294);
    i0.ɵɵelementStart(13, "p", 202);
    i0.ɵɵelementStart(14, "span", 67);
    i0.ɵɵtext(15, "Address 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "i", 298);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "input", 299);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 68);
    i0.ɵɵelementStart(19, "div", 231);
    i0.ɵɵelementStart(20, "p", 295);
    i0.ɵɵtext(21, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "input", 300);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 248);
    i0.ɵɵelementStart(24, "p", 301);
    i0.ɵɵtext(25, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "p-dropdown", 250);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_Template_p_dropdown_onChange_26_listener($event) { i0.ɵɵrestoreView(_r205); const ctx_r204 = i0.ɵɵnextContext(3); ctx_r204.handleCountryChange($event.value, "Current"); return ctx_r204.resetStateOnCountryChange(0); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_div_27_Template, 4, 2, "div", 129);
    i0.ɵɵtemplate(28, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_div_28_Template, 4, 0, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 68);
    i0.ɵɵelementStart(30, "div", 231);
    i0.ɵɵelementStart(31, "p", 295);
    i0.ɵɵtext(32, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "input", 302);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 231);
    i0.ɵɵelementStart(35, "p", 295);
    i0.ɵɵtext(36, "Zip / Postal Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "input", 303);
    i0.ɵɵtemplate(38, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_span_38_Template, 2, 1, "span", 304);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 68);
    i0.ɵɵelementStart(40, "div", 294);
    i0.ɵɵelementStart(41, "p", 295);
    i0.ɵɵtext(42, "County(optional)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(43, "input", 305);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 306);
    i0.ɵɵelementStart(45, "p", 295);
    i0.ɵɵtext(46, "Effective Date From ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "mat-form-field", 192);
    i0.ɵɵelementStart(48, "input", 307);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_Template_input_click_48_listener() { i0.ɵɵrestoreView(_r205); const _r201 = i0.ɵɵreference(51); return _r201.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(49, "mat-datepicker-toggle", 194);
    i0.ɵɵelement(50, "mat-datepicker", null, 308);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r201 = i0.ɵɵreference(51);
    const ctx_r85 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroupName", ctx_r85.getAddressGroup("CURR"));
    i0.ɵɵadvance(26);
    i0.ɵɵproperty("options", ctx_r85.listCountry)("filter", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r85.listStatesCurrent.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r85.listStatesCurrent.length <= 0);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, (ctx_r85.submitted || ctx_r85.beneSelfDetailsForm.get("address")["controls"]["0"].get("postCode").touched) && (ctx_r85.beneSelfDetailsForm.get("address")["controls"]["0"].get("postCode").errors == null ? null : ctx_r85.beneSelfDetailsForm.get("address")["controls"]["0"].get("postCode").errors.pattern) || ctx_r85.submitted && !ctx_r85.iscaseRequest));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r85.submitted || ctx_r85.beneSelfDetailsForm.get("address")["controls"]["0"].get("postCode").touched) && (ctx_r85.beneSelfDetailsForm.get("address")["controls"]["0"].get("postCode").errors == null ? null : ctx_r85.beneSelfDetailsForm.get("address")["controls"]["0"].get("postCode").errors.pattern));
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("max", ctx_r85.currentDate)("matDatepicker", _r201);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r201);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_48_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r211 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 318);
    i0.ɵɵelementStart(1, "p-radioButton", 319);
    i0.ɵɵlistener("onClick", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_48_div_8_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r211); const item_r208 = ctx.$implicit; const ctx_r210 = i0.ɵɵnextContext(4); return ctx_r210.copyAddress(item_r208.code, "Mailing"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 320);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r208 = ctx.$implicit;
    const i_r209 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputId", item_r208.code)("value", item_r208.code);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "listCopyMailAddressCOde", i_r209, "");
    i0.ɵɵproperty("for", item_r208.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r208.name);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 312);
    i0.ɵɵelementStart(1, "div", 231);
    i0.ɵɵelementStart(2, "h5", 313);
    i0.ɵɵtext(3, "Mailing Address Details ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 314);
    i0.ɵɵelementStart(5, "p", 315);
    i0.ɵɵtext(6, "Copy From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 316);
    i0.ɵɵtemplate(8, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_48_div_8_Template, 4, 5, "div", 317);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r86 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngForOf", ctx_r86.listCopyMailAddress);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r218 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 327);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 309);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_div_27_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r218); const ctx_r217 = i0.ɵɵnextContext(5); return ctx_r217.handleStateChange($event.value, 1); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r213 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r213.listStatesMailing)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 328);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 310);
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_span_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 311);
    i0.ɵɵelementStart(1, "span", 329);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r215 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r215.getGlobalErrorMessages("ZIPCODE_ONLY"), "");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r220 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 213);
    i0.ɵɵelementStart(1, "div", 68);
    i0.ɵɵelementStart(2, "div", 294);
    i0.ɵɵelementStart(3, "p", 295);
    i0.ɵɵtext(4, "In care of (optional)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "input", 296);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 68);
    i0.ɵɵelementStart(7, "div", 294);
    i0.ɵɵelementStart(8, "p", 321);
    i0.ɵɵtext(9, "Address 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "input", 297);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 68);
    i0.ɵɵelementStart(12, "div", 294);
    i0.ɵɵelementStart(13, "p", 202);
    i0.ɵɵelementStart(14, "span", 322);
    i0.ɵɵtext(15, "Address 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "i", 298);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "input", 299);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 68);
    i0.ɵɵelementStart(19, "div", 231);
    i0.ɵɵelementStart(20, "p", 323);
    i0.ɵɵtext(21, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "input", 300);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 248);
    i0.ɵɵelementStart(24, "p", 324);
    i0.ɵɵtext(25, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "p-dropdown", 250);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_Template_p_dropdown_onChange_26_listener($event) { i0.ɵɵrestoreView(_r220); const ctx_r219 = i0.ɵɵnextContext(4); ctx_r219.handleCountryChange($event.value, "Mailing"); return ctx_r219.resetStateOnCountryChange(1); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_div_27_Template, 4, 2, "div", 129);
    i0.ɵɵtemplate(28, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_div_28_Template, 4, 0, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 68);
    i0.ɵɵelementStart(30, "div", 231);
    i0.ɵɵelementStart(31, "p", 325);
    i0.ɵɵtext(32, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "input", 302);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 231);
    i0.ɵɵelementStart(35, "p", 326);
    i0.ɵɵtext(36, "Zip / Postal Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "input", 303);
    i0.ɵɵtemplate(38, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_span_38_Template, 3, 1, "span", 304);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 68);
    i0.ɵɵelementStart(40, "div", 294);
    i0.ɵɵelementStart(41, "p", 295);
    i0.ɵɵtext(42, "County(optional)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(43, "input", 305);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 306);
    i0.ɵɵelementStart(45, "p", 295);
    i0.ɵɵtext(46, "Effective Date From ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "mat-form-field", 192);
    i0.ɵɵelementStart(48, "input", 307);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_Template_input_click_48_listener() { i0.ɵɵrestoreView(_r220); const _r216 = i0.ɵɵreference(51); return _r216.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(49, "mat-datepicker-toggle", 194);
    i0.ɵɵelement(50, "mat-datepicker", null, 308);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r216 = i0.ɵɵreference(51);
    const ctx_r212 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroupName", ctx_r212.getAddressGroup("MAIL"));
    i0.ɵɵadvance(26);
    i0.ɵɵproperty("options", ctx_r212.listCountry)("filter", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r212.listStatesMailing.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r212.listStatesMailing.length <= 0);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, (ctx_r212.submitted || ctx_r212.beneSelfDetailsForm.get("address")["controls"]["1"].get("postCode").touched) && (ctx_r212.beneSelfDetailsForm.get("address")["controls"]["1"].get("postCode").errors == null ? null : ctx_r212.beneSelfDetailsForm.get("address")["controls"]["1"].get("postCode").errors.pattern) || ctx_r212.submitted && !ctx_r212.iscaseRequest));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r212.submitted || ctx_r212.beneSelfDetailsForm.get("address")["controls"]["1"].get("postCode").touched) && (ctx_r212.beneSelfDetailsForm.get("address")["controls"]["1"].get("postCode").errors == null ? null : ctx_r212.beneSelfDetailsForm.get("address")["controls"]["1"].get("postCode").errors.pattern));
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("max", ctx_r212.currentDate)("matDatepicker", _r216);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r216);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 130);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_div_1_Template, 52, 12, "div", 131);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r87.iscaseRequest ? ctx_r87.currentItemDisplay.includes("MAILADR") ? true : false : true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 246);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "h5", 330);
    i0.ɵɵtext(3, "Passport Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_51_Template(rf, ctx) { if (rf & 1) {
    const _r223 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 331);
    i0.ɵɵelementStart(1, "div", 332);
    i0.ɵɵelementStart(2, "div", 225);
    i0.ɵɵelementStart(3, "div", 226);
    i0.ɵɵelementStart(4, "p-checkbox", 333);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_51_Template_p_checkbox_onChange_4_listener($event) { i0.ɵɵrestoreView(_r223); const ctx_r222 = i0.ɵɵnextContext(3); return ctx_r222.updatePassportFormControl($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 334);
    i0.ɵɵtext(6, "Ignore passportdetails");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_3_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 340);
    i0.ɵɵtext(1, "Passport No.");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_3_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 340);
    i0.ɵɵtext(1, "Passport No.");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 294);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_3_p_1_Template, 2, 0, "p", 338);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_3_p_2_Template, 2, 0, "p", 338);
    i0.ɵɵelement(3, "input", 339);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r227 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r227.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r227.iscaseRequest);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 341);
    i0.ɵɵelementStart(1, "p", 342);
    i0.ɵɵtext(2, "Issuing Authority");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 343);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r228 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r228.listCountry)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r235 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 344);
    i0.ɵɵtext(2, "Date of Issue");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 192);
    i0.ɵɵelementStart(4, "input", 345);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_6_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r235); const _r233 = i0.ɵɵreference(7); return _r233.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker-toggle", 194);
    i0.ɵɵelement(6, "mat-datepicker", null, 346);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r233 = i0.ɵɵreference(7);
    const ctx_r229 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("max", ctx_r229.currentDate)("matDatepicker", _r233);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r233);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r238 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 347);
    i0.ɵɵtext(2, "Date of Expiry");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 192);
    i0.ɵɵelementStart(4, "input", 348);
    i0.ɵɵlistener("change", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_7_Template_input_change_4_listener() { i0.ɵɵrestoreView(_r238); const ctx_r237 = i0.ɵɵnextContext(5); return ctx_r237.validateExpiry(ctx_r237.beneSelfDetailsForm.controls["passport"] == null ? null : ctx_r237.beneSelfDetailsForm.controls["passport"].value[0] == null ? null : ctx_r237.beneSelfDetailsForm.controls["passport"].value[0].issueDate, ctx_r237.beneSelfDetailsForm.controls["passport"] == null ? null : ctx_r237.beneSelfDetailsForm.controls["passport"].value[0] == null ? null : ctx_r237.beneSelfDetailsForm.controls["passport"].value[0].expiryDate); })("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_7_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r238); const _r236 = i0.ɵɵreference(7); return _r236.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker-toggle", 194);
    i0.ɵɵelement(6, "mat-datepicker", null, 349);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r236 = i0.ɵɵreference(7);
    const ctx_r230 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r236)("min", ctx_r230.beneSelfDetailsForm.controls["passport"] == null ? null : ctx_r230.beneSelfDetailsForm.controls["passport"].value[0] == null ? null : ctx_r230.beneSelfDetailsForm.controls["passport"].value[0].issueDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r236);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 213);
    i0.ɵɵelementStart(2, "div", 68);
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_3_Template, 4, 2, "div", 336);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_4_Template, 4, 2, "div", 337);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 68);
    i0.ɵɵtemplate(6, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_6_Template, 8, 3, "div", 129);
    i0.ɵɵtemplate(7, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_div_7_Template, 8, 3, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r226 = ctx.index;
    const ctx_r224 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r226);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r224.iscaseRequest ? ctx_r224.currentItemDisplay.includes("PASPORTDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r224.iscaseRequest ? ctx_r224.currentItemDisplay.includes("PASPORTDTLS") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r224.iscaseRequest ? ctx_r224.currentItemDisplay.includes("PASPORTDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r224.iscaseRequest ? ctx_r224.currentItemDisplay.includes("PASPORTDTLS") ? true : false : true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 335);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_ng_container_2_Template, 8, 5, "ng-container", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r90.beneSelfDetailsForm.get("passport")["controls"]);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 358);
    i0.ɵɵelementStart(1, "h5", 293);
    i0.ɵɵtext(2, "Signature");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 359);
    i0.ɵɵtext(1, "Upload Signature");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 360);
    i0.ɵɵtext(1, "Change Signature");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_img_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 89);
} if (rf & 2) {
    const ctx_r243 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r243.signatureImage, i0.ɵɵsanitizeUrl);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_Template(rf, ctx) { if (rf & 1) {
    const _r245 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 350);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_div_1_Template, 3, 0, "div", 351);
    i0.ɵɵelementStart(2, "div", 352);
    i0.ɵɵelementStart(3, "p", 353);
    i0.ɵɵelementStart(4, "button", 354);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r245); const ctx_r244 = i0.ɵɵnextContext(3); return ctx_r244.uploadSignatureImage(); });
    i0.ɵɵtemplate(5, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_span_5_Template, 2, 0, "span", 355);
    i0.ɵɵtemplate(6, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_span_6_Template, 2, 0, "span", 356);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 357);
    i0.ɵɵtemplate(8, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_img_8_Template, 1, 1, "img", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r91.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r91.signatureImage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r91.signatureImage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !!ctx_r91.signatureImage);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r253 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "lib-custom-questionnaire", 361);
    i0.ɵɵlistener("refreshList", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_div_1_div_1_div_1_Template_lib_custom_questionnaire_refreshList_1_listener($event) { i0.ɵɵrestoreView(_r253); const ctx_r252 = i0.ɵɵnextContext(7); return ctx_r252.onRefreshPage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r251 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isNewPortion", false)("viewQuestions", false)("loadedIn", "Personal Details")("beneficiaryId", ctx_r251.beneficiaryId)("isSection", true)("familyId", ctx_r251.currentFamilyId);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_div_1_div_1_div_1_Template, 2, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r250 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r250 == null ? null : item_r250.key) == "QTPROFILEBEN" && item_r250.selected == true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_div_1_div_1_Template, 2, 1, "div", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r247 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ques_r247.stakeHoldersSelected);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r247 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ques_r247.name == "Personal Details");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_div_1_Template, 2, 1, "div", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r92.customQuestions == null ? null : ctx_r92.customQuestions.sectionList);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r262 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "lib-custom-questionnaire", 361);
    i0.ɵɵlistener("refreshList", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_div_1_div_1_div_1_Template_lib_custom_questionnaire_refreshList_1_listener($event) { i0.ɵɵrestoreView(_r262); const ctx_r261 = i0.ɵɵnextContext(7); return ctx_r261.onRefreshPage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r260 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isNewPortion", false)("viewQuestions", false)("loadedIn", "Personal Details")("beneficiaryId", ctx_r260.beneficiaryId)("isSection", true)("familyId", ctx_r260.currentFamilyId);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_div_1_div_1_div_1_Template, 2, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r259 = ctx.$implicit;
    const ctx_r258 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r258.detailsAbout == null ? null : ctx_r258.detailsAbout.dependentType == null ? null : ctx_r258.detailsAbout.dependentType.code) == item_r259.key && item_r259.selected == true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_div_1_div_1_Template, 2, 1, "div", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r256 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ques_r256.stakeHoldersSelected);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r256 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ques_r256.name == "Personal Details");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 94);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_div_1_Template, 2, 1, "div", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r93.customQuestions == null ? null : ctx_r93.customQuestions.sectionList);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_65_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r268 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 318);
    i0.ɵɵelementStart(1, "p-radioButton", 371);
    i0.ɵɵlistener("onClick", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_65_div_8_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r268); const item_r265 = ctx.$implicit; const ctx_r267 = i0.ɵɵnextContext(4); return ctx_r267.copyAddress(item_r265.code, "Foreign"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 372);
    i0.ɵɵelementStart(3, "span", 373);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r265 = ctx.$implicit;
    const i_r266 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputId", item_r265.code)("value", item_r265.code);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", item_r265.code);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "listCopyFornAddress_1", i_r266, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r265.name);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_65_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 362);
    i0.ɵɵelementStart(1, "div", 231);
    i0.ɵɵelementStart(2, "h5", 363);
    i0.ɵɵtext(3, "Foreign Address Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 364);
    i0.ɵɵelementStart(5, "p", 365);
    i0.ɵɵtext(6, "Copy From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 316);
    i0.ɵɵtemplate(8, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_65_div_8_Template, 5, 5, "div", 317);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 366);
    i0.ɵɵelementStart(10, "label", 367);
    i0.ɵɵelementStart(11, "b", 368);
    i0.ɵɵtext(12, "Note");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(13, " : ");
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵelementStart(15, "span", 369);
    i0.ɵɵtext(16, "For applicants whose current address is outside the US. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "i", 370);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r94 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngForOf", ctx_r94.listCopyFornAddress);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 382);
    i0.ɵɵtext(2, " State ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 383);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r269 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r269.listStatesForeign)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 384);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 310);
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_span_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 385);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r271 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r271.getGlobalErrorMessages("ZIPCODE_ONLY"), " ");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_Template(rf, ctx) { if (rf & 1) {
    const _r273 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 130);
    i0.ɵɵelementStart(1, "div", 213);
    i0.ɵɵelementStart(2, "div", 68);
    i0.ɵɵelementStart(3, "div", 294);
    i0.ɵɵelementStart(4, "p", 374);
    i0.ɵɵtext(5, " Address 1 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 297);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 68);
    i0.ɵɵelementStart(8, "div", 294);
    i0.ɵɵelementStart(9, "p", 202);
    i0.ɵɵelementStart(10, "span", 375);
    i0.ɵɵtext(11, "Address 2 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "i", 298);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 299);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 68);
    i0.ɵɵelementStart(15, "div", 231);
    i0.ɵɵelementStart(16, "p", 376);
    i0.ɵɵtext(17, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "input", 300);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 248);
    i0.ɵɵelementStart(20, "p", 377);
    i0.ɵɵtext(21, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "p-dropdown", 378);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_Template_p_dropdown_onChange_22_listener($event) { i0.ɵɵrestoreView(_r273); const ctx_r272 = i0.ɵɵnextContext(3); ctx_r272.handleCountryChange($event.value, "Foreign"); return ctx_r272.resetStateOnCountryChange(2); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_div_23_Template, 4, 2, "div", 129);
    i0.ɵɵtemplate(24, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_div_24_Template, 4, 0, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 68);
    i0.ɵɵelementStart(26, "div", 231);
    i0.ɵɵelementStart(27, "p", 379);
    i0.ɵɵtext(28, "City ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(29, "input", 302);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 231);
    i0.ɵɵelementStart(31, "p", 380);
    i0.ɵɵtext(32, "Zip / Postal Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "input", 303);
    i0.ɵɵtemplate(34, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_span_34_Template, 2, 1, "span", 381);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r95 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", ctx_r95.getAddressGroup("FORN"));
    i0.ɵɵadvance(21);
    i0.ɵɵproperty("options", ctx_r95.listCountryForeignAdd)("filter", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r95.listStatesForeign.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r95.listStatesForeign.length <= 0);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, (ctx_r95.submitted || ctx_r95.beneSelfDetailsForm.get("address")["controls"]["2"].get("postCode").touched) && (ctx_r95.beneSelfDetailsForm.get("address")["controls"]["2"].get("postCode").errors == null ? null : ctx_r95.beneSelfDetailsForm.get("address")["controls"]["2"].get("postCode").errors.pattern) || ctx_r95.submitted && !ctx_r95.iscaseRequest));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r95.submitted || ctx_r95.beneSelfDetailsForm.get("address")["controls"]["2"].get("postCode").touched) && (ctx_r95.beneSelfDetailsForm.get("address")["controls"]["2"].get("postCode").errors == null ? null : ctx_r95.beneSelfDetailsForm.get("address")["controls"]["2"].get("postCode").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_67_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r277 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 318);
    i0.ɵɵelementStart(1, "p-radioButton", 388);
    i0.ɵɵlistener("onClick", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_67_div_8_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r277); const item_r275 = ctx.$implicit; const ctx_r276 = i0.ɵɵnextContext(4); return ctx_r276.copyAddress(item_r275.code, "Permanent"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 389);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r275 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", item_r275.code);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", item_r275.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r275.name);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_67_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 386);
    i0.ɵɵelementStart(1, "div", 231);
    i0.ɵɵelementStart(2, "h5", 293);
    i0.ɵɵtext(3, "Permanent Address Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 387);
    i0.ɵɵelementStart(5, "p", 301);
    i0.ɵɵtext(6, "Copy From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 316);
    i0.ɵɵtemplate(8, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_67_div_8_Template, 4, 3, "div", 317);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r96 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngForOf", ctx_r96.listCopyPermAddress);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r282 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 301);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 309);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_div_21_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r282); const ctx_r281 = i0.ɵɵnextContext(4); return ctx_r281.handleStateChange($event.value, 3); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r278 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r278.listStatesPermanent)("filter", true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 295);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 310);
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_span_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 311);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r280 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r280.getGlobalErrorMessages("ZIPCODE_ONLY"), " ");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_Template(rf, ctx) { if (rf & 1) {
    const _r284 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 213);
    i0.ɵɵelementStart(1, "div", 68);
    i0.ɵɵelementStart(2, "div", 294);
    i0.ɵɵelementStart(3, "p", 295);
    i0.ɵɵtext(4, "Address 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "input", 297);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 68);
    i0.ɵɵelementStart(7, "div", 294);
    i0.ɵɵelementStart(8, "p", 295);
    i0.ɵɵtext(9, "Address 2 ");
    i0.ɵɵelement(10, "i", 298);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "input", 299);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 68);
    i0.ɵɵelementStart(13, "div", 231);
    i0.ɵɵelementStart(14, "p", 295);
    i0.ɵɵtext(15, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "input", 390);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 248);
    i0.ɵɵelementStart(18, "p", 301);
    i0.ɵɵtext(19, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "p-dropdown", 250);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_Template_p_dropdown_onChange_20_listener($event) { i0.ɵɵrestoreView(_r284); const ctx_r283 = i0.ɵɵnextContext(3); ctx_r283.handleCountryChange($event.value, "Permanent"); return ctx_r283.resetStateOnCountryChange(3); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_div_21_Template, 4, 2, "div", 129);
    i0.ɵɵtemplate(22, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_div_22_Template, 4, 0, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 68);
    i0.ɵɵelementStart(24, "div", 231);
    i0.ɵɵelementStart(25, "p", 295);
    i0.ɵɵtext(26, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "input", 302);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 231);
    i0.ɵɵelementStart(29, "p", 295);
    i0.ɵɵtext(30, "Zip / Postal Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(31, "input", 303);
    i0.ɵɵtemplate(32, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_span_32_Template, 2, 1, "span", 304);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r97 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroupName", ctx_r97.getAddressGroup("PERM"));
    i0.ɵɵadvance(20);
    i0.ɵɵproperty("options", ctx_r97.listCountry)("filter", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r97.listStatesPermanent.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r97.listStatesPermanent.length <= 0);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, (ctx_r97.submitted || ctx_r97.beneSelfDetailsForm.get("address")["controls"]["3"].get("postCode").touched) && !ctx_r97.iscaseRequest));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r97.submitted && (ctx_r97.beneSelfDetailsForm.get("address")["controls"]["3"].get("postCode").errors == null ? null : ctx_r97.beneSelfDetailsForm.get("address")["controls"]["3"].get("postCode").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_70_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "h5", 391);
    i0.ɵɵtext(2, "Biographic Information ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_70_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 246);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_70_div_1_Template, 3, 0, "div", 174);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r98.iscaseRequest ? ctx_r98.currentItemDisplay.includes("RACEDTLS") ? true : false : true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_71_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 396);
    i0.ɵɵelement(1, "p-radioButton", 397);
    i0.ɵɵelementStart(2, "label", 398);
    i0.ɵɵelementStart(3, "span", 399);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ethinItem_r288 = ctx.$implicit;
    const i_r289 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputId", ethinItem_r288.id)("value", ethinItem_r288.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ethinItem_r288.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "ethinItem", i_r289, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ethinItem_r288.name);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_71_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 393);
    i0.ɵɵelementStart(1, "p", 394);
    i0.ɵɵtext(2, "Ethnicity");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_71_div_2_div_3_Template, 5, 5, "div", 395);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r286 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r286.ethinicityArr);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_71_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_71_div_2_Template, 4, 1, "div", 392);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r99 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r99.iscaseRequest ? ctx_r99.currentItemDisplay.includes("RACEDTLS") ? true : false : true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_72_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "div", 402);
    i0.ɵɵelementStart(3, "div", 403);
    i0.ɵɵelement(4, "p-checkbox", 404);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r291 = ctx.$implicit;
    const i_r292 = ctx.index;
    const ctx_r290 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", ctx_r290.raceArr[i_r292] == null ? null : ctx_r290.raceArr[i_r292].name)("formControl", control_r291);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_72_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 400);
    i0.ɵɵelementStart(1, "p", 401);
    i0.ɵɵtext(2, "Race");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_72_ng_container_3_Template, 5, 2, "ng-container", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r100 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r100.raceArray == null ? null : ctx_r100.raceArray.controls);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 405);
    i0.ɵɵtext(2, "Hair Color");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 406);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r293 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r293.hairColors);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 407);
    i0.ɵɵtext(2, "Eyes Color");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 408);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r294 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r294.eyeColors);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_div_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 412);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r296 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r296.getGlobalErrorMessages("INVALID_FORMAT"), " ");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 409);
    i0.ɵɵtext(2, "Weight(in pounds)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 410);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_div_3_span_4_Template, 2, 1, "span", 411);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r295 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r295.beneSelfDetailsForm.get("weight").touched || ctx_r295.submitted));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r295.beneSelfDetailsForm.get("weight").touched || ctx_r295.submitted) && (ctx_r295.beneSelfDetailsForm.get("weight").errors == null ? null : ctx_r295.beneSelfDetailsForm.get("weight").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_div_1_Template, 4, 1, "div", 129);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_div_2_Template, 4, 1, "div", 129);
    i0.ɵɵtemplate(3, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_div_3_Template, 5, 4, "div", 129);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r101 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r101.iscaseRequest ? ctx_r101.currentItemDisplay.includes("RACEDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r101.iscaseRequest ? ctx_r101.currentItemDisplay.includes("RACEDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r101.iscaseRequest ? ctx_r101.currentItemDisplay.includes("RACEDTLS") ? true : false : true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_74_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 416);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r299 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r299.getGlobalErrorMessages("INVALID_FORMAT"), " ");
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_74_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 231);
    i0.ɵɵelementStart(1, "p", 413);
    i0.ɵɵtext(2, "Height(inches)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 414);
    i0.ɵɵtemplate(4, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_74_div_1_span_4_Template, 2, 1, "span", 415);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r297 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r297.beneSelfDetailsForm.get("height").touched || ctx_r297.submitted));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r297.beneSelfDetailsForm.get("height").touched || ctx_r297.submitted) && (ctx_r297.beneSelfDetailsForm.get("height").errors == null ? null : ctx_r297.beneSelfDetailsForm.get("height").errors.pattern));
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_74_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 294);
    i0.ɵɵelementStart(1, "p", 417);
    i0.ɵɵtext(2, "Marks of identification");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 418);
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_74_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_74_div_1_Template, 5, 4, "div", 129);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_74_div_2_Template, 4, 0, "div", 336);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r102.iscaseRequest ? ctx_r102.currentItemDisplay.includes("RACEDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r102.iscaseRequest ? ctx_r102.currentItemDisplay.includes("RACEDTLS") ? true : false : true);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 246);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "h5", 419);
    i0.ɵɵtext(3, "Additional Info");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 59);
    i0.ɵɵelementStart(5, "div", 60);
    i0.ɵɵelementStart(6, "label", 420);
    i0.ɵɵtext(7, "Visa Sponsor");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 421);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_button_78_Template(rf, ctx) { if (rf & 1) {
    const _r301 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 422);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_button_78_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r301); const ctx_r300 = i0.ɵɵnextContext(3); return ctx_r300.backToTask(); });
    i0.ɵɵelement(1, "i", 423);
    i0.ɵɵelementStart(2, "span", 424);
    i0.ɵɵtext(3, " Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_button_83_Template(rf, ctx) { if (rf & 1) {
    const _r303 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 425);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_button_83_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r303); i0.ɵɵnextContext(); const _r60 = i0.ɵɵreference(1); const ctx_r302 = i0.ɵɵnextContext(2); return ctx_r302.clearProfileData(_r60); });
    i0.ɵɵelement(1, "i", 426);
    i0.ɵɵelementStart(2, "span", 427);
    i0.ɵɵtext(3, " Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_84_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵelementStart(1, "h5", 429);
    i0.ɵɵtext(2, "Add passport photocopy ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "lib-simple-file-upload", 244);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r106 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("configurations", ctx_r106.passportfileUploadConfigurations);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_Template(rf, ctx) { if (rf & 1) {
    const _r305 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 113, 114);
    i0.ɵɵlistener("ngSubmit", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r305); const ctx_r304 = i0.ɵɵnextContext(2); return ctx_r304.savePersonalData(true); });
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_2_Template, 3, 1, "div", 3);
    i0.ɵɵelementStart(3, "h5", 115);
    i0.ɵɵtext(4, "About");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_5_Template, 15, 6, "div", 5);
    i0.ɵɵelementStart(6, "div", 68);
    i0.ɵɵelementStart(7, "div", 116);
    i0.ɵɵelementStart(8, "p", 117);
    i0.ɵɵtext(9, "User Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "input", 118);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_11_Template, 5, 1, "div", 119);
    i0.ɵɵtemplate(12, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_12_Template, 6, 7, "div", 119);
    i0.ɵɵtemplate(13, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_13_Template, 5, 4, "div", 119);
    i0.ɵɵtemplate(14, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_14_Template, 6, 7, "div", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_15_Template, 3, 2, "div", 5);
    i0.ɵɵelementStart(16, "div", 68);
    i0.ɵɵtemplate(17, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_17_Template, 4, 1, "div", 120);
    i0.ɵɵtemplate(18, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_18_Template, 8, 3, "div", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 68);
    i0.ɵɵtemplate(20, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_20_Template, 3, 1, "div", 121);
    i0.ɵɵtemplate(21, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_21_Template, 4, 3, "div", 122);
    i0.ɵɵtemplate(22, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_22_Template, 8, 5, "div", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 68);
    i0.ɵɵelementStart(24, "div", 116);
    i0.ɵɵelementStart(25, "p", 123);
    i0.ɵɵtext(26, "USCIS Online Account No");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "input", 124);
    i0.ɵɵtemplate(28, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_span_28_Template, 2, 0, "span", 125);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 116);
    i0.ɵɵelementStart(30, "p", 126);
    i0.ɵɵtext(31, "IRS Tax Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(32, "input", 127);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(33, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_33_Template, 15, 3, "div", 5);
    i0.ɵɵtemplate(34, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_34_Template, 10, 2, "div", 3);
    i0.ɵɵtemplate(35, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_35_Template, 4, 0, "div", 112);
    i0.ɵɵelementStart(36, "div", 29);
    i0.ɵɵtemplate(37, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_37_Template, 4, 2, "div", 128);
    i0.ɵɵtemplate(38, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_38_Template, 4, 2, "div", 129);
    i0.ɵɵtemplate(39, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_39_Template, 5, 2, "div", 129);
    i0.ɵɵtemplate(40, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_40_Template, 4, 0, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "div", 68);
    i0.ɵɵtemplate(42, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_42_Template, 5, 2, "div", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(43, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_43_Template, 14, 3, "div", 0);
    i0.ɵɵtemplate(44, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_44_Template, 4, 3, "div", 0);
    i0.ɵɵtemplate(45, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_45_Template, 4, 0, "div", 112);
    i0.ɵɵelementStart(46, "div", 130);
    i0.ɵɵtemplate(47, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_47_Template, 52, 12, "div", 131);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(48, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_48_Template, 9, 1, "div", 132);
    i0.ɵɵtemplate(49, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_49_Template, 2, 1, "div", 133);
    i0.ɵɵtemplate(50, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_50_Template, 4, 0, "div", 112);
    i0.ɵɵtemplate(51, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_51_Template, 7, 0, "div", 134);
    i0.ɵɵtemplate(52, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_ng_container_52_Template, 3, 1, "ng-container", 0);
    i0.ɵɵelementStart(53, "div", 135);
    i0.ɵɵelementStart(54, "div", 30);
    i0.ɵɵelementStart(55, "div", 136);
    i0.ɵɵelement(56, "mat-divider");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(57, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_57_Template, 9, 4, "div", 137);
    i0.ɵɵtemplate(58, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_58_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(59, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_59_Template, 2, 1, "div", 44);
    i0.ɵɵelementStart(60, "p-accordion", 45);
    i0.ɵɵelementStart(61, "p-accordionTab", 46);
    i0.ɵɵelementStart(62, "p-header");
    i0.ɵɵelementStart(63, "span", 138);
    i0.ɵɵtext(64, " Advanced Details 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(65, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_65_Template, 18, 1, "div", 139);
    i0.ɵɵtemplate(66, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_66_Template, 35, 9, "div", 133);
    i0.ɵɵtemplate(67, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_67_Template, 9, 1, "div", 140);
    i0.ɵɵelementStart(68, "div", 130);
    i0.ɵɵtemplate(69, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_69_Template, 33, 9, "div", 131);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(70, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_70_Template, 2, 1, "div", 112);
    i0.ɵɵtemplate(71, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_71_Template, 3, 1, "div", 5);
    i0.ɵɵtemplate(72, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_72_Template, 4, 1, "div", 141);
    i0.ɵɵtemplate(73, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_73_Template, 4, 3, "div", 5);
    i0.ɵɵtemplate(74, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_74_Template, 3, 2, "div", 5);
    i0.ɵɵtemplate(75, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_75_Template, 9, 0, "div", 112);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(76, "div", 142);
    i0.ɵɵelementStart(77, "div", 64);
    i0.ɵɵtemplate(78, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_button_78_Template, 4, 0, "button", 143);
    i0.ɵɵelementStart(79, "button", 144);
    i0.ɵɵelement(80, "i", 145);
    i0.ɵɵelementStart(81, "span", 146);
    i0.ɵɵtext(82, " Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(83, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_button_83_Template, 4, 0, "button", 147);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(84, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_div_84_Template, 4, 1, "div", 148);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r58.beneSelfDetailsForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r58.isExternalEmployeeId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r58.isShowProfilePic);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("NAME") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("NAME") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("NAME") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("NAME") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("NAME") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("GENDER") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("DOB") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("MOBLNO") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("EMAILID") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB" && (ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("SSN") ? true : false : true));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", (ctx_r58.beneSelfDetailsForm.get("uscisAccNumber").touched || ctx_r58.submitted) && (ctx_r58.beneSelfDetailsForm.get("uscisAccNumber").errors == null ? null : ctx_r58.beneSelfDetailsForm.get("uscisAccNumber").errors.pattern));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB" && (ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("GRNCARDDTLS") ? true : false : true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB" && ctx_r58.beneSelfDetailsForm.get("isLpr").value == 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("BIRTHDTLS") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("BIRTHDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("BIRTHDTLS") ? true : false : true) && ctx_r58.listStatesBirth.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("BIRTHDTLS") ? true : false : true) && ctx_r58.listStatesBirth.length <= 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("BIRTHDTLS") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("BIRTHDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.showCitizenShipAquiredInfo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.showMarriageSection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("CURRADR") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("CURRADR") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("MAILADR") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("MAILADR") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB" && (ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("PASPORTDTLS") ? true : false : true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB" && (ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("PASPORTDTLS") ? true : false : true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r58.beneSelfDetailsForm.get("hasPassport").value);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", (ctx_r58.beneficiaryData == null ? null : ctx_r58.beneficiaryData.id) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.detailsAbout.showDetailFor == "self");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.detailsAbout.showDetailFor !== "self");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selected", false);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("FORADR") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("FORADR") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("PERMADR") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("PERMADR") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB" && ctx_r58.iscaseRequest ? ctx_r58.currentItemDisplay.includes("RACEDTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.onlyFormBuilder !== "FB");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r58.beneUpdateProfile);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r58.editModeVal);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.passportShow);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_div_2_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 431);
    i0.ɵɵtext(1, "Add Additional Documents ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 246);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_div_2_p_1_Template, 2, 0, "p", 430);
    i0.ɵɵelement(2, "file-upload-deafult-library", 244);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r59.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("configurations", ctx_r59.documentFileUploadConfigurations);
} }
const _c3 = function (a0) { return { disabledView: a0 }; };
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_form_1_Template, 85, 48, "form", 111);
    i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_div_2_Template, 3, 2, "div", 112);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, ctx_r1.isViewMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.beneSelfDetailsForm && (ctx_r1.beneficiaryData || ctx_r1.onlyFormBuilder === "FB"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.onlyFormBuilder == "FB" && ctx_r1.beneficiaryId !== 0);
} }
function GenericBeneficiaryPersonalDetailsLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r308 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 432);
    i0.ɵɵelementStart(1, "button", 433);
    i0.ɵɵlistener("click", function GenericBeneficiaryPersonalDetailsLibraryComponent_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r308); const ctx_r307 = i0.ɵɵnextContext(); return ctx_r307.toggleEditView(true); });
    i0.ɵɵelementStart(2, "mat-icon", 434);
    i0.ɵɵtext(3, "add_circle_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "h5", 435);
    i0.ɵɵelementStart(5, "span", 67);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.isDisabled);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("Create ", ctx_r2.beneficiaryData == null ? null : ctx_r2.beneficiaryData.relationShipType == null ? null : ctx_r2.beneficiaryData.relationShipType.name, " Profile");
} }
// @Pipe({name: 'creditCardMask'})
class GenericBeneficiaryPersonalDetailsLibraryComponent {
    constructor(referenceLibraryService, beneSelfFormBuilder, cacheCountryService, toastr, dialog, store, router, route, genericBeneficiaryPersonalDetailsLibraryService) {
        this.referenceLibraryService = referenceLibraryService;
        this.beneSelfFormBuilder = beneSelfFormBuilder;
        this.cacheCountryService = cacheCountryService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.store = store;
        this.router = router;
        this.route = route;
        this.genericBeneficiaryPersonalDetailsLibraryService = genericBeneficiaryPersonalDetailsLibraryService;
        this.isViewMode = false;
        this.updateBenProfile = true;
        this.editDetails = false;
        this.ssn_hide = false;
        this.showAliasName = false;
        this.showforeignAddress = false;
        this.permanentLocality = false;
        this.currentLocality = false;
        this.submitted = false;
        this.listStatesCurrent = [];
        this.listStatesPermanent = [];
        this.listStatesMailing = [];
        this.listStatesForeign = [];
        this.listStatesBirth = [];
        this.listStatesMarriage = [];
        this.showExpiryValidation = false;
        //IM-3402 fix
        this.selectedPermanentCheckbox = false;
        this.selectedCurrentCheckbox = false;
        this.listForeignCountry = [];
        this.showForienAddressMandatory = false;
        this.observableSubscription$ = new Subject();
        this.isBirthStateRequired = false;
        //IM
        this.datesStoredArrayForDisplay = [
            { dob: '' },
            { issueDate: '' },
            { expiryDate: '' },
            { dateRangeFrom: '' }
        ];
        //update for expansion panel
        this.personaldetails = 0;
        this.viewMode = false;
        this.profileEditStatus = new EventEmitter();
        this.personalDetails = new EventEmitter();
        this.beneficiaryIdFromFB1 = new EventEmitter();
        this.hasFamily = new EventEmitter();
        this.isShowProfilePic = true;
        this.isShowVerify = true;
        this.isEditDisabled = false;
        this.passportShow = true;
        this.editModeVal = false;
        this.destroy$ = new Subject();
        this.passportfileUploadConfigurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENPASSDOC',
            entityId: 0,
            fileCategory: 'PASSCOPY',
            listUploadedFiles: [],
            useCase: 'beneficiary',
            useCaseId: 0,
            documentTypeRequired: true,
            docummentTypeCode: 'BENPASSDOC',
            useEntityId: false,
            isDeleteEnabled: sessionStorage.getItem('bene-profile-viewMode') == 'true' ? false : true,
            isUploadEnabled: sessionStorage.getItem('bene-profile-viewMode') == 'true' ? false : true,
            familyId: null
        };
        this.fileUploadConfigurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENGREENCARD',
            entityId: 0,
            fileCategory: 'BENGREENCARD',
            listUploadedFiles: [],
            useCase: 'beneficiary',
            useCaseId: 0,
            documentTypeRequired: true,
            docummentTypeCode: 'BENGREENCARD',
            useEntityId: false,
            isDeleteEnabled: sessionStorage.getItem('bene-profile-viewMode') == 'true' ? false : true,
            isUploadEnabled: sessionStorage.getItem('bene-profile-viewMode') == 'true' ? false : true,
            familyId: null,
            family: false
        };
        this.documentFileUploadConfigurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'FBBENDOC',
            entityId: 0,
            fileCategory: '',
            listUploadedFiles: [],
            documentTypeRequired: true,
            docummentTypeCode: 'FBBENDOC',
            useCase: 'beneficiary',
            useCaseId: 0,
            useEntityId: false,
            isDeleteEnabled: this.viewMode ? false : true,
            isUploadEnabled: this.viewMode ? false : true,
            familyId: null,
            family: false
        };
        this.showDepedentInfo = false;
        this.showMarriageSection = true;
        this.showCitizenShipAquiredInfo = false;
        this.dependentDetailsLoaded = false;
        // lifeStoryTabsLoaded = false;
        this.showAddIcon = false;
        this.referenceLibararyReady = false;
        this.ngOnChangesCalled = false;
        this.loading = false;
        this.beneUpdateProfile = false;
        this.showEditButton = true;
        //selectedTabDetail: any;
        this.isPersonalDetailsFormReset = false;
        this.isDisabled = false;
        this.fbDetails = {
            moduleId: null,
            pageFormId: null,
            employeeCreationType: null,
            employeeDataToBeFilled: null,
            employeeType: null,
            fbEmpId: null
        };
        this.listCountryMarriage = [];
        this.listCountryForeignAdd = [];
        this.currentItemDisplay = [];
        this.iscaseRequest = false;
        this.isBenQuestShowDivs = false;
        this.profilePic = '../../../../../assets/cameraIcon.png';
        this.hasPassportChange = new EventEmitter();
        this.isExternalEmployeeId = sessionStorage.getItem('_isExternalEmployeeId');
        if (this.isExternalEmployeeId) {
            this.isDisabled = true;
        }
        this.missingValueFalg = false;
        this.requiredFields = {};
        this.loading = true;
        this.addressTypeList = [];
        this.maritalTypeList = [];
        this.phoneTypeList = [];
        this.emailTypeList = [];
        this.currentDate = moment__default().format('YYYY-MM-DD');
        this.employeeId = parseInt(this.route.snapshot.queryParams.fbEmpId) ? parseInt(this.route.snapshot.queryParams.fbEmpId) : sessionStorage.getItem('employeeId');
        if (this.route.snapshot.queryParams.hasOwnProperty('fbEmpId')) {
            this.fbEmpId = this.route.snapshot.queryParams.fbEmpId;
        }
        this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
        if (this.onlyFormBuilder === 'FB') {
            this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
        }
        else {
            this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.genericBeneficiaryPersonalDetailsLibraryService.currentUserValue['beneficiaryId'];
        }
        this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            var _a;
            if (((_a = data === null || data === void 0 ? void 0 : data.listCountries) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const transformedCountries = data.listCountries.map(c => (Object.assign(Object.assign({}, c), { labelWithCode: `${c.countryName} - ${c.phoneCode}` })));
                const defaultOption = {
                    countryCode: null,
                    countryName: 'Select',
                    labelWithCode: 'Select',
                    phoneCode: ''
                };
                this.referenceLibraryService.translateArray([defaultOption, ...transformedCountries], 'countryName')
                    .then(translated => {
                    this.listCountry = translated;
                    this.listCountryMarriage = [...this.listCountry];
                    this.listCountryForeignAdd = [...this.listCountry];
                    this.listForeignCountry = [...this.listCountry];
                })
                    .catch(error => console.error("Translation error:", error));
                this.referenceLibraryService.translateArray([defaultOption, ...transformedCountries], 'labelWithCode')
                    .then(translated => {
                    this.listCountryCode = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
        });
        Promise.all([
            this.referenceLibraryService.translateArray(HAIRCOLORS, 'name'),
            this.referenceLibraryService.translateArray(EYECOLORS, 'name')
        ])
            .then(([translatedHairColors, translatedEyeColors]) => {
            this.hairColors = translatedHairColors;
            this.eyeColors = translatedEyeColors;
        })
            .catch(error => console.error("Translation error:", error));
        this.greenCardValidPattern = "^[a-zA-Z{3}0-9]{13}$";
        this.greenCardValidPattern = "^[a-zA-Z]{3}[0-9]{10}$";
        this.certificateNumberValidPattern = "^[a-zA-Z0-9]{8}$";
        this.textOnlyValidPattern = '^[a-zA-Z ]*$';
        // this.listCopyMailAddress = copyAddressLists.MAILING_LIST;
        // this.listCopyFornAddress = copyAddressLists.FOREIGN_LIST;
        // this.listCopyPermAddress = copyAddressLists.PERMANENT_LIST;
        this.listCopyMailAddress = copyAddressLists.MAILING_LIST.filter(item => item.code !== '');
        this.listCopyFornAddress = copyAddressLists.FOREIGN_LIST.filter(item => item.code !== '');
        this.listCopyPermAddress = copyAddressLists.PERMANENT_LIST.filter(item => item.code !== '');
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.beneficiaryId) && !this.beneficiaryId) {
            this.beneficiaryId = (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.beneficiaryId;
        }
        this.companyId = parseInt(sessionStorage.getItem('companyId'));
        if (JSON.parse(localStorage.getItem('customQuestions'))) {
            this.customQuestions = JSON.parse(localStorage.getItem('customQuestions'));
        }
        if (!this.customQuestions) {
            this.beneficiaryId = sessionStorage.getItem('beneficiaryId') ? parseInt(sessionStorage.getItem('beneficiaryId')) : parseInt(sessionStorage.getItem('listBeneficiaryId'));
        }
        if (this.onlyFormBuilder === 'FB' && this.beneficiaryId === 0) {
            this.editDetails = true;
        }
        else {
            this.editDetails = false;
        }
        this.referenceLibraryService.requestDataFromMultipleSources().subscribe(response => {
            this.addressTypeList = response[0].data;
            this.maritalTypeList = response[1].data;
            this.phoneTypeList = response[2].data;
            this.emailTypeList = response[3].data;
            Promise.all([
                this.referenceLibraryService.translateArray(response[4].data, 'name'),
                this.referenceLibraryService.translateArray(response[5].data, 'name'),
                this.referenceLibraryService.translateArray(response[6].data, 'name')
            ])
                .then(([translatedGenders, translatedTitles, translatedMaritalStatuses]) => {
                this.listGender = translatedGenders;
                this.listTitle = translatedTitles;
                this.maritalStatusArr = translatedMaritalStatuses;
            })
                .catch(error => console.error("Translation error:", error));
            this.raceArr = response[7].data;
            this.familyRelTypeArr = response[8].data;
            this.citizenshipAcquiredArr = response[9].data;
            this.ethinicityArr = response[10].data;
            this.referenceLibararyReady = true;
            this.setvalidatations();
            this.afterOnChangesAndReferenceLibraryLoaded();
            this.loading = false;
            this.updatePassportFormControl(false);
            this.hidePasspportDetails();
        });
        if (this.passportShow && (this.beneficiaryId || ((_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.beneficiaryId) || ((_d = this.primaryData) === null || _d === void 0 ? void 0 : _d.sponsorId))) {
            this.passportfileUploadConfigurations.entityId = this.beneficiaryId || ((_e = this.primaryData) === null || _e === void 0 ? void 0 : _e.beneficiaryId) || ((_f = this.primaryData) === null || _f === void 0 ? void 0 : _f.sponsorId);
            this.passportfileUploadConfigurations.useCaseId = this.beneficiaryId || ((_g = this.primaryData) === null || _g === void 0 ? void 0 : _g.beneficiaryId) || ((_h = this.primaryData) === null || _h === void 0 ? void 0 : _h.sponsorId);
            this.passportfileUploadConfigurations = Object.assign({}, this.passportfileUploadConfigurations);
            this.getUpolodedFiles();
        }
        this.beneficiaryProfileUpdate = sessionStorage.getItem('bene-update-profile');
        if (this.beneficiaryProfileUpdate === 'true') {
            this.beneUpdateProfile = true;
        }
        this.showEditButton = !this.genericBeneficiaryPersonalDetailsLibraryService.checkValidity();
        this.viewMode = sessionStorage.getItem('bene-profile-viewMode') == 'true' ? true : false;
        this.genericBeneficiaryPersonalDetailsLibraryService.currentUser.pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            if (sessionStorage.getItem('userTypeRole') === copyAddressLists.ATTORNEY || sessionStorage.getItem('userTypeRole') === copyAddressLists.PETITIONER) {
                this.updateBenProfile = this.genericBeneficiaryPersonalDetailsLibraryService.checkBeneEditPermission();
                this.viewMode = !this.updateBenProfile;
                this.fileUploadConfigurations = Object.assign(Object.assign({}, this.fileUploadConfigurations), { isDeleteEnabled: !this.viewMode, isUploadEnabled: !this.viewMode });
                this.documentFileUploadConfigurations = Object.assign(Object.assign({}, this.documentFileUploadConfigurations), { isDeleteEnabled: !this.viewMode, isUploadEnabled: !this.viewMode });
            }
        });
        this.genericBeneficiaryPersonalDetailsLibraryService.profilePicUpdate.subscribe((obj) => {
            this.profilePic = obj.hasImage ? `data:image/jpeg;base64,${obj.image}` : '../../../../../assets/cameraIcon.png';
        });
        this.genericBeneficiaryPersonalDetailsLibraryService.onLifeStorySubTabs.subscribe(() => {
            // this.lifeStoryTabsLoaded = true;
            this.triggerChangeDependentProfileID();
        });
        if (this.onlyFormBuilder === 'FB') {
            this.getFBEmployeeDetails();
        }
    }
    getFBEmployeeDetails() {
        if ((this.fbDetails && this.fbDetails.fbEmpId === null) || !this.fbEmpId) {
            this.genericBeneficiaryPersonalDetailsLibraryService.getFBEmployeeDetails(this.fbEmpId).subscribe((data) => {
                this.fbDetails = {
                    moduleId: data.moduleId,
                    pageFormId: data.pageFormId,
                    employeeCreationType: data.employeeCreationType,
                    employeeDataToBeFilled: data.employeeDataToBeFilled,
                    employeeType: data.employeeType,
                    fbEmpId: this.fbEmpId
                };
                this.getformBuilderDetails();
            });
        }
        else {
            this.getformBuilderDetails();
        }
    }
    // initData() {
    //   // return new Promise((resolve, reject) => {
    //   //   const request1 = this.referenceLibraryService.getReferenceData('ADDR');
    //   //   const request2 = this.referenceLibraryService.getReferenceData('MARSTAT');
    //   //   const request3 = this.referenceLibraryService.getReferenceData('PHON');
    //   //   const request4 = this.referenceLibraryService.getReferenceData('EMLTYP');
    //   //   const request5 = this.referenceLibraryService.getReferenceData('GENDER');
    //   //   const request6 = this.referenceLibraryService.getReferenceData('TITL');
    //   //   const request7 = this.referenceLibraryService.getGroupReferenceData('MARSTAT');
    //   //   const request8 = this.referenceLibraryService.getGroupReferenceData('RACE');
    //   //   const request9 = this.referenceLibraryService.getGroupReferenceData('FAMRELTYP');
    //   //   const request10 = this.referenceLibraryService.getGroupReferenceData('CTZNACQRTYP');
    //   //   const request11 = this.referenceLibraryService.getGroupReferenceData('ETHNICITY');
    //   //   forkJoin([request1, request2, request3, request4, request5, request6, request7, request8, request9, request10, request11]).subscribe(
    //   //     ([response1, response2, response3, response4, response5, response6, response7, response8, response9, response10, response11]) => {
    //   //       this.addressTypeList = <ReferenceLibrary[]>response1;
    //   //       this.maritalTypeList = <ReferenceLibrary[]>response2;
    //   //       this.phoneTypeList = <ReferenceLibrary[]>response3;
    //   //       this.emailTypeList = <ReferenceLibrary[]>response4;
    //   //       this.listGender = <ReferenceLibrary[]>response5;
    //   //       this.listTitle = <ReferenceLibrary[]>response6;
    //   //       this.maritalStatusArr = <ReferenceLibrary[]>response7;
    //   //       this.raceArr = <ReferenceLibrary[]>response8;
    //   //       this.familyRelTypeArr = <ReferenceLibrary[]>response9;
    //   //       this.citizenshipAcquiredArr = <ReferenceLibrary[]>response10;
    //   //       this.ethinicityArr = <ReferenceLibrary[]>response11;
    //   //       this.referenceLibararyReady = true;
    //   //       this.afterOnChangesAndReferenceLibraryLoaded();
    //   //       this.setvalidatations();
    //   //       this.loading = false;
    //   //       resolve(true);
    //   //     })
    //   // })
    // }
    setvalidatations() {
        if (!this.iscaseRequest) {
            this.beneSelfDetailsForm = this.beneSelfFormBuilder.group({
                id: [],
                userName: [''],
                visaSponsor: [''],
                fName: ['', Validators.required],
                mName: [''],
                lName: ['', Validators.required],
                title: [''],
                aliasName: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        fName: [''],
                        title: [''],
                        id: ['']
                    })
                ]),
                gender: this.beneSelfFormBuilder.group({
                    id: [''],
                    name: [''],
                }),
                dob: [''],
                ssn: [''],
                uscisAccNumber: ['', [Validators.pattern(/^[0-9]*$/)]],
                itin: [''],
                emailContacts: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        email: ['', [Validators.required, Validators.email]],
                        id: [''],
                        type: this.beneSelfFormBuilder.group({
                            code: ['PRIM'],
                            id: [this.emailTypeList.find(x => x.code === 'PRIM') ? this.emailTypeList.find(x => x.code === 'PRIM').id : null]
                        })
                    })
                ]),
                phoneContacts: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        phoneNo: ['', [Validators.pattern(/^-?(0|[0-9]\d*)?$/)]],
                        id: [''],
                        type: this.beneSelfFormBuilder.group({
                            code: ['MOBL'],
                            id: [this.phoneTypeList.find(x => x.code === 'MOBL') ? this.phoneTypeList.find(x => x.code === 'MOBL').id : null]
                        }),
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: [''],
                            phoneCode: ['']
                        })
                    })
                ]),
                address: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: ['', [Validators.pattern(/^[a-zA-Z0-9 ]+$/)]],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [null],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'CURR') ? this.addressTypeList.find(x => x.code === 'CURR').id : null],
                            code: ['CURR']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: ['', [Validators.pattern(/^[a-zA-Z0-9 ]+$/)]],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [null],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'MAIL') ? this.addressTypeList.find(x => x.code === 'MAIL').id : null],
                            code: ['MAIL']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: ['', [Validators.pattern(/^[a-zA-Z0-9 ]+$/)]],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [null],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'FORN') ? this.addressTypeList.find(x => x.code === 'FORN').id : null],
                            code: ['FORN']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: ['', [Validators.pattern(/^[a-zA-Z0-9 ]+$/)]],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [null],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'PERM') ? this.addressTypeList.find(x => x.code === 'PERM').id : null],
                            code: ['PERM']
                        })
                    })
                ]),
                identificationMark: [''],
                height: ['', [Validators.pattern(/^[1-9]\d*(\.\d+)?$/)]],
                hairColor: [''],
                skinColor: [''],
                eyeColor: [''],
                countryCode: this.beneSelfFormBuilder.group({
                    countryCode: ['']
                }),
                birthStateProvinceCode: [null],
                birthStateProvinceName: [''],
                birthCity: [''],
                ctznshipCountryCode: this.beneSelfFormBuilder.group({
                    countryName: null,
                    countryCode: ['']
                }),
                hasPassport: [false],
                passport: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        id: [''],
                        passportNo: [''],
                        issueDate: [''],
                        expiryDate: [''],
                        issueCountryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        })
                    })
                ]),
                currentVisaStatus: null,
                profileImage: null,
                smallProfileImage: null,
                profilePic: null,
                smallProfilePic: null,
                firstAndLastName: null,
                // maritalStatus:null,
                maritalStatus: this.beneSelfFormBuilder.group({
                    id: [null],
                    name: [''],
                }),
                cpyFromMailAddress: this.beneSelfFormBuilder.group({
                    mailCode: [''],
                    name: [''],
                }),
                cpyFromPermAddress: this.beneSelfFormBuilder.group({
                    permCode: [''],
                    name: [''],
                }),
                cpyFromFrnAddress: this.beneSelfFormBuilder.group({
                    frnCode: [''],
                    name: [''],
                }),
                countryOfMarriage: this.beneSelfFormBuilder.group({
                    countryCode: ['']
                }),
                marriageStateProvinceCode: [null],
                marriageStateProvinceName: [''],
                cityOfMarriage: [''],
                // relationShipType:this.beneSelfFormBuilder.group({
                //   id: [''],
                //   name: [''],
                // }),
                isLpr: [null],
                lprThruMarriage: null,
                greenCardNo: ['', [Validators.pattern(this.greenCardValidPattern)]],
                // ethnicity:[],
                ethnicity: this.beneSelfFormBuilder.group({
                    ethnicityId: [],
                    name: ['']
                }),
                race: this.beneSelfFormBuilder.array([
                //  this.beneSelfFormBuilder.group({
                //    id: [''],
                //   raceId: this.beneSelfFormBuilder.group({
                //     id: [''],
                //     name: ['']
                //   })
                // })
                ]),
                weight: ['', [Validators.pattern(/^[1-9]\d*(\.\d+)?$/)]],
                ctznAcqrTypeId: this.beneSelfFormBuilder.group({
                    ctznAcqrId: [''],
                    name: ['']
                }),
                hasCtznCrtfct: [false],
                ctznCrtfctNo: [''],
                ctznCrtfctIssPlace: [''],
                ctznCrtfctIssDate: [null],
                marriageDate: [null]
            });
        }
        else {
            this.beneSelfDetailsForm = this.beneSelfFormBuilder.group({
                id: [],
                userName: [],
                visaSponsor: [''],
                fName: [''],
                mName: [''],
                lName: [''],
                title: [''],
                aliasName: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        fName: [''],
                        title: [''],
                        id: ['']
                    })
                ]),
                gender: this.beneSelfFormBuilder.group({
                    id: [''],
                    name: [''],
                }),
                dob: [''],
                ssn: [''],
                uscisAccNumber: ['', [Validators.pattern(/^[0-9]*$/)]],
                itin: [''],
                emailContacts: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        email: [''],
                        id: [''],
                        type: this.beneSelfFormBuilder.group({
                            code: ['PRIM'],
                            id: [this.emailTypeList.find(x => x.code === 'PRIM') ? this.emailTypeList.find(x => x.code === 'PRIM').id : null]
                        })
                    })
                ]),
                phoneContacts: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        phoneNo: [''],
                        id: [''],
                        type: this.beneSelfFormBuilder.group({
                            code: ['MOBL'],
                            id: [this.phoneTypeList.find(x => x.code === 'MOBL') ? this.phoneTypeList.find(x => x.code === 'MOBL').id : null]
                        }),
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: [''],
                            phoneCode: ['']
                        })
                    })
                ]),
                address: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: [''],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [''],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'CURR') ? this.addressTypeList.find(x => x.code === 'CURR').id : null],
                            code: ['CURR']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: [''],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [''],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'MAIL') ? this.addressTypeList.find(x => x.code === 'MAIL').id : null],
                            code: ['MAIL']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: [''],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [''],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'FORN') ? this.addressTypeList.find(x => x.code === 'FORN').id : null],
                            code: ['FORN']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: ['', Validators.pattern(/^[a-zA-Z0-9 ]+$/)],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [null],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'PERM') ? this.addressTypeList.find(x => x.code === 'PERM').id : null],
                            code: ['PERM']
                        })
                    })
                ]),
                identificationMark: [''],
                height: [''],
                hairColor: [''],
                skinColor: [''],
                eyeColor: [''],
                countryCode: this.beneSelfFormBuilder.group({
                    countryCode: ['']
                }),
                birthStateProvinceCode: [null],
                birthStateProvinceName: [''],
                birthCity: [''],
                ctznshipCountryCode: this.beneSelfFormBuilder.group({
                    countryName: null,
                    countryCode: [null]
                }),
                hasPassport: [false],
                passport: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        id: [''],
                        passportNo: [''],
                        issueDate: [''],
                        expiryDate: [''],
                        issueCountryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        })
                    })
                ]),
                currentVisaStatus: null,
                profileImage: null,
                smallProfileImage: null,
                profilePic: null,
                smallProfilePic: null,
                firstAndLastName: null,
                // maritalStatus:null,
                maritalStatus: this.beneSelfFormBuilder.group({
                    id: [''],
                    name: [''],
                }),
                cpyFromMailAddress: this.beneSelfFormBuilder.group({
                    mailCode: [''],
                    name: [''],
                }),
                cpyFromPermAddress: this.beneSelfFormBuilder.group({
                    permCode: [''],
                    name: [''],
                }),
                cpyFromFrnAddress: this.beneSelfFormBuilder.group({
                    frnCode: [''],
                    name: [''],
                }),
                countryOfMarriage: this.beneSelfFormBuilder.group({
                    countryCode: ['']
                }),
                marriageStateProvinceCode: [null],
                marriageStateProvinceName: [''],
                cityOfMarriage: [''],
                // relationShipType:this.beneSelfFormBuilder.group({
                //   id: [''],
                //   name: [''],
                // }),
                isLpr: [''],
                lprThruMarriage: null,
                greenCardNo: ['', Validators.pattern(this.greenCardValidPattern)],
                // ethnicity:[],
                ethnicity: this.beneSelfFormBuilder.group({
                    ethnicityId: [],
                    name: ['']
                }),
                race: this.beneSelfFormBuilder.array([
                //  this.beneSelfFormBuilder.group({
                //    id: [''],
                //   raceId: this.beneSelfFormBuilder.group({
                //     id: [''],
                //     name: ['']
                //   })
                // })
                ]),
                weight: [''],
                ctznAcqrTypeId: this.beneSelfFormBuilder.group({
                    ctznAcqrId: [''],
                    name: ['']
                }),
                hasCtznCrtfct: [false],
                ctznCrtfctNo: [''],
                ctznCrtfctIssPlace: ['', Validators.pattern(this.textOnlyValidPattern)],
                ctznCrtfctIssDate: [null],
                marriageDate: [null]
            });
        }
        if (this.onlyFormBuilder === 'FB') {
            this.beneSelfDetailsForm.get('isLpr').clearValidators();
            this.beneSelfDetailsForm.get('isLpr').updateValueAndValidity();
        }
        this.formStatusCheck();
    }
    hidePasspportDetails() {
        if (this.beneSelfDetailsForm.get('hasPassport').value === true && this.onlyFormBuilder === 'FB') {
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueCountryCode']['controls']['countryCode'].clearValidators();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['expiryDate'].clearValidators();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueDate'].clearValidators();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['passportNo'].clearValidators();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueCountryCode']['controls']['countryCode'].updateValueAndValidity();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['expiryDate'].updateValueAndValidity();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueDate'].updateValueAndValidity();
            // this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['passportNo'].updateValueAndValidity();
        }
    }
    updatePassportFormControl(event) {
        var _a, _b, _c;
        if (!event.checked && this.beneficiaryType === 'self') {
            if (!this.iscaseRequest) {
                // this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueCountryCode']['controls']['countryCode'].setValidators(Validators.required);
                // this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['expiryDate'].setValidators(Validators.required);
                // this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueDate'].setValidators(Validators.required);
                // this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['passportNo'].setValidators(Validators.required);
            }
        }
        else {
            if ((((_a = this.beneficiaryData) === null || _a === void 0 ? void 0 : _a.passport) && !((_b = this.beneficiaryData) === null || _b === void 0 ? void 0 : _b.passport.length)) || ((_c = this.beneficiaryData) === null || _c === void 0 ? void 0 : _c.passport) === null) {
                this.beneSelfDetailsForm.patchValue({
                    passport: [{
                            id: 0,
                            issueCountryCode: {
                                countryCode: null
                            },
                            expiryDate: '',
                            issueDate: '',
                            passportNo: ''
                        }]
                });
            }
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueCountryCode']['controls']['countryCode'].clearValidators();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['expiryDate'].clearValidators();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueDate'].clearValidators();
            this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['passportNo'].clearValidators();
        }
        this.translet();
        this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueCountryCode']['controls']['countryCode'].updateValueAndValidity();
        this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['expiryDate'].updateValueAndValidity();
        this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['issueDate'].updateValueAndValidity();
        this.beneSelfDetailsForm.get('passport')['controls'][0]['controls']['passportNo'].updateValueAndValidity();
        this.hasPassportChange.emit(!event.checked);
    }
    addRaceArrayFormControl() {
        const raceOptionArray = this.beneSelfDetailsForm.get('race');
        //   for(let i = raceOptionArray.length-1; i >= 0; i--) {
        //     raceOptionArray.removeAt(i)
        //  }
        raceOptionArray.clear();
        // this.raceArr.forEach(() => {
        //   raceOptionArray.push(createNewRaceControl());
        // });
        if (this.raceArr && this.raceArr.length > 0) {
            this.raceArr.forEach((x, index) => {
                const raceChecked = this.beneficiaryData.race && this.beneficiaryData.race.length > 0 && this.beneficiaryData.race.some(y => y.raceId.id === x.id);
                // raceOptionArray.push(this.createNewRaceControl(x)); // new FormControl(false)
                raceOptionArray.push(new FormControl(raceChecked));
            });
        }
    }
    ngOnChanges(changes) {
        var _a, _b, _c;
        if ((_a = changes.type) === null || _a === void 0 ? void 0 : _a.currentValue) {
            this.beneficiaryType = changes.type.currentValue;
        }
        if ((_b = changes.formDetails) === null || _b === void 0 ? void 0 : _b.currentValue) {
            this.parsedJsonData = changes.formDetails.currentValue;
            if (!this.beneSelfDetailsForm) {
                this.setvalidatations();
            }
            else {
                this.getBeneficiaryDetails();
            }
        }
        if (JSON.parse(localStorage.getItem('customQuestions'))) {
            this.customQuestions = JSON.parse(localStorage.getItem('customQuestions'));
        }
        this.beneUpdateProfile = this.updateEditButtonStatus;
        this.ngOnChangesCalled = true;
        this.afterOnChangesAndReferenceLibraryLoaded();
        if ((_c = changes === null || changes === void 0 ? void 0 : changes.editMode) === null || _c === void 0 ? void 0 : _c.currentValue) {
            this.editModeVal = true;
        }
        if (changes.customQuestionsDisplay && changes.customQuestionsDisplay.currentValue) {
            this.customQuestions = changes.customQuestionsDisplay.currentValue;
        }
        if ((sessionStorage.getItem('isCaseRequest') || (changes.caseRequestShowDivs && changes.caseRequestShowDivs.currentValue)) || (localStorage.getItem('selectedBeneData') || (changes.benQuestShowDivs && changes.benQuestShowDivs.currentValue))) {
            if (changes.caseRequestShowDivs && changes.caseRequestShowDivs.currentValue) {
                this.iscaseRequest = true;
                changes.caseRequestShowDivs.currentValue.subLevel.forEach(element => {
                    this.currentItemDisplay.push(element.code);
                });
            }
            if (changes.benQuestShowDivs && changes.benQuestShowDivs.currentValue) {
                this.isBenQuestShowDivs = true;
                changes.benQuestShowDivs.currentValue.subLevel.forEach(element => {
                    this.currentItemDisplay.push(element.code);
                });
            }
            this.beneSelfDetailsForm = this.beneSelfFormBuilder.group({
                id: [],
                userName: [''],
                visaSponsor: [''],
                fName: [''],
                mName: [''],
                lName: [''],
                title: [''],
                aliasName: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        fName: [''],
                        title: [''],
                        id: ['']
                    })
                ]),
                gender: this.beneSelfFormBuilder.group({
                    id: [''],
                    name: [''],
                }),
                dob: [''],
                ssn: [''],
                uscisAccNumber: ['', [Validators.pattern(/^[0-9]*$/)]],
                itin: [''],
                emailContacts: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        email: [''],
                        id: [''],
                        type: this.beneSelfFormBuilder.group({
                            code: ['PRIM'],
                            id: [this.emailTypeList.find(x => x.code === 'PRIM') ? this.emailTypeList.find(x => x.code === 'PRIM').id : null]
                        })
                    })
                ]),
                phoneContacts: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        phoneNo: [''],
                        id: [''],
                        type: this.beneSelfFormBuilder.group({
                            code: ['MOBL'],
                            id: [this.phoneTypeList.find(x => x.code === 'MOBL') ? this.phoneTypeList.find(x => x.code === 'MOBL').id : null]
                        }),
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: [''],
                            phoneCode: ['']
                        })
                    })
                ]),
                address: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: [''],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [''],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'CURR') ? this.addressTypeList.find(x => x.code === 'CURR').id : null],
                            code: ['CURR']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: [''],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [''],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'MAIL') ? this.addressTypeList.find(x => x.code === 'MAIL').id : null],
                            code: ['MAIL']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: [''],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [''],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'FORN') ? this.addressTypeList.find(x => x.code === 'FORN').id : null],
                            code: ['FORN']
                        })
                    }),
                    this.beneSelfFormBuilder.group({
                        addressLine1: [''],
                        addressLine2: [''],
                        postCode: ['', Validators.pattern(/^[a-zA-Z0-9 ]+$/)],
                        doorNo: [''],
                        id: [''],
                        streetNo: [''],
                        countryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        }),
                        stateProvinceCode: [null],
                        stateProvinceName: [''],
                        city: [''],
                        locality: [''],
                        inCareOfName: [''],
                        county: [''],
                        dateRangeFrom: [''],
                        type: this.beneSelfFormBuilder.group({
                            id: [this.addressTypeList.find(x => x.code === 'PERM') ? this.addressTypeList.find(x => x.code === 'PERM').id : null],
                            code: ['PERM']
                        })
                    })
                ]),
                identificationMark: [''],
                height: [''],
                hairColor: [''],
                skinColor: [''],
                eyeColor: [''],
                countryCode: this.beneSelfFormBuilder.group({
                    countryCode: ['']
                }),
                birthStateProvinceCode: [null],
                birthStateProvinceName: [''],
                birthCity: [''],
                ctznshipCountryCode: this.beneSelfFormBuilder.group({
                    countryName: null,
                    countryCode: [null]
                }),
                hasPassport: [false],
                passport: this.beneSelfFormBuilder.array([
                    this.beneSelfFormBuilder.group({
                        id: [''],
                        passportNo: [''],
                        issueDate: [''],
                        expiryDate: [''],
                        issueCountryCode: this.beneSelfFormBuilder.group({
                            countryCode: ['']
                        })
                    })
                ]),
                currentVisaStatus: null,
                profileImage: null,
                smallProfileImage: null,
                profilePic: null,
                smallProfilePic: null,
                firstAndLastName: null,
                // maritalStatus:null,
                maritalStatus: this.beneSelfFormBuilder.group({
                    id: [''],
                    name: [''],
                }),
                cpyFromMailAddress: this.beneSelfFormBuilder.group({
                    mailCode: [''],
                    name: [''],
                }),
                cpyFromPermAddress: this.beneSelfFormBuilder.group({
                    permCode: [''],
                    name: [''],
                }),
                cpyFromFrnAddress: this.beneSelfFormBuilder.group({
                    frnCode: [''],
                    name: [''],
                }),
                countryOfMarriage: this.beneSelfFormBuilder.group({
                    countryCode: ['']
                }),
                marriageStateProvinceCode: [null],
                marriageStateProvinceName: [''],
                cityOfMarriage: [''],
                // relationShipType:this.beneSelfFormBuilder.group({
                //   id: [''],
                //   name: [''],
                // }),
                isLpr: [''],
                lprThruMarriage: null,
                greenCardNo: ['', Validators.pattern(this.greenCardValidPattern)],
                // ethnicity:[],
                ethnicity: this.beneSelfFormBuilder.group({
                    ethnicityId: [],
                    name: ['']
                }),
                race: this.beneSelfFormBuilder.array([
                //  this.beneSelfFormBuilder.group({
                //    id: [''],
                //   raceId: this.beneSelfFormBuilder.group({
                //     id: [''],
                //     name: ['']
                //   })
                // })
                ]),
                weight: [''],
                ctznAcqrTypeId: this.beneSelfFormBuilder.group({
                    ctznAcqrId: [''],
                    name: ['']
                }),
                hasCtznCrtfct: [false],
                ctznCrtfctNo: [''],
                ctznCrtfctIssPlace: ['', Validators.pattern(this.textOnlyValidPattern)],
                ctznCrtfctIssDate: [null],
                marriageDate: [null]
            });
        }
        else {
            this.iscaseRequest = false;
        }
    }
    afterOnChangesAndReferenceLibraryLoaded() {
        var _a, _b, _c, _d, _e;
        if (this.referenceLibararyReady && this.ngOnChangesCalled) {
            this.beneficiaryType = this.detailsAbout.showDetailFor === 'self' ? 'self' : 'family';
            if (this.isBenQuestShowDivs && sessionStorage.getItem('isCaseRequest')) {
                if (this.beneficiaryType === 'self') {
                    this.iscaseRequest = true;
                }
                else {
                    this.iscaseRequest = false;
                }
            }
            if (!this.beneSelfDetailsForm || this.beneficiaryType === 'self') {
                this.setvalidatations();
            }
            else if (this.beneficiaryType === 'family') {
                //Remove validation for Family and Other dependents
                this.removeValidations(this.beneSelfDetailsForm);
                this.applyForeignAddressValidation(null, null, 2);
            }
            this.showMarriageSection = this.detailsAbout && ((_a = this.detailsAbout) === null || _a === void 0 ? void 0 : _a.dependentType) && ((_c = (_b = this.detailsAbout) === null || _b === void 0 ? void 0 : _b.dependentType) === null || _c === void 0 ? void 0 : _c.code) ? !['SPOUSE'].includes((_e = (_d = this.detailsAbout) === null || _d === void 0 ? void 0 : _d.dependentType) === null || _e === void 0 ? void 0 : _e.code) : true;
            if (this.detailsAbout.showDetailFor === 'self') {
                if (this.onlyFormBuilder === 'FB') {
                    this.getFBEmployeeDetails();
                }
                else {
                    this.getBeneficiaryDetails();
                }
            }
            else {
                this.getBeneficiaryFamilyDetails();
            }
        }
    }
    createNewRaceControl(item) {
        return new FormGroup({
            id: new FormControl(0),
            raceId: new FormGroup({
                id: new FormControl(item.id ? item.id : null),
                name: new FormControl(item.name ? item.name : null),
                checked: new FormControl(false)
            }),
        });
    }
    ngAfterViewInit() {
        // this.helpVideoComponent.setValues('right', 'Building Beneficiary Profile', 'Building Beneficiary Profile');
        this.cacheCountryService.getCountry()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(data => {
            var _a;
            if (((_a = data === null || data === void 0 ? void 0 : data.listCountries) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const transformedCountries = data.listCountries.map(c => (Object.assign(Object.assign({}, c), { labelWithCode: `${c.countryName} - ${c.phoneCode}` })));
                const defaultOption = {
                    countryCode: null,
                    countryName: 'Select',
                    labelWithCode: 'Select',
                    phoneCode: ''
                };
                this.referenceLibraryService.translateArray([defaultOption, ...transformedCountries], 'countryName')
                    .then(translated => {
                    this.listCountry = translated;
                    this.listCountryMarriage = [...this.listCountry];
                    this.listCountryForeignAdd = [...this.listCountry];
                    this.listForeignCountry = [...this.listCountry];
                })
                    .catch(error => console.error("Translation error:", error));
                this.referenceLibraryService.translateArray([defaultOption, ...transformedCountries], 'labelWithCode')
                    .then(translated => {
                    this.listCountryCode = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
        });
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 1000);
    }
    onRefreshPage(event) {
        if (event) {
            this.ngOnInit();
        }
    }
    formStatusCheck() {
        this.formChangesSubscription = this.beneSelfDetailsForm.valueChanges.pipe(map$1(() => this.beneSelfDetailsForm.dirty && this.beneSelfDetailsForm.enabled), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true,
                    message: "If you leave before saving, all changes made on the 'Profile Details' form will be lost. Do you wish to continue?"
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false,
                    message: ""
                }));
            }
        });
    }
    // To Verify Missing Fields
    handleVerify() {
        this.missingValueFalg = false;
        this.requiredFields = {
            fName: true,
            lName: true,
            email: false,
        };
        if (!this.iterateRequiredFileds(this.requiredFields, null)) {
            this.toastr.success('Fields validation is successful', 'Success');
        }
        else {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Check the missing fields');
        }
    }
    iterateRequiredFileds(obj, parentKey) {
        if (!this.missingValueFalg) {
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (parentKey) {
                        // for object inside Obj
                        if (obj[key]
                            && (this.beneficiaryData[parentKey] === null ||
                                this.beneficiaryData[parentKey][key] === null ||
                                this.beneficiaryData[parentKey][key] === undefined ||
                                this.beneficiaryData[parentKey][key] === '')) {
                            this.missingValueFalg = true;
                            break;
                        }
                    }
                    else {
                        if (obj[key] && (this.beneficiaryData[key] === null ||
                            this.beneficiaryData[key] === undefined ||
                            this.beneficiaryData[key] === '')) {
                            this.missingValueFalg = true;
                            break;
                        }
                    }
                }
            }
        }
        return this.missingValueFalg;
    }
    handleEdit() {
        if (this.isPersonalDetailsFormReset) {
            this.setBeneficiaryFormData();
        }
        this.editDetails = !this.editDetails;
        this.beneSelfDetailsForm.enable();
        this.updatePassportFormControl({ checked: this.beneSelfDetailsForm.get('hasPassport').value });
        if (this.editDetails) {
            this.beneSelfDetailsForm.patchValue({
                cpyFromMailAddress: { mailCode: null },
                cpyFromFrnAddress: { frnCode: null },
                cpyFromPermAddress: { permCode: null }
            });
        }
        this.editDetails ? this.subscribeValueChanges() : this.unSubscribeValueChanges();
        if (this.editDetails) {
            this.profileEditStatus.emit(true);
        }
        else {
            this.profileEditStatus.emit(false);
        }
        this.translet();
    }
    subscribeValueChanges() {
        this.subscription = this.beneSelfDetailsForm.valueChanges
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((values) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            this.showforeignAddress = ((_c = (_b = (_a = values.address) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.countryCode) === null || _c === void 0 ? void 0 : _c.countryCode) === 'USA' &&
                ((_f = (_e = (_d = values.address) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.countryCode) === null || _f === void 0 ? void 0 : _f.countryCode) === 'USA';
            this.currentLocality = ((_j = (_h = (_g = values.address) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.countryCode) === null || _j === void 0 ? void 0 : _j.countryCode) === 'IND';
            this.permanentLocality = ((_m = (_l = (_k = values.address) === null || _k === void 0 ? void 0 : _k[1]) === null || _l === void 0 ? void 0 : _l.countryCode) === null || _m === void 0 ? void 0 : _m.countryCode) === 'IND';
        });
    }
    // subscribeValueChanges() {
    //   this.subscription = this.beneSelfDetailsForm.valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe((values) => {
    //     this.showforeignAddress = values.address['0']['countryCode']['countryCode'] === 'USA' && values.address['1']['countryCode']['countryCode'] === 'USA';
    //     this.currentLocality = values.address['0']['countryCode']['countryCode'] === 'IND';
    //     this.permanentLocality = values.address['1']['countryCode']['countryCode'] === 'IND';
    //   });
    // }
    maskify(cc) {
        return cc.slice(0, -4).replace(/./g, '#') + cc.slice(-4);
    }
    patch(group, stateIndex, addType) {
        if (group.countryCode.countryCode) {
            this.handleCountryChange(group.countryCode.countryCode, stateIndex);
        }
        if (addType === 'Foreign') {
            const foreignAddress = this.getAddress('FORN');
            const foreignAddressType = foreignAddress.value.type;
            const foreignAddressID = foreignAddress.value.id;
            foreignAddress.setValue(group);
            foreignAddress.patchValue({
                id: foreignAddressID,
                type: foreignAddressType
            });
        }
        else if (addType === 'Mailing') {
            const mailAddress = this.getAddress('MAIL');
            const mailAddressType = mailAddress.value.type;
            const mailAddressID = mailAddress.value.id;
            mailAddress.setValue(group);
            mailAddress.patchValue({
                id: mailAddressID,
                type: mailAddressType
            });
        }
        else if (addType === 'Permanent') {
            const permAddress = this.getAddress('PERM');
            const permAddressType = permAddress.value.type;
            const permAddressID = permAddress.value.id;
            permAddress.setValue(group);
            permAddress.patchValue({
                id: permAddressID,
                type: permAddressType
            });
        }
    }
    unSubscribeValueChanges() {
        this.subscription.unsubscribe();
    }
    clearProfileData(myForm) {
        this.selectedCurrentCheckbox = false;
        this.selectedPermanentCheckbox = false;
        this.isPersonalDetailsFormReset = true;
        this.beneSelfDetailsForm.disable();
        myForm.resetForm();
        this.editDetails = !this.editDetails;
        this.profileEditStatus.emit(this.editDetails);
        this.setvalidatations();
        this.translet();
    }
    checkForeignAddress() {
        let currAddress = this.getAddress('CURR');
        let permAddress = this.getAddress('PERM');
        let ca = currAddress['value']['countryCode']['countryCode'];
        let pa = permAddress['value']['countryCode']['countryCode'];
        if (ca != 'USA') {
            this.patch(currAddress['value'], 'Current', 'Foreign');
        }
        else if (ca === 'USA' && pa != 'USA') {
            this.patch(permAddress['value'], 'Permanent', 'Foreign');
        }
    }
    getBeneficiaryDetails() {
        var _a, _b, _c, _d;
        if (this.primaryData) {
            let orderedArr = [];
            if (!this.parsedJsonData) {
                let url = this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails((this.beneficiaryId || ((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.beneficiaryId) || ((_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.sponsorId)), 'self');
                if (this.primaryData && ((_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.familyId) && this.type === 'family') {
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails((this.beneficiaryId || ((_d = this.primaryData) === null || _d === void 0 ? void 0 : _d.sponsorId)), 'family', this.primaryData.familyId);
                }
                url.pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
                    orderedArr.push(this.emptyAddress('Current'), this.emptyAddress('Foreign'));
                    if (beneficiary) {
                        this.beneficiaryData = this.primaryData && this.primaryData.familyId && this.type === 'family' ? beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.find(member => member.id === this.primaryData.familyId) : beneficiary;
                        if (!((_a = this.beneficiaryData) === null || _a === void 0 ? void 0 : _a.countryCode)) {
                            this.beneficiaryData.countryCode = beneficiary.countryCode = {
                                countryCode: null,
                                countryName: null
                            };
                        }
                        if (this.beneficiaryData && this.beneficiaryData['phoneContacts']) {
                            this.beneficiaryData['phoneContacts'].forEach((el) => {
                                if (!el.countryCode) {
                                    el.countryCode = {
                                        phoneCode: 0,
                                        countryCode: '',
                                        countryName: '',
                                    };
                                }
                            });
                        }
                        if (!(this.beneficiaryData.ctznshipCountryCode && this.beneficiaryData.ctznshipCountryCode.countryCode)) {
                            this.beneficiaryData.ctznshipCountryCode = beneficiary.ctznshipCountryCode = {
                                countryCode: null,
                                countryName: null
                            };
                        }
                        this.beneSelfDetailsForm.patchValue({
                            dob: this.beneficiaryData.dob && moment__default(this.beneficiaryData.dob, 'YYYY-MM-DD').toDate(),
                            // dateRangeFrom: this.beneficiaryData.
                            passport: ((_b = this.beneficiaryData) === null || _b === void 0 ? void 0 : _b.passport) && ((_d = (_c = this.beneficiaryData) === null || _c === void 0 ? void 0 : _c.passport) === null || _d === void 0 ? void 0 : _d.length) ? [Object.assign(Object.assign({}, this.beneficiaryData.passport[0]), { expiryDate: this.beneficiaryData.passport[0].expiryDate && moment__default(this.beneficiaryData.passport[0].expiryDate, 'YYYY-MM-DD').toDate(), issueDate: this.beneficiaryData.passport[0].issueDate && moment__default(this.beneficiaryData.passport[0].issueDate, 'YYYY-MM-DD').toDate(), issueCountryCode: this.beneficiaryData.passport[0].issueCountryCode ? this.beneficiaryData.passport[0].issueCountryCode : { countryCode: null } })] : this.beneficiaryData.passport,
                            // address : {...addressthis.beneficiaryData.address[0].dateRangeFrom && moment(this.beneficiaryData.address[0].dateRangeFrom, 'YYYY-MM-DD').toDate(),
                            // address: this.beneficiaryData?.passport && this.beneficiaryData?.passport?.length ? [{ }]
                            // address: this.beneficiaryData?.address[0] && this.beneficiaryData?.address?.length ? [{}] : this.beneficiaryData?.address[0]?.dateRangeFrom
                            title: (_e = this.beneficiaryData) === null || _e === void 0 ? void 0 : _e.title,
                            fName: (_f = this.beneficiaryData) === null || _f === void 0 ? void 0 : _f.fName,
                            mName: (_g = this.beneficiaryData) === null || _g === void 0 ? void 0 : _g.mName,
                            lName: (_h = this.beneficiaryData) === null || _h === void 0 ? void 0 : _h.lName,
                            ssn: (_j = this.beneficiaryData) === null || _j === void 0 ? void 0 : _j.ssn,
                            uscisAccNumber: (_k = this.beneficiaryData) === null || _k === void 0 ? void 0 : _k.uscisAccNumber,
                            itin: (_l = this.beneficiaryData) === null || _l === void 0 ? void 0 : _l.itin,
                            birthStateProvinceCode: (_m = this.beneficiaryData) === null || _m === void 0 ? void 0 : _m.birthStateProvinceCode,
                            birthStateProvinceName: (_o = this.beneficiaryData) === null || _o === void 0 ? void 0 : _o.birthStateProvinceName,
                            countryCode: (_p = this.beneficiaryData) === null || _p === void 0 ? void 0 : _p.countryCode,
                            ctznshipCountryCode: (_q = this.beneficiaryData) === null || _q === void 0 ? void 0 : _q.ctznshipCountryCode,
                            // emailContacts: this.beneficiaryData.emailContacts,
                            gender: ((_r = this.beneficiaryData) === null || _r === void 0 ? void 0 : _r.gender) ? { id: (_s = this.beneficiaryData.gender) === null || _s === void 0 ? void 0 : _s.id, name: (_t = this.beneficiaryData.gender) === null || _t === void 0 ? void 0 : _t.name } : { id: null, name: null },
                            phoneContacts: this.beneficiaryData.phoneContacts,
                            visaSponsor: (_u = this.beneficiaryData) === null || _u === void 0 ? void 0 : _u.visaSponsor,
                        });
                        // let showAliasName;
                        // if (this.beneficiaryData?.aliasName?.length > 0) {
                        //   showAliasName = this.beneficiaryData.aliasName[0].fName;
                        // }
                        // this.beneSelfDetailsForm.patchValue({ aliasName: showAliasName })
                        let pEmail = [];
                        this.beneficiaryData.emailContacts.forEach(email => {
                            var _a;
                            if (((_a = email.type) === null || _a === void 0 ? void 0 : _a.code) === "PRIM") {
                                pEmail.push(email);
                                this.primaryEmail = email;
                            }
                        });
                        this.beneSelfDetailsForm.patchValue({ emailContacts: pEmail });
                        if (((_w = (_v = this.beneficiaryData) === null || _v === void 0 ? void 0 : _v.address) === null || _w === void 0 ? void 0 : _w.length) > 0) {
                            if (this.beneficiaryData.address.find(x => x.type.code === 'CURR')) {
                                orderedArr[0] = this.beneficiaryData.address.find(x => x.type.code === 'CURR');
                            }
                            if (this.beneficiaryData.address.find(x => x.type.code === 'FORN')) {
                                orderedArr[1] = this.beneficiaryData.address.find(x => x.type.code === 'FORN');
                            }
                            else {
                                orderedArr[1] = this.emptyAddress('Foreign');
                            }
                            if (this.beneficiaryData.address[0] && this.beneficiaryData.address[0].countryCode && this.beneficiaryData.address[0].countryCode.countryCode) {
                                this.handleCountryChange(this.beneficiaryData.address[0].countryCode.countryCode, 'Current');
                            }
                            else if (this.beneficiaryData.address[0] && !this.beneficiaryData.address[0].countryCode) {
                                this.beneficiaryData.address[0]['countryCode'] = {
                                    countryCode: '',
                                    countryName: ''
                                };
                            }
                            if (this.beneficiaryData.address[1] && this.beneficiaryData.address[1].countryCode && this.beneficiaryData.address[1].countryCode.countryCode) {
                                this.handleCountryChange(this.beneficiaryData.address[1].countryCode.countryCode, 'Foreign');
                            }
                            if (this.beneficiaryData.address[1] && !this.beneficiaryData.address[1].countryCode) {
                                //IM-3932-For Existing beneficiary-after clicking on edit link-country code, mobile no, email id, passport fields are showing blank
                                this.beneficiaryData.address[1]['countryCode'] = {
                                    countryCode: '',
                                    countryName: ''
                                };
                            }
                        }
                        this.handleCountryChange((_y = (_x = this.beneficiaryData) === null || _x === void 0 ? void 0 : _x.countryCode) === null || _y === void 0 ? void 0 : _y.countryCode, 'Birth');
                    }
                    this.beneSelfDetailsForm.patchValue({ address: orderedArr });
                    this.setBeneficiaryFormData();
                    // this.orderedArr = orderedArr;
                });
            }
            else if (this.parsedJsonData) {
                let url = this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails(this.beneficiaryId, 'self');
                if ((this.primaryData && this.primaryData.familyId) || this.type === 'family') {
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails(this.beneficiaryId, 'family', this.primaryData.familyId);
                }
                url.pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36;
                    this.beneficiaryData = beneficiary;
                    this.setBeneficiaryFormData();
                    const dob = this.genericBeneficiaryPersonalDetailsLibraryService.parseToDate((_c = (_b = (_a = this.parsedJsonData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.personalDetails) === null || _c === void 0 ? void 0 : _c.dob);
                    const issueDate = this.genericBeneficiaryPersonalDetailsLibraryService.parseToDate((_f = (_e = (_d = this.parsedJsonData) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.passport) === null || _f === void 0 ? void 0 : _f.issueDate);
                    const expiryDate = this.genericBeneficiaryPersonalDetailsLibraryService.parseToDate((_j = (_h = (_g = this.parsedJsonData) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.passport) === null || _j === void 0 ? void 0 : _j.expiryDate);
                    // const dateRangeFrom = this.genericBeneficiaryPersonalDetailsLibraryService.parseToDate(this.parsedJsonData?.data.personalDetails?.dateRangeFrom);
                    this.handleCountryChange((_m = (_l = (_k = this.parsedJsonData) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.address) === null || _m === void 0 ? void 0 : _m.countryCode, 'Current');
                    this.handleCountryChange((_q = (_p = (_o = this.parsedJsonData) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.placeOfBirth) === null || _q === void 0 ? void 0 : _q.countryCode, 'Birth');
                    if (this.documentType == 'PASSPORT') {
                        this.beneSelfDetailsForm.patchValue({
                            dob: dob,
                            passport: [{
                                    passportNo: ((_t = (_s = (_r = this.parsedJsonData) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.passport) === null || _t === void 0 ? void 0 : _t.passportNo) || null,
                                    issueCountryCode: {
                                        countryCode: ((_w = (_v = (_u = this.parsedJsonData) === null || _u === void 0 ? void 0 : _u.data) === null || _v === void 0 ? void 0 : _v.passport) === null || _w === void 0 ? void 0 : _w.countryCode) || null
                                    },
                                    issueDate: issueDate,
                                    expiryDate: expiryDate
                                }],
                            fName: ((_z = (_y = (_x = this.parsedJsonData) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.personalDetails) === null || _z === void 0 ? void 0 : _z.fName) || null,
                            mName: ((_2 = (_1 = (_0 = this.parsedJsonData) === null || _0 === void 0 ? void 0 : _0.data) === null || _1 === void 0 ? void 0 : _1.personalDetails) === null || _2 === void 0 ? void 0 : _2.mName) || null,
                            lName: ((_5 = (_4 = (_3 = this.parsedJsonData) === null || _3 === void 0 ? void 0 : _3.data) === null || _4 === void 0 ? void 0 : _4.personalDetails) === null || _5 === void 0 ? void 0 : _5.lName) || null,
                            ssn: ((_8 = (_7 = (_6 = this.parsedJsonData) === null || _6 === void 0 ? void 0 : _6.data) === null || _7 === void 0 ? void 0 : _7.personalDetails) === null || _8 === void 0 ? void 0 : _8.ssn) || null,
                            birthStateProvinceCode: ((_11 = (_10 = (_9 = this.parsedJsonData) === null || _9 === void 0 ? void 0 : _9.data) === null || _10 === void 0 ? void 0 : _10.placeOfBirth) === null || _11 === void 0 ? void 0 : _11.birthStateProvinceCode) || null,
                            gender: (beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.gender) ? { id: (_12 = beneficiary.gender) === null || _12 === void 0 ? void 0 : _12.id, name: (_13 = beneficiary.gender) === null || _13 === void 0 ? void 0 : _13.name } : { id: null, name: null }
                            //birthStateProvinceName: this.parsedJsonData?.data?.placeOfBirth?.birthStateProvinceCode || null,
                        });
                        this.beneSelfDetailsForm.get('ctznshipCountryCode').get('countryCode').patchValue((_16 = (_15 = (_14 = this.parsedJsonData) === null || _14 === void 0 ? void 0 : _14.data) === null || _15 === void 0 ? void 0 : _15.placeOfBirth) === null || _16 === void 0 ? void 0 : _16.ctznshipCountryCode);
                        this.beneSelfDetailsForm.get('countryCode').get('countryCode').patchValue((_19 = (_18 = (_17 = this.parsedJsonData) === null || _17 === void 0 ? void 0 : _17.data) === null || _18 === void 0 ? void 0 : _18.placeOfBirth) === null || _19 === void 0 ? void 0 : _19.countryCode);
                        this.patchAddress();
                    }
                    else if (this.documentType == 'RESUME') {
                        if (!this.beneSelfDetailsForm.value.fName) {
                            this.beneSelfDetailsForm.patchValue({
                                fName: ((_22 = (_21 = (_20 = this.parsedJsonData) === null || _20 === void 0 ? void 0 : _20.data) === null || _21 === void 0 ? void 0 : _21.personalDetails) === null || _22 === void 0 ? void 0 : _22.fName) || null
                            });
                        }
                        if (!this.beneSelfDetailsForm.value.mName) {
                            this.beneSelfDetailsForm.patchValue({
                                mName: ((_25 = (_24 = (_23 = this.parsedJsonData) === null || _23 === void 0 ? void 0 : _23.data) === null || _24 === void 0 ? void 0 : _24.personalDetails) === null || _25 === void 0 ? void 0 : _25.mName) || null
                            });
                        }
                        if (!this.beneSelfDetailsForm.value.lName) {
                            this.beneSelfDetailsForm.patchValue({
                                lName: ((_28 = (_27 = (_26 = this.parsedJsonData) === null || _26 === void 0 ? void 0 : _26.data) === null || _27 === void 0 ? void 0 : _27.personalDetails) === null || _28 === void 0 ? void 0 : _28.lName) || null
                            });
                        }
                        this.beneSelfDetailsForm.patchValue({
                            emailContacts: [{
                                    email: ((_32 = (_31 = (_30 = (_29 = this.parsedJsonData) === null || _29 === void 0 ? void 0 : _29.data) === null || _30 === void 0 ? void 0 : _30.personalDetails) === null || _31 === void 0 ? void 0 : _31.contact) === null || _32 === void 0 ? void 0 : _32.email) || null
                                }],
                            phoneContacts: [{
                                    phoneNo: ((_36 = (_35 = (_34 = (_33 = this.parsedJsonData) === null || _33 === void 0 ? void 0 : _33.data) === null || _34 === void 0 ? void 0 : _34.personalDetails) === null || _35 === void 0 ? void 0 : _35.contact) === null || _36 === void 0 ? void 0 : _36.phone) || null
                                }]
                        });
                    }
                    //this.setBeneficiaryFormData(); // When parsedJsonData is coming from OCR response and we are setting the values here itself don't need to call this function as this is repopulating form data with previous beneficiary
                });
            }
            if (sessionStorage.getItem('wizardTID')) {
                this.editDetails = false;
                this.handleEdit();
            }
            // }
        }
        else {
            if (this.onlyFormBuilder !== 'FB' && this.beneficiaryId !== null) {
                debugger;
                this.emptyBeneficiaryData();
                this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails(this.beneficiaryId, 'self').pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary) => {
                    var _a, _b, _c, _d, _e;
                    this.beneficiaryData = Object.assign(Object.assign({}, beneficiary), { dob: beneficiary.dob && moment__default(beneficiary.dob, 'YYYY-MM-DD').toDate(), marriageDate: beneficiary.marriageDate && moment__default(beneficiary.marriageDate, 'YYYY-MM-DD').toDate(), ctznCrtfctIssDate: beneficiary.ctznCrtfctIssDate && moment__default(beneficiary.ctznCrtfctIssDate, 'YYYY-MM-DD').toDate(), passport: ((_a = beneficiary.passport) === null || _a === void 0 ? void 0 : _a.length) ? [Object.assign(Object.assign({}, beneficiary.passport[0]), { expiryDate: beneficiary.passport[0].expiryDate && moment__default(beneficiary.passport[0].expiryDate, 'YYYY-MM-DD').toDate(), issueDate: beneficiary.passport[0].issueDate && moment__default(beneficiary.passport[0].issueDate, 'YYYY-MM-DD').toDate() })] : beneficiary.passport });
                    if (this.beneficiaryData.address.length > 0) {
                        if (this.beneficiaryData.address[0]) {
                            this.beneficiaryData.address[0].dateRangeFrom = ((_c = (_b = this.beneficiaryData) === null || _b === void 0 ? void 0 : _b.address[0]) === null || _c === void 0 ? void 0 : _c.dateRangeFrom) ? moment__default(this.beneficiaryData.address[0].dateRangeFrom, 'YYYY-MM-DD').toDate() : null;
                        }
                        if (this.beneficiaryData.address[1]) {
                            this.beneficiaryData.address[1].dateRangeFrom = ((_e = (_d = this.beneficiaryData) === null || _d === void 0 ? void 0 : _d.address[1]) === null || _e === void 0 ? void 0 : _e.dateRangeFrom) ? moment__default(this.beneficiaryData.address[1].dateRangeFrom, 'YYYY-MM-DD').toDate() : null;
                        }
                    }
                    this.personalDetails.next(this.beneficiaryData);
                    this.setBeneficiaryFormData();
                    this.translet();
                });
            }
        }
    }
    patchAddress() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
        this.beneSelfDetailsForm.get('address').controls[0].patchValue({
            addressLine1: ((_c = (_b = (_a = this.parsedJsonData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.addressLine1) || '',
            addressLine2: ((_f = (_e = (_d = this.parsedJsonData) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.addressLine2) || '',
            postCode: ((_j = (_h = (_g = this.parsedJsonData) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.address) === null || _j === void 0 ? void 0 : _j.postCode) || '',
            stateProvinceCode: ((_m = (_l = (_k = this.parsedJsonData) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.address) === null || _m === void 0 ? void 0 : _m.stateProvinceCode) || null,
            stateProvinceName: ((_q = (_p = (_o = this.parsedJsonData) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.address) === null || _q === void 0 ? void 0 : _q.stateProvinceName) || '',
            city: ((_t = (_s = (_r = this.parsedJsonData) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.address) === null || _t === void 0 ? void 0 : _t.city) || '',
            locality: ((_w = (_v = (_u = this.parsedJsonData) === null || _u === void 0 ? void 0 : _u.data) === null || _v === void 0 ? void 0 : _v.address) === null || _w === void 0 ? void 0 : _w.locality) || '',
            inCareOfName: ((_z = (_y = (_x = this.parsedJsonData) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.address) === null || _z === void 0 ? void 0 : _z.inCareOfName) || '',
            county: ((_1 = (_0 = this.parsedJsonData) === null || _0 === void 0 ? void 0 : _0.data) === null || _1 === void 0 ? void 0 : _1.address.county) || '',
        });
        this.beneSelfDetailsForm.get('address').controls[0].get('countryCode').patchValue({
            countryCode: ((_4 = (_3 = (_2 = this.parsedJsonData) === null || _2 === void 0 ? void 0 : _2.data) === null || _3 === void 0 ? void 0 : _3.address) === null || _4 === void 0 ? void 0 : _4.countryCode) || null,
        });
    }
    getformBuilderDetails() {
        this.emptyBeneficiaryData();
        this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
        this.beneficiaryIdFromFB1.emit(this.beneficiaryIdFromFB);
        this.genericBeneficiaryPersonalDetailsLibraryService.getEmployeeFBDetails(this.fbDetails.moduleId, this.fbDetails.pageFormId, this.companyId, this.beneficiaryId).pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary) => {
            this.beneficiaryData = beneficiary;
            this.personalDetails.next(this.beneficiaryData);
            // if(this.beneficiaryIdFromFB !== null && this.beneficiaryIdFromFB !== 0){
            this.setBeneficiaryFormData();
            // }
        });
    }
    getUpolodedFiles() {
        var _a, _b;
        this.passportfileUploadConfigurations.familyId = (this.type === 'family' || this.beneficiaryType === 'family') && ((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.familyId) ? (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.familyId : null;
        this.currentFamilyId = this.passportfileUploadConfigurations.familyId;
        this.passportfileUploadConfigurations = Object.assign({}, this.passportfileUploadConfigurations);
        //this.editClicked =  (sessionStorage.getItem('dependentId') == '0') ? false : true
        this.genericBeneficiaryPersonalDetailsLibraryService.genericGetUploadDocument(this.passportfileUploadConfigurations.useCase, this.passportfileUploadConfigurations.useCaseId, this.passportfileUploadConfigurations.categoryName, this.passportfileUploadConfigurations.entityId, this.passportfileUploadConfigurations.useEntityId, (this.type === 'family' ? this.passportfileUploadConfigurations.familyId : null)).subscribe((response) => {
            if (response['status'] === 200) {
                this.passportfileUploadConfigurations.listUploadedFiles = response['data'];
                this.passportfileUploadConfigurations = Object.assign({}, this.passportfileUploadConfigurations);
            }
            else {
                this.passportfileUploadConfigurations.listUploadedFiles = [];
                this.passportfileUploadConfigurations = Object.assign({}, this.passportfileUploadConfigurations);
            }
        });
    }
    setBeneficiaryFormData() {
        var _a, _b, _c;
        let orderedArr = [];
        this.showAddIcon = ((_a = this.beneficiaryData) === null || _a === void 0 ? void 0 : _a.id) == 0 ? true : false;
        if (this.onlyFormBuilder === 'FB') {
            this.fileUploadConfigurations.entityId = this.documentFileUploadConfigurations.entityId = this.beneficiaryId ? this.beneficiaryId : this.beneficiaryIdFromFB;
            this.fileUploadConfigurations.useCaseId = this.documentFileUploadConfigurations.useCaseId = this.beneficiaryId ? this.beneficiaryId : this.beneficiaryIdFromFB;
        }
        else {
            this.fileUploadConfigurations.entityId = this.beneficiaryId || ((_b = this.beneficiaryData) === null || _b === void 0 ? void 0 : _b.id);
            this.fileUploadConfigurations.useCaseId = this.beneficiaryId || ((_c = this.beneficiaryData) === null || _c === void 0 ? void 0 : _c.id);
        }
        if (this.onlyFormBuilder === 'FB') {
            this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
            this.documentFileUploadConfigurations.familyId = (this.beneficiaryType === 'family') ? this.beneficiaryData.id : null;
            this.currentFamilyId = this.documentFileUploadConfigurations.familyId;
            this.documentFileUploadConfigurations.family = (this.beneficiaryType === 'family') ? true : false;
            this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
        }
        this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
        this.fileUploadConfigurations.familyId = (this.beneficiaryType === 'family') ? this.beneficiaryData.id : null;
        this.currentFamilyId = this.fileUploadConfigurations.familyId;
        this.fileUploadConfigurations.family = (this.beneficiaryType === 'family') ? true : false;
        this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
        //this.editClicked =  (sessionStorage.getItem('dependentId') == '0') ? false : true
        if (this.beneficiaryType === 'family' && this.beneficiaryData.id === 0) {
            if (this.onlyFormBuilder === 'FB') {
                this.documentFileUploadConfigurations.listUploadedFiles = [];
                this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
            }
            this.fileUploadConfigurations.listUploadedFiles = [];
            this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
        }
        else {
            if (this.onlyFormBuilder === 'FB') {
                this.genericBeneficiaryPersonalDetailsLibraryService.genericGetUploadDocument(this.documentFileUploadConfigurations.useCase, this.documentFileUploadConfigurations.useCaseId, this.documentFileUploadConfigurations.categoryName, this.documentFileUploadConfigurations.entityId, this.documentFileUploadConfigurations.useEntityId, this.documentFileUploadConfigurations.familyId).subscribe((response) => {
                    if (response['status'] === 200) {
                        this.documentFileUploadConfigurations.listUploadedFiles = response['data'];
                        this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
                    }
                    else {
                        this.documentFileUploadConfigurations.listUploadedFiles = [];
                        this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
                    }
                });
            }
            this.genericBeneficiaryPersonalDetailsLibraryService.genericGetUploadDocument(this.fileUploadConfigurations.useCase, this.fileUploadConfigurations.useCaseId, this.fileUploadConfigurations.categoryName, this.fileUploadConfigurations.entityId, this.fileUploadConfigurations.useEntityId, this.fileUploadConfigurations.familyId).subscribe((response) => {
                if (response['status'] === 200) {
                    this.fileUploadConfigurations.listUploadedFiles = response['data'];
                    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
                }
                else {
                    this.fileUploadConfigurations.listUploadedFiles = [];
                    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
                }
            });
        }
        this.showAddIcon = this.beneficiaryData.id == 0 ? true : false;
        this.signatureImage = (this.beneficiaryData['signPic'] !== null && this.beneficiaryData['signPic'] !== undefined) ? `data:image/jpeg;base64,${this.beneficiaryData['signPic']}` : '';
        if (this.beneficiaryData.address && this.beneficiaryData.address.length > 0) {
            if (this.beneficiaryData.address.find(x => x.type.code === 'CURR')) {
                orderedArr[0] = this.beneficiaryData.address.find(x => x.type.code === 'CURR');
            }
            else {
                orderedArr[0] = this.emptyAddress('Current');
            }
            if (this.beneficiaryData.address.find(x => x.type.code === 'MAIL')) {
                orderedArr[1] = this.beneficiaryData.address.find(x => x.type.code === 'MAIL');
            }
            else {
                orderedArr[1] = this.emptyAddress('Mailing');
            }
            if (this.beneficiaryData.address.find(x => x.type.code === 'FORN')) {
                orderedArr[2] = this.beneficiaryData.address.find(x => x.type.code === 'FORN');
            }
            else {
                orderedArr[2] = this.emptyAddress('Foreign');
            }
            if (this.beneficiaryData.address.find(x => x.type.code === 'PERM')) {
                orderedArr[3] = this.beneficiaryData.address.find(x => x.type.code === 'PERM');
            }
            else {
                orderedArr[3] = this.emptyAddress('Permanent');
            }
        }
        else {
            orderedArr.push(this.emptyAddress('Current'), this.emptyAddress('Mailing'), this.emptyAddress('Permanent'), this.emptyAddress('Foreign'));
        }
        ///IM-3601
        this.datesStoredArrayForDisplay['dob'] = this.beneficiaryData.dob ? moment__default(this.beneficiaryData.dob).toISOString() : '';
        this.datesStoredArrayForDisplay['issueDate'] = this.beneficiaryData.passport[0] ? moment__default(this.beneficiaryData.passport[0].issueDate).toISOString() : '';
        this.datesStoredArrayForDisplay['expiryDate'] = this.beneficiaryData.passport[0] ? moment__default(this.beneficiaryData.passport[0].expiryDate).toISOString() : '';
        // this.datesStoredArrayForDisplay['dateRangeFrom'] = this.beneficiaryData.address[0] ? moment(this.beneficiaryData.address[0].dateRangeFrom).toISOString() : '';
        // this.datesStoredArrayForDisplay['dateRangeFrom'] = this.beneficiaryData.address[0] ? moment(this.beneficiaryData.address[1].dateRangeFrom).toISOString() : '';
        this.beneficiaryData.address = orderedArr;
        if (this.beneficiaryData && this.beneficiaryData.aliasName && this.beneficiaryData.aliasName.length > 0) {
            this.showAliasName = (this.beneficiaryData.aliasName[0].fName) ? true : false;
        }
        if (this.beneficiaryData.address && this.beneficiaryData.address.length > 0) {
            if (this.beneficiaryData.address[0] && this.beneficiaryData.address[0].countryCode && this.beneficiaryData.address[0].countryCode.countryCode) {
                this.handleCountryChange(this.beneficiaryData.address[0].countryCode.countryCode, 'Current');
            }
            else if (this.beneficiaryData.address[0] && !this.beneficiaryData.address[0].countryCode) {
                this.beneficiaryData.address[0]['countryCode'] = {
                    countryCode: '',
                    countryName: ''
                };
            }
            if (this.beneficiaryData.address[1] && this.beneficiaryData.address[1].countryCode && this.beneficiaryData.address[1].countryCode.countryCode) {
                this.handleCountryChange(this.beneficiaryData.address[1].countryCode.countryCode, 'Mailing');
            }
            else if (this.beneficiaryData.address[1] && !this.beneficiaryData.address[1].countryCode) {
                this.beneficiaryData.address[1]['countryCode'] = {
                    countryCode: '',
                    countryName: ''
                };
            }
            if (this.beneficiaryData.address[2] && this.beneficiaryData.address[2].countryCode && this.beneficiaryData.address[2].countryCode.countryCode) {
                this.handleCountryChange(this.beneficiaryData.address[2].countryCode.countryCode, 'Foreign');
            }
            if (this.beneficiaryData.address[2] && !this.beneficiaryData.address[2].countryCode) {
                //IM-3932-For Existing beneficiary-after clicking on edit link-country code, mobile no, email id, passport fields are showing blank
                this.beneficiaryData.address[2]['countryCode'] = {
                    countryCode: '',
                    countryName: ''
                };
            }
            if (this.beneficiaryData.address[3] && this.beneficiaryData.address[3].countryCode && this.beneficiaryData.address[3].countryCode.countryCode) {
                this.handleCountryChange(this.beneficiaryData.address[3].countryCode.countryCode, 'Permanent');
            }
            else if (this.beneficiaryData.address[3] && !this.beneficiaryData.address[3].countryCode) {
                this.beneficiaryData.address[3]['countryCode'] = {
                    countryCode: '',
                    countryName: ''
                };
            }
        }
        if (this.beneficiaryData.countryCode && this.beneficiaryData.countryCode.countryCode) {
            this.handleCountryChange(this.beneficiaryData.countryCode.countryCode, 'Birth');
        }
        if (this.beneficiaryData.countryOfMarriage && this.beneficiaryData.countryOfMarriage.countryCode) {
            this.handleCountryChange(this.beneficiaryData.countryOfMarriage.countryCode, 'Marriage');
        }
        if (this.beneficiaryData.ctznshipCountryCode && this.beneficiaryData.ctznshipCountryCode.countryCode) {
            this.showCitizenShipAquiredInfo = (this.beneficiaryData.ctznshipCountryCode.countryCode === 'USA') ? true : false;
        }
        else {
            this.showCitizenShipAquiredInfo = false;
        }
        if (!this.beneficiaryData.gender) {
            this.beneficiaryData.gender = {
                id: null,
                name: null
            };
        }
        if (!this.beneficiaryData.countryCode) {
            this.beneficiaryData.countryCode = {
                countryCode: null,
                countryName: null
            };
        }
        if (!(this.beneficiaryData.ctznshipCountryCode && this.beneficiaryData.ctznshipCountryCode.countryCode)) {
            this.beneficiaryData.ctznshipCountryCode = {
                countryCode: null,
                countryName: null
            };
        }
        if (!(this.beneficiaryData.countryOfMarriage && this.beneficiaryData.countryOfMarriage.countryCode)) {
            this.beneficiaryData.countryOfMarriage = {
                countryCode: null,
                countryName: null
            };
        }
        if (!(this.beneficiaryData.maritalStatus)) {
            this.beneficiaryData.maritalStatus = {
                id: null,
                name: ''
            };
        }
        if (!this.beneficiaryData.dob) {
            this.beneSelfDetailsForm.get('dob').setValue(null);
        }
        if (!this.beneficiaryData.marriageDate) {
            this.beneSelfDetailsForm.get('marriageDate').setValue(null);
        }
        if (!this.beneficiaryData.ctznCrtfctIssDate) {
            this.beneSelfDetailsForm.get('ctznCrtfctIssDate').setValue(null);
        }
        if (!(this.beneficiaryData.aliasName && this.beneficiaryData.aliasName.length > 0 && this.beneficiaryData.aliasName[0].fName)) {
            const aliasNameArray = this.beneSelfDetailsForm.get('aliasName');
            aliasNameArray.clear();
        }
        //IM-3763-Profile picture is not shown when Petitioner edits beneficiary.
        if (this.beneficiaryData['profileImage']) {
            //sessionStorage.setItem('profilePic', this.beneficiaryData['profileImage']);
            this.genericBeneficiaryPersonalDetailsLibraryService.hasProfileImage({ hasImage: true, image: this.beneficiaryData['profileImage'] });
        }
        else {
            this.genericBeneficiaryPersonalDetailsLibraryService.hasProfileImage(false);
        }
        if (!this.isPersonalDetailsFormReset) {
            this.editDetails = false;
            this.profileEditStatus.emit(false);
        }
        this.dependentDetailsLoaded = true;
        this.triggerChangeDependentProfileID();
        this.addRaceArrayFormControl();
        if (this.beneficiaryData && this.beneficiaryData['phoneContacts']) {
            this.beneficiaryData['phoneContacts'].forEach((el) => {
                if (!el.countryCode) {
                    el.countryCode = {
                        phoneCode: 0,
                        countryCode: '',
                        countryName: '',
                    };
                }
            });
        }
        const beneFormPatchValue = Object.assign(Object.assign({}, this.beneficiaryData), { race: [], hasPassport: !this.beneficiaryData['hasPassport'] });
        try {
            // this.beneSelfDetailsForm.patchValue(this.beneficiaryData);
            this.beneSelfDetailsForm.patchValue(Object.assign(Object.assign({}, beneFormPatchValue), { ctznCrtfctIssPlace: this.beneficiaryData.ctznCrtfctIssPlace, ctznCrtfctNo: this.beneficiaryData.ctznCrtfctNo, ctznAcqrTypeId: {
                    ctznAcqrId: this.beneficiaryData.ctznAcqrTypeId && this.beneficiaryData.ctznAcqrTypeId.id ? this.beneficiaryData.ctznAcqrTypeId.id : null
                }, ethnicity: {
                    ethnicityId: this.beneficiaryData.ethnicity && this.beneficiaryData.ethnicity.id ? this.beneficiaryData.ethnicity.id : null
                } }));
            // this.dependentProfileDataService.changeDependentProfileID(this.beneSelfDetailsForm.get('id').value,this.beneficiaryType);
        }
        catch (error) {
        }
        this.beneSelfDetailsForm.patchValue({
            weight: this.beneficiaryData.weight ? this.beneficiaryData.weight : null
        });
        // this.addRaceArrayFormControl();
        this.handleIsLprChanges();
        //this.setValidatorForCitizenShipAquired();
        this.handleCitizenshipSwitchChange();
        /// this.beneSelfDetailsForm.patchValue(this.beneficiaryData);
        this.beneSelfDetailsForm.disable();
        if (this.editModeVal) {
            this.editDetails = false;
            this.handleEdit();
        }
        if (this.beneUpdateProfile && !this.viewMode && !this.isPersonalDetailsFormReset) {
            this.handleEdit();
        }
    }
    triggerChangeDependentProfileID() {
        if (this.dependentDetailsLoaded) {
            this.genericBeneficiaryPersonalDetailsLibraryService.changeDependentProfileID(this.beneficiaryType !== 'self' ? this.beneficiaryData.id : null, this.beneficiaryType);
        }
    }
    getBeneficiaryFamilyDetails(isOnSave) {
        var _a, _b, _c;
        if (this.primaryData) {
            let orderedArr = [];
            if (!this.parsedJsonData) {
                let url = this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails((this.beneficiaryId || ((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.sponsorId)), 'self');
                if (this.primaryData && ((_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.familyId) && this.type === 'family') {
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails((this.beneficiaryId || ((_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.sponsorId)), 'family', this.primaryData.familyId);
                }
                url.pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
                    orderedArr.push(this.emptyAddress('Current'), this.emptyAddress('Foreign'));
                    if (beneficiary) {
                        this.beneficiaryData = this.primaryData && this.primaryData.familyId && this.type === 'family' ? beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.find(member => member.id === this.primaryData.familyId) : beneficiary;
                        // if (this.primaryData && this.primaryData?.familyId || this.type === 'family') {
                        //   beneficiary = this.beneficiaryData;
                        // }
                        if (!((_a = this.beneficiaryData) === null || _a === void 0 ? void 0 : _a.countryCode)) {
                            this.beneficiaryData.countryCode = beneficiary.countryCode = {
                                countryCode: null,
                                countryName: null
                            };
                        }
                        if (this.beneficiaryData && this.beneficiaryData['phoneContacts']) {
                            this.beneficiaryData['phoneContacts'].forEach((el) => {
                                if (!el.countryCode) {
                                    el.countryCode = {
                                        phoneCode: 0,
                                        countryCode: '',
                                        countryName: '',
                                    };
                                }
                            });
                        }
                        if (!(this.beneficiaryData.ctznshipCountryCode && this.beneficiaryData.ctznshipCountryCode.countryCode)) {
                            this.beneficiaryData.ctznshipCountryCode = beneficiary.ctznshipCountryCode = {
                                countryCode: null,
                                countryName: null
                            };
                        }
                        this.beneSelfDetailsForm.patchValue({
                            dob: this.beneficiaryData.dob && moment__default(this.beneficiaryData.dob, 'YYYY-MM-DD').toDate(),
                            passport: ((_b = this.beneficiaryData) === null || _b === void 0 ? void 0 : _b.passport) && ((_d = (_c = this.beneficiaryData) === null || _c === void 0 ? void 0 : _c.passport) === null || _d === void 0 ? void 0 : _d.length) ? [Object.assign(Object.assign({}, this.beneficiaryData.passport[0]), { expiryDate: this.beneficiaryData.passport[0].expiryDate && moment__default(this.beneficiaryData.passport[0].expiryDate, 'YYYY-MM-DD').toDate(), issueDate: this.beneficiaryData.passport[0].issueDate && moment__default(this.beneficiaryData.passport[0].issueDate, 'YYYY-MM-DD').toDate(), issueCountryCode: this.beneficiaryData.passport[0].issueCountryCode ? this.beneficiaryData.passport[0].issueCountryCode : { countryCode: null } })] : this.beneficiaryData.passport,
                            fName: (_e = this.beneficiaryData) === null || _e === void 0 ? void 0 : _e.fName,
                            mName: (_f = this.beneficiaryData) === null || _f === void 0 ? void 0 : _f.mName,
                            lName: (_g = this.beneficiaryData) === null || _g === void 0 ? void 0 : _g.lName,
                            ssn: (_h = this.beneficiaryData) === null || _h === void 0 ? void 0 : _h.ssn,
                            birthStateProvinceCode: (_j = this.beneficiaryData) === null || _j === void 0 ? void 0 : _j.birthStateProvinceCode,
                            birthStateProvinceName: (_k = this.beneficiaryData) === null || _k === void 0 ? void 0 : _k.birthStateProvinceName,
                            countryCode: (_l = this.beneficiaryData) === null || _l === void 0 ? void 0 : _l.countryCode,
                            ctznshipCountryCode: (_m = this.beneficiaryData) === null || _m === void 0 ? void 0 : _m.ctznshipCountryCode,
                            // emailContacts: this.beneficiaryData.emailContacts,
                            gender: ((_o = this.beneficiaryData) === null || _o === void 0 ? void 0 : _o.gender) ? { id: (_p = this.beneficiaryData.gender) === null || _p === void 0 ? void 0 : _p.id, name: (_q = this.beneficiaryData.gender) === null || _q === void 0 ? void 0 : _q.name } : { id: null, name: null },
                            phoneContacts: this.beneficiaryData.phoneContacts
                        });
                        // let showAliasName;
                        // if (this.beneficiaryData?.aliasName?.length > 0) {
                        //   showAliasName = this.beneficiaryData.aliasName[0].fName;
                        // }
                        // this.beneSelfDetailsForm.patchValue({ aliasName: showAliasName })
                        let pEmail = [];
                        this.beneficiaryData.emailContacts.forEach(email => {
                            var _a;
                            if (((_a = email.type) === null || _a === void 0 ? void 0 : _a.code) === "PRIM") {
                                pEmail.push(email);
                                this.primaryEmail = email;
                            }
                        });
                        this.beneSelfDetailsForm.patchValue({ emailContacts: pEmail });
                        if (((_s = (_r = this.beneficiaryData) === null || _r === void 0 ? void 0 : _r.address) === null || _s === void 0 ? void 0 : _s.length) > 0) {
                            if (this.beneficiaryData.address.find(x => x.type.code === 'CURR')) {
                                orderedArr[0] = this.beneficiaryData.address.find(x => x.type.code === 'CURR');
                            }
                            if (this.beneficiaryData.address.find(x => x.type.code === 'FORN')) {
                                orderedArr[1] = this.beneficiaryData.address.find(x => x.type.code === 'FORN');
                            }
                            else {
                                orderedArr[1] = this.emptyAddress('Foreign');
                            }
                            if (this.beneficiaryData.address[0] && this.beneficiaryData.address[0].countryCode && this.beneficiaryData.address[0].countryCode.countryCode) {
                                this.handleCountryChange(this.beneficiaryData.address[0].countryCode.countryCode, 'Current');
                            }
                            else if (this.beneficiaryData.address[0] && !this.beneficiaryData.address[0].countryCode) {
                                this.beneficiaryData.address[0]['countryCode'] = {
                                    countryCode: '',
                                    countryName: ''
                                };
                            }
                            if (this.beneficiaryData.address[1] && this.beneficiaryData.address[1].countryCode && this.beneficiaryData.address[1].countryCode.countryCode) {
                                this.handleCountryChange(this.beneficiaryData.address[1].countryCode.countryCode, 'Foreign');
                            }
                            if (this.beneficiaryData.address[1] && !this.beneficiaryData.address[1].countryCode) {
                                //IM-3932-For Existing beneficiary-after clicking on edit link-country code, mobile no, email id, passport fields are showing blank
                                this.beneficiaryData.address[1]['countryCode'] = {
                                    countryCode: '',
                                    countryName: ''
                                };
                            }
                        }
                        this.handleCountryChange((_u = (_t = this.beneficiaryData) === null || _t === void 0 ? void 0 : _t.countryCode) === null || _u === void 0 ? void 0 : _u.countryCode, 'Birth');
                    }
                    this.beneSelfDetailsForm.patchValue({ address: orderedArr });
                    this.setBeneficiaryFormData();
                    // this.beneAddress = orderedArr;
                });
            }
            else if (this.parsedJsonData) {
                let url = this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails(this.beneficiaryId, 'self');
                if ((this.primaryData && this.primaryData.familyId) || this.type === 'family') {
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails(this.beneficiaryId, 'family', this.primaryData.familyId);
                }
                url.pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36;
                    this.beneficiaryData = beneficiary;
                    const dob = this.genericBeneficiaryPersonalDetailsLibraryService.parseToDate((_c = (_b = (_a = this.parsedJsonData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.personalDetails) === null || _c === void 0 ? void 0 : _c.dob);
                    const issueDate = this.genericBeneficiaryPersonalDetailsLibraryService.parseToDate((_f = (_e = (_d = this.parsedJsonData) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.passport) === null || _f === void 0 ? void 0 : _f.issueDate);
                    const expiryDate = this.genericBeneficiaryPersonalDetailsLibraryService.parseToDate((_j = (_h = (_g = this.parsedJsonData) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.passport) === null || _j === void 0 ? void 0 : _j.expiryDate);
                    // const dateRangeFrom = this.genericBeneficiaryPersonalDetailsLibraryService.parseToDate(this.parsedJsonData?.data?.address[0]?.dateRangeFrom);
                    this.handleCountryChange((_m = (_l = (_k = this.parsedJsonData) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.address) === null || _m === void 0 ? void 0 : _m.countryCode, 'Current');
                    this.handleCountryChange((_q = (_p = (_o = this.parsedJsonData) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.placeOfBirth) === null || _q === void 0 ? void 0 : _q.countryCode, 'Birth');
                    if (this.documentType == 'PASSPORT') {
                        this.beneSelfDetailsForm.patchValue({
                            dob: dob,
                            passport: [{
                                    passportNo: ((_t = (_s = (_r = this.parsedJsonData) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.passport) === null || _t === void 0 ? void 0 : _t.passportNo) || null,
                                    issueCountryCode: {
                                        countryCode: ((_w = (_v = (_u = this.parsedJsonData) === null || _u === void 0 ? void 0 : _u.data) === null || _v === void 0 ? void 0 : _v.passport) === null || _w === void 0 ? void 0 : _w.countryCode) || null
                                    },
                                    issueDate: issueDate,
                                    expiryDate: expiryDate
                                }],
                            fName: ((_z = (_y = (_x = this.parsedJsonData) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.personalDetails) === null || _z === void 0 ? void 0 : _z.fName) || null,
                            mName: ((_2 = (_1 = (_0 = this.parsedJsonData) === null || _0 === void 0 ? void 0 : _0.data) === null || _1 === void 0 ? void 0 : _1.personalDetails) === null || _2 === void 0 ? void 0 : _2.mName) || null,
                            lName: ((_5 = (_4 = (_3 = this.parsedJsonData) === null || _3 === void 0 ? void 0 : _3.data) === null || _4 === void 0 ? void 0 : _4.personalDetails) === null || _5 === void 0 ? void 0 : _5.lName) || null,
                            ssn: ((_8 = (_7 = (_6 = this.parsedJsonData) === null || _6 === void 0 ? void 0 : _6.data) === null || _7 === void 0 ? void 0 : _7.personalDetails) === null || _8 === void 0 ? void 0 : _8.ssn) || null,
                            birthStateProvinceCode: ((_11 = (_10 = (_9 = this.parsedJsonData) === null || _9 === void 0 ? void 0 : _9.data) === null || _10 === void 0 ? void 0 : _10.placeOfBirth) === null || _11 === void 0 ? void 0 : _11.birthStateProvinceCode) || null,
                            gender: (beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.gender) ? { id: (_12 = beneficiary.gender) === null || _12 === void 0 ? void 0 : _12.id, name: (_13 = beneficiary.gender) === null || _13 === void 0 ? void 0 : _13.name } : { id: null, name: null }
                            //birthStateProvinceName: this.parsedJsonData?.data?.placeOfBirth?.birthStateProvinceCode || null,
                        });
                        this.beneSelfDetailsForm.get('ctznshipCountryCode').get('countryCode').patchValue((_16 = (_15 = (_14 = this.parsedJsonData) === null || _14 === void 0 ? void 0 : _14.data) === null || _15 === void 0 ? void 0 : _15.placeOfBirth) === null || _16 === void 0 ? void 0 : _16.ctznshipCountryCode);
                        this.beneSelfDetailsForm.get('countryCode').get('countryCode').patchValue((_19 = (_18 = (_17 = this.parsedJsonData) === null || _17 === void 0 ? void 0 : _17.data) === null || _18 === void 0 ? void 0 : _18.placeOfBirth) === null || _19 === void 0 ? void 0 : _19.countryCode);
                        this.patchAddress();
                    }
                    else if (this.documentType == 'RESUME') {
                        if (!this.beneSelfDetailsForm.value.fName) {
                            this.beneSelfDetailsForm.patchValue({
                                fName: ((_22 = (_21 = (_20 = this.parsedJsonData) === null || _20 === void 0 ? void 0 : _20.data) === null || _21 === void 0 ? void 0 : _21.personalDetails) === null || _22 === void 0 ? void 0 : _22.fName) || null
                            });
                        }
                        if (!this.beneSelfDetailsForm.value.mName) {
                            this.beneSelfDetailsForm.patchValue({
                                mName: ((_25 = (_24 = (_23 = this.parsedJsonData) === null || _23 === void 0 ? void 0 : _23.data) === null || _24 === void 0 ? void 0 : _24.personalDetails) === null || _25 === void 0 ? void 0 : _25.mName) || null
                            });
                        }
                        if (!this.beneSelfDetailsForm.value.lName) {
                            this.beneSelfDetailsForm.patchValue({
                                lName: ((_28 = (_27 = (_26 = this.parsedJsonData) === null || _26 === void 0 ? void 0 : _26.data) === null || _27 === void 0 ? void 0 : _27.personalDetails) === null || _28 === void 0 ? void 0 : _28.lName) || null
                            });
                        }
                        this.beneSelfDetailsForm.patchValue({
                            emailContacts: [{
                                    email: ((_32 = (_31 = (_30 = (_29 = this.parsedJsonData) === null || _29 === void 0 ? void 0 : _29.data) === null || _30 === void 0 ? void 0 : _30.personalDetails) === null || _31 === void 0 ? void 0 : _31.contact) === null || _32 === void 0 ? void 0 : _32.email) || null
                                }],
                            phoneContacts: [{
                                    phoneNo: ((_36 = (_35 = (_34 = (_33 = this.parsedJsonData) === null || _33 === void 0 ? void 0 : _33.data) === null || _34 === void 0 ? void 0 : _34.personalDetails) === null || _35 === void 0 ? void 0 : _35.contact) === null || _36 === void 0 ? void 0 : _36.phone) || null
                                }]
                        });
                    }
                });
            }
            if (sessionStorage.getItem('wizardTID')) {
                this.editDetails = false;
                this.handleEdit();
            }
            //this.setBeneficiaryFormData(); // This function expects this.beneficiaryData to have some value otherwise this is throwing errors on multiple places
        }
        else {
            this.genericBeneficiaryPersonalDetailsLibraryService.getBeneficiaryDetails(this.beneficiaryId, 'family').pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiaryFamilyInfo) => {
                this.beneficiaryFamilyInfo = beneficiaryFamilyInfo;
                let a;
                if (this.detailsAbout.isNewImplementation) {
                    a = this.beneficiaryFamilyInfo.find(e => { var _a, _b; return e.relationShipType.code === ((_b = (_a = this.detailsAbout) === null || _a === void 0 ? void 0 : _a.dependentType) === null || _b === void 0 ? void 0 : _b.code); });
                    if (a) {
                        this.hasFamily.emit(a.id);
                    }
                    if (isOnSave) {
                        this.genericBeneficiaryPersonalDetailsLibraryService.newSubDependentCreated.next({ beneficiaryFamilyInfo, selectedSubTabId: this.selectedSubTabId });
                    }
                    this.handleNewTabChange();
                }
                else {
                    a = this.beneficiaryFamilyInfo.find(e => { var _a, _b; return e.relationShipType.code === ((_b = (_a = this.detailsAbout) === null || _a === void 0 ? void 0 : _a.dependentType) === null || _b === void 0 ? void 0 : _b.code); });
                    if (a) {
                        this.hasFamily.emit(a.id);
                    }
                    if (isOnSave) {
                        this.genericBeneficiaryPersonalDetailsLibraryService.newSubDependentCreated.next({ beneficiaryFamilyInfo, selectedSubTabId: this.selectedSubTabId });
                    }
                    else {
                        this.handleTabChange();
                    }
                }
                if (!this.customQuestions) {
                    this.setBeneficiaryFormData();
                }
            });
        }
    }
    getStateName(stateProvinceCodes, stateIndex) {
        switch (stateIndex) {
            case 'Current':
                const selectedCurrStateObj = this.listStatesCurrent.find(x => x.stateProvinceCode === stateProvinceCodes);
                return (selectedCurrStateObj) ? selectedCurrStateObj.stateProvinceName : '--';
            case 'Permanent':
                const selectedPermStateObj = this.listStatesPermanent.find(x => x.stateProvinceCode === stateProvinceCodes);
                return (selectedPermStateObj) ? selectedPermStateObj.stateProvinceName : '--';
            case 'Permanent':
                const selectedMailStateObj = this.listStatesMailing.find(x => x.stateProvinceCode === stateProvinceCodes);
                return (selectedPermStateObj) ? selectedPermStateObj.stateProvinceName : '--';
            case 'Foreign':
                const selectedFornStateObj = this.listStatesForeign.find(x => x.stateProvinceCode === stateProvinceCodes);
                return (selectedFornStateObj) ? selectedFornStateObj.stateProvinceName : '--';
            case 'Birth':
                const selectedBirthStateObj = this.listStatesBirth.find(x => x.stateProvinceCode === stateProvinceCodes);
                return (selectedBirthStateObj) ? selectedBirthStateObj.stateProvinceName : '--';
            case 'Marriage':
                const selectedMarriageStateObj = this.listStatesMarriage.find(x => x.stateProvinceCode === stateProvinceCodes);
                return (selectedMarriageStateObj) ? selectedMarriageStateObj.stateProvinceName : '--';
            case 'Mailing':
                const selectedMailingStateObj = this.listStatesMailing.find(x => x.stateProvinceCode === stateProvinceCodes);
                return (selectedMailingStateObj) ? selectedMailingStateObj.stateProvinceName : '--';
        }
    }
    findInvalidControls() {
        const invalid = [];
        const controls = this.beneSelfDetailsForm.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        // console.log(invalid);
        return invalid;
    }
    savePersonalData(isDraft = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (!isDraft) {
            this.submitted = true;
            if (this.beneSelfDetailsForm.invalid) {
                this.findInvalidControls();
                return;
            }
        }
        // IM-3402 - Commented code
        //this.checkForeignAddress();
        //patchvalue add to fix IM-3485
        this.beneSelfDetailsForm.patchValue({
            dob: this.beneSelfDetailsForm.get('dob').value ? moment__default(this.beneSelfDetailsForm.get('dob').value).format('YYYY-MM-DD') : null,
            marriageDate: this.beneSelfDetailsForm.get('marriageDate').value ? moment__default(this.beneSelfDetailsForm.get('marriageDate').value).format('YYYY-MM-DD') : null,
            ctznCrtfctIssDate: this.beneSelfDetailsForm.get('ctznCrtfctIssDate').value ? moment__default(this.beneSelfDetailsForm.get('ctznCrtfctIssDate').value).format('YYYY-MM-DD') : null
        });
        const passportExpiryDate = this.beneSelfDetailsForm.get("passport")['controls'][0].get('expiryDate').value;
        const passportIssueDate = this.beneSelfDetailsForm.get("passport")['controls'][0].get('issueDate').value;
        this.beneSelfDetailsForm.get("passport")['controls'][0].patchValue({
            expiryDate: passportExpiryDate ? moment__default(passportExpiryDate).format('YYYY-MM-DD') : '',
            issueDate: passportIssueDate ? moment__default(passportIssueDate).format('YYYY-MM-DD') : '',
        });
        // if (this.checkProperties(this.beneSelfDetailsForm.value.address[2]) && this.checkProperties(this.beneSelfDetailsForm.value.address[2].countryCode.countryCode)) {
        //   //IM-3932-For Existing beneficiary-after clicking on edit link-country code, mobile no, email id, passport fields are showing blank
        //   this.beneSelfDetailsForm.value.address.splice(2);
        // }
        //IM-7524 fix
        const dateRangeFromArray = this.beneSelfDetailsForm.get('address');
        dateRangeFromArray.at(0).patchValue({ dateRangeFrom: ((_b = (_a = dateRangeFromArray === null || dateRangeFromArray === void 0 ? void 0 : dateRangeFromArray.controls[0]) === null || _a === void 0 ? void 0 : _a.get('dateRangeFrom')) === null || _b === void 0 ? void 0 : _b.value) ? moment__default(dateRangeFromArray.controls[0].get('dateRangeFrom').value).format('YYYY-MM-DD') : null });
        dateRangeFromArray.at(1).patchValue({ dateRangeFrom: ((_d = (_c = dateRangeFromArray === null || dateRangeFromArray === void 0 ? void 0 : dateRangeFromArray.controls[1]) === null || _c === void 0 ? void 0 : _c.get('dateRangeFrom')) === null || _d === void 0 ? void 0 : _d.value) ? moment__default(dateRangeFromArray.controls[1].get('dateRangeFrom').value).format('YYYY-MM-DD') : null });
        const foreignAddressIndex = this.beneSelfDetailsForm.value.address.findIndex(x => x.type.code === 'FORN');
        const foreignAddressValue = (_e = this.beneSelfDetailsForm.get('address')
            .controls[foreignAddressIndex]) === null || _e === void 0 ? void 0 : _e.value;
        if (foreignAddressValue) {
            if (!this.showForienAddressMandatory && (!foreignAddressValue.addressLine1 || (foreignAddressValue.addressLine1 && foreignAddressValue.addressLine1.trim() === '')) &&
                (!foreignAddressValue.addressLine2 || (foreignAddressValue.addressLine2 && foreignAddressValue.addressLine2.trim() === '')) &&
                (!foreignAddressValue.locality || (foreignAddressValue.locality && foreignAddressValue.locality.trim() === '')) &&
                (!foreignAddressValue.countryCode || (foreignAddressValue.countryCode && (!foreignAddressValue.countryCode.countryCode || (foreignAddressValue.countryCode.countryCode && foreignAddressValue.countryCode.countryCode.trim() === '')))) &&
                ((this.listStatesForeign.length <= 0 &&
                    (!foreignAddressValue.stateProvinceName ||
                        (foreignAddressValue.stateProvinceName && foreignAddressValue.stateProvinceName.trim() === ''))) ||
                    (this.listStatesForeign.length > 0 && (!foreignAddressValue.stateProvinceCode ||
                        (foreignAddressValue.stateProvinceCode && foreignAddressValue.stateProvinceCode.trim() === '')))) &&
                (!foreignAddressValue.city || (foreignAddressValue.city && foreignAddressValue.city.trim() === '')) &&
                (!foreignAddressValue.postCode || (foreignAddressValue.postCode && foreignAddressValue.postCode.trim() === ''))) {
                this.beneSelfDetailsForm.value.address.splice(foreignAddressIndex);
            }
        }
        let url;
        const race = [];
        // if(this.beneficiaryData.race && this.beneficiaryData.race.length > 0){
        this.beneSelfDetailsForm.value.race.forEach((raceBoolean, i) => {
            if (raceBoolean) {
                const raceObj = this.raceArr[i];
                // //  const racePresent = this.beneficiaryData.race ? this.beneficiaryData.race.find(x => x.raceId.id === raceObj.id) : null;
                race.push({
                    raceId: {
                        id: raceObj.id,
                        name: raceObj.name
                    },
                    id: 0
                });
                //race.push(raceObj);
            }
        });
        //}
        const _m = this.beneSelfDetailsForm.value, { cpyFromPermAddress, cpyFromFrnAddress, cpyFromMailAddress } = _m, rest = __rest(_m, ["cpyFromPermAddress", "cpyFromFrnAddress", "cpyFromMailAddress"]);
        const payload = Object.assign(Object.assign({}, rest), { hasCtznCrtfct: this.beneSelfDetailsForm.value.hasCtznCrtfct ? 1 : 0, lprThruMarriage: this.beneSelfDetailsForm.value.lprThruMarriage ? 1 : 0, uscisAccNumber: this.beneSelfDetailsForm.value['uscisAccNumber'], itin: this.beneSelfDetailsForm.value['itin'] ? this.beneSelfDetailsForm.value['itin'] : null, maritalStatus: Object.assign(Object.assign({}, this.beneSelfDetailsForm.value.maritalStatus), { id: this.showMarriageSection ? this.beneSelfDetailsForm.value.maritalStatus.id : 9 }), ctznAcqrTypeId: this.beneSelfDetailsForm.value['ctznAcqrTypeId']['ctznAcqrId'] && this.beneSelfDetailsForm.value['ctznAcqrTypeId']['ctznAcqrId'] !== 0 ? {
                id: this.beneSelfDetailsForm.value['ctznAcqrTypeId']['ctznAcqrId'],
                name: this.beneSelfDetailsForm.value['ctznAcqrTypeId']['name']
            } : null, ethnicity: {
                id: this.beneSelfDetailsForm.value['ethnicity']['ethnicityId'],
                name: this.beneSelfDetailsForm.value['ethnicity']['name']
            }, gender: {
                id: this.beneSelfDetailsForm.value['gender']['id'],
                name: this.beneSelfDetailsForm.value['gender']['name']
            }, marriageStateProvinceCode: this.beneSelfDetailsForm.value['marriageStateProvinceCode'] ? this.beneSelfDetailsForm.value['marriageStateProvinceCode'] : null, birthCountryCode: this.beneSelfDetailsForm.value['countryCode']['countryCode'] ? this.beneSelfDetailsForm.value['countryCode'] : null, race, hasPassport: !this.beneSelfDetailsForm.value['hasPassport'], title: this.beneSelfDetailsForm.value['title'], ctznshipCountryCode: !this.beneSelfDetailsForm.value['ctznshipCountryCode']['countryCode'] ? { countryCode: null, countryName: null } : this.beneSelfDetailsForm.value['ctznshipCountryCode'] });
        if (!(payload && payload.countryOfMarriage && payload.countryOfMarriage.countryCode)) {
            payload.countryOfMarriage = null;
        }
        let familyPayload = {
            family: []
        };
        if (this.primaryData) {
            if ((this.detailsAbout.showDetailFor === 'self') || (this.type === 'self')) {
                payload.id = this.beneficiaryId || ((_f = this.primaryData) === null || _f === void 0 ? void 0 : _f.sponsorId);
                if (payload.hasOwnProperty('relationShipType')) {
                    delete payload.relationShipType;
                }
                payload['isSaveAsDraft'] = isDraft;
                if (this.onlyFormBuilder === 'FB') {
                    let fbPayload = {
                        companyId: this.companyId,
                        employeeCreationType: this.fbDetails.employeeCreationType,
                        employeeDataToBeFilled: this.fbDetails.employeeDataToBeFilled,
                        employeeDataToBeFilledTypeJSON: JSON.stringify(payload),
                        employeeType: this.fbDetails.employeeType,
                        moduleId: this.fbDetails.moduleId,
                        pageFormId: this.fbDetails.pageFormId,
                        id: this.employeeId
                    };
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.saveEmployeeFB(fbPayload);
                }
                else {
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.saveBeneficiaryDetails((this.beneficiaryId || ((_g = this.primaryData) === null || _g === void 0 ? void 0 : _g.sponsorId)), 'self', payload);
                }
            }
            else {
                if (this.primaryData) {
                    if (this.primaryData && ((_h = this.primaryData) === null || _h === void 0 ? void 0 : _h.familyId) && ((_j = this.primaryData) === null || _j === void 0 ? void 0 : _j.layoutCode) !== 'PERSONAL_DETAIL' || this.type === 'family') {
                        let familyPayload = {
                            family: []
                        };
                        payload.id = this.primaryData.familyId || this.primaryData.jsonInput.applicantsList[0].id;
                        familyPayload.family.push(payload);
                        url = this.genericBeneficiaryPersonalDetailsLibraryService.saveBeneficiaryFamilyDetails((this.beneficiaryId || ((_k = this.primaryData) === null || _k === void 0 ? void 0 : _k.sponsorId)), 'family', familyPayload);
                    }
                }
                else {
                    payload.id = payload.id ? payload.id : 0;
                    familyPayload.family.push(payload);
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.saveBeneficiaryFamilyDetails((this.beneficiaryId || ((_l = this.primaryData) === null || _l === void 0 ? void 0 : _l.sponsorId)), 'family', familyPayload);
                }
            }
            url.pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.selectedSubTabId = null;
                if (data.status === 200) {
                    this.beneSelfDetailsForm.reset(this.beneSelfDetailsForm.value);
                    this.toastr.success(data.message, 'Success');
                    if (this.onlyFormBuilder === 'FB') {
                        this.beneficiaryId = data.data.beneficiaryId;
                        sessionStorage.setItem('FbEmployeeId', this.beneficiaryId.toString());
                    }
                    if (this.detailsAbout.showDetailFor === 'self') {
                        if (this.customQuestionsComponent) {
                            // this.customQuestionsComponent?.onClickSave(null); 
                            //IM-23009 - uncommenting this as custom questions not getting saved which are added under personal details.
                        }
                    }
                    else {
                        if (this.customQuestionsComponent) {
                            this.customQuestionsComponent.onClickSave(data.data[0].id);
                        }
                    }
                    if (this.detailsAbout.showDetailFor === 'dependent') {
                        if (this.detailsAbout.dependentType.subTabsList) {
                            this.selectedSubTabId = data.data[0].id ? data.data[0].id : null;
                        }
                        //this.getBeneficiaryFamilyDetails(true);
                        this.showAddIcon = false;
                    }
                    else {
                        this.genericBeneficiaryPersonalDetailsLibraryService.selfBeneficiaryDetailChange.next();
                        if (this.onlyFormBuilder === 'FB') {
                            this.getformBuilderDetails();
                        }
                        else {
                            //this.getBeneficiaryDetails();
                        }
                    }
                    if (this.onlyFormBuilder === 'FB') {
                        this.documentFileUploadConfigurations.family = false;
                        this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
                    }
                    this.fileUploadConfigurations.family = false;
                    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
                    this.selectedCurrentCheckbox = false;
                    this.selectedPermanentCheckbox = false;
                    this.beneSelfDetailsForm.disable();
                    if (this.beneUpdateProfile) {
                        this.isPersonalDetailsFormReset = true;
                    }
                    this.handleEdit();
                    if (this.type === 'family' || this.detailsAbout.showDetailFor === 'family' || this.detailsAbout.showDetailFor === 'dependent') {
                        this.getBeneficiaryFamilyDetails(true);
                    }
                    else {
                        this.getBeneficiaryDetails();
                    }
                    this.genericBeneficiaryPersonalDetailsLibraryService.triggerSelfDetailsSaved();
                }
            });
        }
        else {
            if (this.detailsAbout.showDetailFor === 'self') {
                payload.id = this.beneficiaryId;
                if (payload.hasOwnProperty('relationShipType')) {
                    delete payload.relationShipType;
                }
                payload['isSaveAsDraft'] = isDraft;
                if (this.onlyFormBuilder === 'FB') {
                    let fbPayload = {
                        companyId: this.companyId,
                        employeeCreationType: this.fbDetails.employeeCreationType,
                        employeeDataToBeFilled: this.fbDetails.employeeDataToBeFilled,
                        employeeDataToBeFilledTypeJSON: JSON.stringify(payload),
                        employeeType: this.fbDetails.employeeType,
                        moduleId: this.fbDetails.moduleId,
                        pageFormId: this.fbDetails.pageFormId,
                        id: this.employeeId
                    };
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.saveEmployeeFB(fbPayload);
                }
                else {
                    url = this.genericBeneficiaryPersonalDetailsLibraryService.saveBeneficiaryDetails(this.beneficiaryId, 'self', payload);
                }
            }
            else {
                payload.id = payload.id ? payload.id : 0;
                familyPayload.family.push(payload);
                url = this.genericBeneficiaryPersonalDetailsLibraryService.saveBeneficiaryFamilyDetails(this.beneficiaryId, 'family', familyPayload);
            }
            // this.customTriggeredStatus == false ? this.customTriggeredStatus = true: this.customTriggeredStatus = false;
            url.pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.selectedSubTabId = null;
                if (data.status === 200) {
                    if (this.onlyFormBuilder === 'FB') {
                        this.beneficiaryId = data.data.beneficiaryId;
                        sessionStorage.setItem('FbEmployeeId', this.beneficiaryId.toString());
                    }
                    if (this.detailsAbout.showDetailFor === 'self') {
                        if (this.customQuestionsComponent) {
                            // this.customQuestionsComponent?.onClickSave(null);
                            //IM-23009 - uncommenting this as custom questions not getting saved which are added under personal details.
                        }
                    }
                    else {
                        if (this.customQuestionsComponent) {
                            this.customQuestionsComponent.onClickSave(data.data[0].id);
                        }
                    }
                    // this.currentFamilyId = data.data[0].id;
                    // this.customQuestionsService.selectedFamilyId = data.data[0].id;
                    // this.customTrigger();
                    this.beneSelfDetailsForm.reset(this.beneSelfDetailsForm.value);
                    //form.resetForm();
                    this.toastr.success(data.message, 'Success');
                    if (this.detailsAbout.showDetailFor === 'dependent') {
                        if (this.detailsAbout.dependentType.subTabsList) {
                            this.selectedSubTabId = data.data[0].id ? data.data[0].id : null;
                            // this.dependentProfileDataService.newSubDependentCreated.next(this.selectedSubTabId)
                        }
                        this.getBeneficiaryFamilyDetails(true);
                        this.showAddIcon = false;
                    }
                    else {
                        this.genericBeneficiaryPersonalDetailsLibraryService.selfBeneficiaryDetailChange.next();
                        if (this.onlyFormBuilder === 'FB') {
                            this.getformBuilderDetails();
                        }
                        else {
                            this.getBeneficiaryDetails();
                        }
                    }
                    if (this.onlyFormBuilder === 'FB') {
                        this.documentFileUploadConfigurations.family = false;
                        this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
                    }
                    this.fileUploadConfigurations.family = false;
                    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
                    this.selectedCurrentCheckbox = false;
                    this.selectedPermanentCheckbox = false;
                    this.beneSelfDetailsForm.disable();
                    if (this.beneUpdateProfile) {
                        this.isPersonalDetailsFormReset = true;
                    }
                    this.handleEdit();
                    this.genericBeneficiaryPersonalDetailsLibraryService.triggerSelfDetailsSaved();
                }
            });
        }
        this.translet();
    }
    checkProperties(obj) {
        for (var key in obj) {
            if (obj[key] !== null && obj[key].toString().trim() != "" && key != 'countryCode' && key != 'type')
                return false;
        }
        return true;
    }
    toggleAlias(e) {
        if (e.checked) {
            this.showAliasName = true;
            this.addAliasName();
        }
        else {
            this.showAliasName = false;
            this.removeAllAliasNames();
        }
        this.translet();
    }
    removeAllAliasNames() {
        const aliasNameArray = this.beneSelfDetailsForm.get('aliasName');
        aliasNameArray.clear(); // Clear all alias names
    }
    addAliasName() {
        const aliasNameArray = this.beneSelfDetailsForm.get('aliasName');
        aliasNameArray.push(this.createAliasNameGroup());
    }
    createAliasNameGroup() {
        return this.beneSelfFormBuilder.group({
            fName: [''],
            title: [''],
            id: ['']
        });
    }
    // IM-4338 fix
    resetAddress(addressType) {
        let addressTypeCode = '';
        switch (addressType.toLowerCase()) {
            case 'permanent':
                this.listStatesPermanent = [];
                addressTypeCode = 'PERM';
                break;
            case 'foreign':
                this.listStatesForeign = [];
                addressTypeCode = 'FORN';
                break;
            case 'mailing':
                this.listStatesMailing = [];
                addressTypeCode = 'MAIL';
                break;
        }
        const resetAddress = this.getAddress(addressTypeCode);
        if (resetAddress) {
            const resetAddressType = resetAddress.value.type;
            const resetAddressID = resetAddress.value.id;
            resetAddress.reset();
            resetAddress.patchValue({
                id: resetAddressID,
                type: resetAddressType
            });
        }
    }
    emptyAddress(addressType) {
        const addressObj = {
            id: null,
            addressLine1: '',
            addressLine2: null,
            countryCode: {
                countryCode: null,
                countryName: null,
            },
            stateProvinceCode: null,
            stateProvinceName: null,
            state: null,
            city: '',
            locality: null,
            postCode: null,
            inCareOfName: null,
            county: null,
            dateRangeFrom: null,
            type: { id: null, code: null, name: null }
        };
        switch (addressType) {
            case 'Current':
                addressObj.type = {
                    id: this.addressTypeList.find(x => x.code === 'CURR') ? this.addressTypeList.find(x => x.code === 'CURR').id : null,
                    code: 'CURR',
                    name: 'Current'
                };
                break;
            case 'Permanent':
                addressObj.type = {
                    id: this.addressTypeList.find(x => x.code === 'PERM') ? this.addressTypeList.find(x => x.code === 'PERM').id : null,
                    code: 'PERM',
                    name: 'Permanent'
                };
                break;
            case 'Foreign':
                addressObj.type = {
                    id: this.addressTypeList.find(x => x.code === 'FORN') ? this.addressTypeList.find(x => x.code === 'FORN').id : null,
                    code: 'FORN',
                    name: 'Foreign'
                };
                break;
            case 'Mailing':
                addressObj.type = {
                    id: this.addressTypeList.find(x => x.code === 'MAIL') ? this.addressTypeList.find(x => x.code === 'MAIL').id : null,
                    code: 'MAIL',
                    name: 'Mailing'
                };
                break;
        }
        return addressObj;
    }
    copyAddress(copyFrom, copyTo) {
        if (copyFrom && copyTo) {
            const addressValue = this.getAddress(copyFrom);
            this.patch(addressValue.value, copyTo, copyTo);
        }
        else {
            this.resetAddress(copyTo);
        }
    }
    handleTabChange(index) {
        // this.clearProfileData(this.beneSelfDetailsForm);
        const selectedDependentTab = this.detailsAbout.dependentType;
        this.beneSelfDetailsForm.addControl('relationShipType', this.beneSelfFormBuilder.group({
            id: [selectedDependentTab.id],
            name: [selectedDependentTab.name]
        }));
        // this.showMarriageSection = ['SPOUSE', 'MOTHER'].includes(this.detailsAbout.dependentType.code) ? false : true;
        if (this.beneficiaryFamilyInfo.length > 0) {
            if (selectedDependentTab.subTabsList) {
                const data = this.beneficiaryFamilyInfo.find(item => item.id == this.detailsAbout.selectedSubTabId);
                this.beneficiaryData = data ? data : this.emptyBeneficiaryData(selectedDependentTab);
            }
            else {
                const data = this.beneficiaryFamilyInfo.find(item => item.relationShipType && item.relationShipType.id === selectedDependentTab.id);
                this.beneficiaryData = data ? data : this.emptyBeneficiaryData(selectedDependentTab);
            }
        }
        else {
            this.beneficiaryData = this.emptyBeneficiaryData(selectedDependentTab);
        }
        this.setBeneficiaryFormData();
    }
    handleNewTabChange(index) {
        // this.clearProfileData(this.beneSelfDetailsForm);
        const selectedDependent = this.detailsAbout.dependentType;
        this.beneSelfDetailsForm.addControl('relationShipType', this.beneSelfFormBuilder.group({
            id: [selectedDependent.relationShipType.id],
            name: [selectedDependent.relationShipType.name]
        }));
        // this.showMarriageSection = ['SPOUSE', 'MOTHER'].includes(this.detailsAbout.dependentType.code) ? false : true;
        if (this.beneficiaryFamilyInfo.length > 0) {
            const data = this.beneficiaryFamilyInfo.find(item => item.id === selectedDependent.id);
            this.beneficiaryData = data ? data : this.emptyBeneficiaryData(selectedDependent);
        }
        else {
            this.beneficiaryData = this.emptyBeneficiaryData(selectedDependent);
        }
        this.setBeneficiaryFormData();
    }
    handleCountryChange(countryCode, stateIndex) {
        // IM-3402 - Added to update state blank for US and India
        if (stateIndex === 'Current') {
            this.listStatesCurrent = [];
        }
        else if (stateIndex === 'Permanent') {
            this.listStatesPermanent = [];
        }
        else if (stateIndex === 'Mailing') {
            this.listStatesMailing = [];
        }
        else if (stateIndex === 'Foreign') {
            this.listStatesForeign = [];
        }
        else if (stateIndex === 'Birth') {
            this.listStatesBirth = [];
        }
        else if (stateIndex === 'Marriage') {
            this.listStatesMarriage = [];
        }
        if (null === countryCode)
            return;
        this.genericBeneficiaryPersonalDetailsLibraryService.getStates(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states) => {
            // console.log(states?.length);
            switch (stateIndex) {
                case 'Current':
                    this.translateAndAssign(states, 'stateProvinceName', 'listStatesCurrent');
                    // this.applyStateValidation(states, 0);
                    // this.applyForeignAddressValidation(countryCode, states, 2); // IM-3402 fix
                    break;
                case 'Permanent':
                    this.translateAndAssign(states, 'stateProvinceName', 'listStatesPermanent');
                    // this.applyStateValidation(states, 1);
                    break;
                case 'Foreign':
                    this.translateAndAssign(states, 'stateProvinceName', 'listStatesForeign');
                    // this.applyForeignStateValidation(states, 2); // IM-3402 fix
                    break;
                case 'Birth':
                    this.translateAndAssign(states, 'stateProvinceName', 'listStatesBirth');
                    // this.applyBirthStateValidation(states, countryCode);
                    break;
                case 'Marriage':
                    this.translateAndAssign(states, 'stateProvinceName', 'listStatesMarriage');
                    // this.applyBirthStateValidation(states);
                    break;
                case 'Mailing':
                    this.translateAndAssign(states, 'stateProvinceName', 'listStatesMailing');
                    break;
            }
        });
    }
    translateAndAssign(states, key, target) {
        this.referenceLibraryService.translateArray(states, 'stateProvinceName')
            .then(translated => {
            this[target] = translated;
        })
            .catch(error => console.error("Translation error:", error));
    }
    handleStateChange(statecode, stateIndex) {
        this.beneSelfDetailsForm.get('address')['controls'][stateIndex].get('stateProvinceCode').clearValidators();
        if (statecode === "null") {
            this.beneSelfDetailsForm.get('address')['controls'][stateIndex].get('stateProvinceCode').setValidators(null);
            this.beneSelfDetailsForm.get('address')['controls'][stateIndex].get('stateProvinceCode').value = null;
            this.beneSelfDetailsForm.get('address')['controls'][stateIndex].get('stateProvinceName').value = '';
            this.beneSelfDetailsForm.updateValueAndValidity();
        }
    }
    resetStateOnCountryChange(index) {
        this.beneSelfDetailsForm.get('address')['controls'][index].get('stateProvinceCode').value = null;
        this.beneSelfDetailsForm.get('address')['controls'][index].get('stateProvinceName').value = '';
    }
    resetBirthStateOnCountryChange() {
        this.beneSelfDetailsForm.get('birthStateProvinceCode').clearValidators();
        this.beneSelfDetailsForm.get('birthStateProvinceName').clearValidators();
        this.beneSelfDetailsForm.get('birthStateProvinceCode').setValue(null);
        this.beneSelfDetailsForm.get('birthStateProvinceName').setValue('');
        this.beneSelfDetailsForm.updateValueAndValidity();
    }
    applyStateValidation(states, type) {
        if (states.length > 0 && this.beneficiaryType === 'self') {
            // IM-3402 - For state validation
            this.beneSelfDetailsForm.get('address')['controls'][type].get('stateProvinceCode').setValidators([Validators.required]);
        }
        else {
            //IM-3948-beneficiary-profile - removed validation for stateprovicename
            this.beneSelfDetailsForm.get('address')['controls'][type].get('stateProvinceCode').clearValidators();
            //IM-3948 - validators were getting cleared but the errors was not getting reset.
            this.customFormUpdateAndValidity(this.beneSelfDetailsForm.get('address')['controls'][type]);
        }
        this.beneSelfDetailsForm.updateValueAndValidity();
    }
    applyForeignStateValidation(states, type) {
        this.beneSelfDetailsForm.get('address')['controls'][type].get('stateProvinceCode').clearValidators();
        if (states.length > 0) {
            // this.beneSelfDetailsForm.get('address')['controls'][type].get('stateProvinceCode').setValidators([Validators.required]);
        }
        this.customFormUpdateAndValidity(this.beneSelfDetailsForm.get('address')['controls'][type]);
        // this.beneSelfDetailsForm.updateValueAndValidity();
    }
    applyBirthStateValidation(states, countryCode) {
        if (states.length > 0) {
            this.beneSelfDetailsForm.get('birthStateProvinceName').clearValidators();
            this.beneSelfDetailsForm.get('birthStateProvinceCode').setValidators([Validators.required]);
        }
        else {
            this.beneSelfDetailsForm.get('birthStateProvinceCode').clearValidators();
            this.beneSelfDetailsForm.get('birthStateProvinceName').clearValidators();
            if (countryCode === 'CAN') {
                this.beneSelfDetailsForm.get('birthStateProvinceName').setValidators([Validators.required]);
                this.isBirthStateRequired = true;
            }
            else {
                this.isBirthStateRequired = false;
            }
            //IM-3768 this.beneSelfDetailsForm.get('birthStateProvinceName').setValidators([Validators.required]);
        }
        this.beneSelfDetailsForm.updateValueAndValidity();
    }
    //IM-3402 fix
    applyForeignAddressValidation(countryCode, states, type) {
        if (countryCode === 'USA' && this.beneficiaryType === 'self') {
            this.showForienAddressMandatory = true;
            this.beneSelfDetailsForm.get('address')['controls'][type].get('addressLine1').setValidators([Validators.required]);
            this.beneSelfDetailsForm.get('address')['controls'][type].get('city').setValidators([Validators.required]);
        }
        else {
            this.showForienAddressMandatory = false;
            this.clearForeignAddrValidators(type);
        }
        this.customFormUpdateAndValidity(this.beneSelfDetailsForm.get('address')['controls'][type]);
    }
    customFormUpdateAndValidity(form) {
        Object.keys(form.controls).forEach(key => {
            form.controls[key].updateValueAndValidity();
        });
    }
    clearForeignAddrValidators(type) {
        this.beneSelfDetailsForm.get('address')['controls'][type].get('addressLine1').clearValidators();
        this.beneSelfDetailsForm.get('address')['controls'][type].get('city').clearValidators();
        this.beneSelfDetailsForm.get('address')['controls'][type].get('stateProvinceCode').clearValidators();
        this.customFormUpdateAndValidity(this.beneSelfDetailsForm.get('address')['controls'][type]);
    }
    //IM-3403 fix
    updateCountry(countryCode, field) {
        const ctznshipCountryCodeVal = this.beneSelfDetailsForm.get("ctznshipCountryCode.countryCode").value;
        if (ctznshipCountryCodeVal === 'USA') {
            this.showCitizenShipAquiredInfo = true;
            // if (this.beneficiaryType === 'self') {
            //   this.beneSelfDetailsForm.get('ctznAcqrTypeId.ctznAcqrId').setValidators(Validators.required);
            //   this.beneSelfDetailsForm.get('ctznAcqrTypeId.ctznAcqrId').updateValueAndValidity();
            // }
        }
        else {
            this.showCitizenShipAquiredInfo = false;
            this.beneSelfDetailsForm.get('ctznAcqrTypeId.ctznAcqrId').clearValidators();
            this.beneSelfDetailsForm.get('ctznAcqrTypeId.ctznAcqrId').reset(null);
            this.beneSelfDetailsForm.get('hasCtznCrtfct').reset(false);
            this.beneSelfDetailsForm.get('ctznAcqrTypeId.ctznAcqrId').updateValueAndValidity();
            this.setValidatorForCitizenShipAquired();
        }
        // this.setValidatorForCitizenShipAquired();
        if (field === 'citizenship') {
            this.beneSelfDetailsForm.get("ctznshipCountryCode").patchValue({
                countryCode: countryCode,
            });
            this.updateCountry(countryCode, 'issueCountryCode');
        }
        else {
            if (this.onlyFormBuilder !== 'FB') {
                this.beneSelfDetailsForm.get("passport")['controls'][0].get('issueCountryCode').patchValue({
                    countryCode: countryCode,
                });
            }
        }
        this.translet();
    }
    resetCitizenShipAquiredValues() {
        const ctznCrtfctNoCtrl = this.beneSelfDetailsForm.get('ctznCrtfctNo');
        const ctznCrtfctIssPlaceCtrl = this.beneSelfDetailsForm.get('ctznCrtfctIssPlace');
        const ctznCrtfctIssDateCtrl = this.beneSelfDetailsForm.get('ctznCrtfctIssDate');
        const validationCitizenshipArr = [ctznCrtfctNoCtrl, ctznCrtfctIssPlaceCtrl, ctznCrtfctIssDateCtrl];
        for (let i = 0; i < validationCitizenshipArr.length; i++) {
            validationCitizenshipArr[i].patchValue(null);
            validationCitizenshipArr[i].clearValidators();
            validationCitizenshipArr[i].reset();
            validationCitizenshipArr[i].markAsPristine();
            validationCitizenshipArr[i].updateValueAndValidity();
        }
    }
    setValidatorForCitizenShipAquired() {
        //  const hasCtznCrtfctCtrl = this.beneSelfDetailsForm.get('hasCtznCrtfct') as FormControl;
        //  const ctznAcqrTypeIdCtrl = this.beneSelfDetailsForm.get('ctznAcqrTypeId.ctznAcqrId') as FormControl;
        // const ctznCrtfctNoCtrl = this.beneSelfDetailsForm.get('ctznCrtfctNo') as FormControl;
        // const ctznCrtfctIssPlaceCtrl = this.beneSelfDetailsForm.get('ctznCrtfctIssPlace') as FormControl;
        // const ctznCrtfctIssDateCtrl = this.beneSelfDetailsForm.get('ctznCrtfctIssDate') as FormControl;
        // const validationCitizenshipArr = [ctznCrtfctNoCtrl, ctznCrtfctIssPlaceCtrl, ctznCrtfctIssDateCtrl];
        // // hasCtznCrtfctCtrl.setValidators
        // for (let i = 0; i < validationCitizenshipArr.length; i++) {
        //   if (this.showCitizenShipAquiredInfo) {
        //     validationCitizenshipArr[i].setValidators(Validators.required);
        //     ctznCrtfctNoCtrl.setValidators([Validators.required, Validators.pattern(this.certificateNumberValidPattern)]);
        //     ctznCrtfctIssPlaceCtrl.setValidators([Validators.required, Validators.pattern(this.textOnlyValidPattern)]);
        //   } else {
        //     validationCitizenshipArr[i].patchValue(null);
        //     validationCitizenshipArr[i].reset();
        //     validationCitizenshipArr[i].clearValidators();
        //   }
        //   validationCitizenshipArr[i].updateValueAndValidity();
        // }
    }
    foreignAddChange($event) {
        if (this.showforeignAddress && $event.value === 'PA') {
            let Address = this.getAddress('PERM');
            this.patch(Address['value'], 'Permanent', 'Foreign');
        }
        else if (this.showforeignAddress && $event.value === 'CA') {
            let Address = this.getAddress('CURR');
            this.patch(Address['value'], 'Current', 'Foreign');
        }
    }
    getAddress(code) {
        let Address;
        for (const control of this.beneSelfDetailsForm.get('address').controls) {
            if (control.value.type.code === code) {
                Address = control;
                return Address;
            }
        }
    }
    permanentAddChange($event) {
        if ($event.value === 'CA') {
            this.patch(this.beneSelfDetailsForm.get('address').get('0').value, 'Current', 'Permanent');
        }
    }
    getAddressGroup(addrType) {
        let temp = this.beneSelfDetailsForm.get('address');
        if (temp instanceof FormArray) {
            return temp.controls.findIndex(x => x.value['type']['code'] === addrType);
        }
    }
    validateExpiry(issueDate, expiryDate) {
        this.showExpiryValidation = this.genericBeneficiaryPersonalDetailsLibraryService.MaxDateValidate(issueDate, expiryDate);
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleCitizenshipSwitchChange() {
        if (!this.beneSelfDetailsForm.get('hasCtznCrtfct').value) {
            this.resetCitizenShipAquiredValues();
        }
        else if (this.beneficiaryType === 'self') {
            this.setValidatorForCitizenShipAquired();
        }
    }
    handleLawfulSwitchChange() {
    }
    handleIsLprChanges() {
        // const isLprVlaue = this.beneSelfDetailsForm.get('isLpr').value;
        // const greenCardControl = this.beneSelfDetailsForm.get('greenCardNo');
        // const lprThruMarriageCtrl = this.beneSelfDetailsForm.get('lprThruMarriage');
        // if (isLprVlaue && this.beneficiaryType === 'self') {
        //   greenCardControl.setValidators([Validators.required, Validators.pattern(this.greenCardValidPattern)]);
        // } else {
        //   greenCardControl.clearValidators();
        //   greenCardControl.patchValue(null);
        //   lprThruMarriageCtrl.patchValue(null);
        //   // greenCardControl.setValidators([Validators.pattern(this.greenCardValidPattern)]);
        // }
        // greenCardControl.updateValueAndValidity();
    }
    handleRaceSelection(isChecked, id, index) {
        this.beneSelfDetailsForm.get('race')['controls'][index].get('raceId').patchValue({
            checked: isChecked ? true : false
        });
    }
    toggleEditView(val) {
        this.showAddIcon = false;
        this.handleEdit();
        // this.editDetails = true;
    }
    emptyBeneficiaryData(selectedDepedent) {
        // this.setvalidatations();
        //  this.beneSelfDetailsForm.reset();
        this.submitted = false;
        return {
            id: 0,
            userName: '',
            visaSponsor: '',
            title: '',
            fName: '',
            mName: '',
            lName: ' ',
            profilePic: ' ',
            aliasNames: '',
            aliasName: [{
                    id: 0,
                    title: '',
                    fName: '',
                    mName: '',
                    lName: '',
                }],
            currentVisaStatus: '',
            visaStatus: '',
            birthState: null,
            birthCity: '',
            birthStateProvinceCode: '',
            birthStateProvinceName: '',
            ctznshipCountryCode: {
                countryCode: '',
                countryName: '',
            },
            gender: {
                id: 0,
                name: '',
            },
            countryCode: {
                countryCode: '',
                countryName: '',
            },
            dob: null,
            identificationMark: '',
            height: null,
            skinColor: '',
            eyeColor: '',
            hairColor: '',
            phoneContacts: [
                {
                    id: 0,
                    phoneNo: null,
                    countryCode: {
                        phoneCode: 0,
                        countryCode: '',
                        countryName: '',
                    },
                    type: {
                        code: '',
                        name: '',
                    }
                }
            ],
            emailContacts: [{
                    email: '',
                    id: 0,
                    type: {
                        code: 'PRIM',
                        id: this.emailTypeList.find(x => x.code === 'PRIM') ? this.emailTypeList.find(x => x.code === 'PRIM').id : null
                    }
                }],
            hasPassport: true,
            passport: [{
                    id: 0,
                    passportNo: '',
                    issueDate: null,
                    expiryDate: null,
                    issueCountryCode: {
                        countryCode: '',
                        countryName: '',
                    }
                }],
            addressDifferFlag: null,
            address: [
                {
                    id: 0,
                    addressLine1: '',
                    addressLine2: '',
                    countryCode: {
                        countryCode: '',
                        countryName: '',
                    },
                    stateProvinceCode: '',
                    stateProvinceName: '',
                    state: null,
                    city: '',
                    locality: '',
                    postCode: null,
                    inCareOfName: null,
                    county: null,
                    dateRangeFrom: null,
                    type: {
                        code: 'FORN',
                        name: 'FOREIGN',
                        id: 232,
                    },
                },
                {
                    id: 0,
                    addressLine1: '',
                    addressLine2: '',
                    countryCode: {
                        countryCode: '',
                        countryName: '',
                    },
                    stateProvinceCode: '',
                    stateProvinceName: '',
                    state: null,
                    city: '',
                    locality: '',
                    postCode: null,
                    inCareOfName: null,
                    county: null,
                    dateRangeFrom: null,
                    type: {
                        code: 'PERM',
                        name: 'Permanent',
                        id: 2,
                    },
                },
                {
                    id: 0,
                    addressLine1: '',
                    addressLine2: '',
                    countryCode: {
                        countryCode: '',
                        countryName: '',
                    },
                    stateProvinceCode: '',
                    stateProvinceName: '',
                    state: null,
                    city: '',
                    locality: '',
                    postCode: null,
                    inCareOfName: null,
                    county: null,
                    dateRangeFrom: null,
                    type: {
                        code: 'CURR',
                        name: 'Current',
                        id: 1,
                    },
                }
            ],
            ssn: '',
            uscisAccNumber: null,
            itin: '',
            relationShipType: {
                id: selectedDepedent && selectedDepedent.id ? selectedDepedent.id : 0,
                name: selectedDepedent && selectedDepedent.name ? selectedDepedent.name : ''
            },
            maritalStatus: {
                id: selectedDepedent && ['SPOUSE', 'MOTHER'].includes(selectedDepedent.code) ? 9 : null,
                name: '',
            },
            countryOfMarriage: {
                countryCode: '',
                countryName: '',
            },
            marriageStateProvinceCode: null,
            marriageStateProvinceName: '',
            cityOfMarriage: '',
            isLpr: null,
            lprThruMarriage: 0,
            greenCardNo: '',
            ethnicity: {
                id: 0,
                ethnicityId: 0,
                name: '',
            },
            race: null,
            weight: 0,
            ctznAcqrTypeId: {
                ctznAcqrId: null,
                id: null,
                name: '',
            },
            hasCtznCrtfct: null,
            ctznCrtfctNo: '',
            ctznCrtfctIssPlace: '',
            ctznCrtfctIssDate: null,
            marriageDate: null,
            profileImage: null,
        };
    }
    ngOnDestroy() {
        var _a;
        (_a = this.formChangesSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
    uploadSignatureImage() {
        this.showCropperSection = false;
        const dialogRef = this.dialog.open(SignatureUploadComponent, {
            panelClass: 'custom-dialog'
        });
        dialogRef.afterClosed().subscribe(result => {
            this.sessionpicimage = sessionStorage.setItem("SesionpicValue", this.signatureImage);
            const file = this.dataURItoBlob(result);
            //console.dir("blob", file);
            let reader = new FileReader();
            let self = this;
            reader.readAsDataURL(file);
            reader.onload = function () {
                self.signatureImage = reader.result;
            };
            reader.onerror = function (error) {
            };
            this.signatureImageForm = new FormData();
            this.signatureImageForm.append("file", file, "mysignature.png");
            if (this.onlyFormBuilder !== 'FB') {
                if (this.beneficiaryData.id === this.beneficiaryId) {
                    this.genericBeneficiaryPersonalDetailsLibraryService.postSignatureImageBen(this.beneficiaryId, this.signatureImageForm).subscribe((response) => {
                        if (response['status'] === 200) {
                            this.toastr.success('Image Uploaded successfully', 'Success');
                        }
                        else {
                            CustomErrorToastComponent.showErrorToast(this.toastr, 'Image is not Uploaded successfully');
                        }
                    });
                }
                else {
                    if (this.beneficiaryData.id !== 0) {
                        this.genericBeneficiaryPersonalDetailsLibraryService.postFamilySignatureImageBen(this.beneficiaryId, this.beneficiaryData.id, this.signatureImageForm).subscribe((response) => {
                            if (response['status'] === 200) {
                                this.toastr.success('Image Uploaded successfully', 'Success');
                            }
                            else {
                                CustomErrorToastComponent.showErrorToast(this.toastr, 'Image is not Uploaded successfully');
                            }
                        });
                    }
                }
            }
            else {
                if (this.beneficiaryData.id === this.beneficiaryIdFromFB) {
                    this.genericBeneficiaryPersonalDetailsLibraryService.postSignatureImageBen(this.beneficiaryIdFromFB, this.signatureImageForm).subscribe((response) => {
                        if (response['status'] === 200) {
                            this.toastr.success('Image Uploaded successfully', 'Success');
                        }
                        else {
                            CustomErrorToastComponent.showErrorToast(this.toastr, 'Image is not Uploaded successfully');
                        }
                    });
                }
            }
        });
    }
    dataURItoBlob(dataURI) {
        const binary = atob(dataURI.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
            type: 'image/png',
        });
    }
    getSignatureImage() {
        let signImage = "";
        if (this.onlyFormBuilder === 'FB') {
            if (this.beneficiaryId === this.beneficiaryData.id) {
                this.genericBeneficiaryPersonalDetailsLibraryService.getSignatureImageBen(this.beneficiaryId).subscribe((response) => {
                    if (response['status'] === 200) {
                        this.signatureImage = (response['data']['signImage'] !== null && response['data']['signImage'] !== undefined) ? `data:image/jpeg;base64,${response['data']['signImage']}` : '';
                        //alert(this.sessionpicimage);
                    }
                });
            }
            else {
                if (this.beneficiaryData.id > 0) {
                    this.genericBeneficiaryPersonalDetailsLibraryService.getFamilySignatureImageBen(this.beneficiaryId, this.beneficiaryData.id).subscribe((response) => {
                        if (response['status'] === 200) {
                            this.signatureImage = (response['data']['signImage'] !== null && response['data']['signImage'] !== undefined) ? `data:image/jpeg;base64,${response['data']['signImage']}` : '';
                            //alert(this.sessionpicimage);
                        }
                    });
                }
            }
        }
        else {
            if (this.beneficiaryIdFromFB === this.beneficiaryData.id) {
                this.genericBeneficiaryPersonalDetailsLibraryService.getSignatureImageBen(this.beneficiaryIdFromFB).subscribe((response) => {
                    if (response['status'] === 200) {
                        this.signatureImage = (response['data']['signImage'] !== null && response['data']['signImage'] !== undefined) ? `data:image/jpeg;base64,${response['data']['signImage']}` : '';
                        //alert(this.sessionpicimage);
                    }
                });
            }
        }
    }
    backToOriginPage() {
        sessionStorage.removeItem('redirectUrl');
        //this.router.navigate([`${this.redirectUrl}`]);
    }
    backToTask() {
        const taskPageUrl = sessionStorage.getItem('redirectUrl');
        sessionStorage.removeItem('redirectUrl');
        this.router.navigate([`${taskPageUrl}`]);
    }
    removeValidations(formElement) {
        Object.keys(formElement.controls).forEach(field => {
            const control = formElement.get(field);
            if (control instanceof FormControl) {
                control.clearValidators();
                control.updateValueAndValidity();
            }
            else if (control instanceof FormArray) {
                this.removeValidations(control);
            }
            else if (control instanceof FormGroup) {
                this.removeValidations(control);
            }
        });
    }
    saveAsDraft(event) {
        this.savePersonalData(event);
    }
    uploadFamilyProfile(event) {
        this.showCropperSection = false;
        const dialogRef = this.dialog.open(ProfilePictureUploadComponent, {
            panelClass: 'custom-dialog',
            height: '435px',
            width: '520px'
        });
        dialogRef.afterClosed().subscribe(result => {
            let profileImage = result;
            const file = this.dataURItoBlob(result);
            let fd1 = new FormData();
            fd1.append("file", file, "myprofile.png");
            this.genericBeneficiaryPersonalDetailsLibraryService.updateFamilyProfilePic(this.beneficiaryId, event, fd1).subscribe((response) => {
                if (response['status'] === 200) {
                    this.getBeneficiaryFamilyDetails();
                    this.toastr.success('Profile Pic Uploaded successfully', 'Success');
                }
                else {
                    CustomErrorToastComponent.showErrorToast(this.toastr, 'Profile Pic Upload Failed!');
                }
            });
        });
    }
    uploadProfile() {
        this.showCropperSection = false;
        let employeeId = parseInt(sessionStorage.getItem('employeeId'));
        const dialogRef = this.dialog.open(ProfilePictureUploadComponent, {
            panelClass: 'custom-dialog',
            height: '435px',
            width: '520px'
        });
        dialogRef.afterClosed().subscribe(result => {
            let profileImage = result;
            const file = this.dataURItoBlob(result);
            let fd = new FormData();
            fd.append("file", file, "myprofile.png");
            this.genericBeneficiaryPersonalDetailsLibraryService.updateProfilePic(this.beneficiaryId, fd).subscribe((response) => {
                if (response['status'] === 200) {
                    this.profilePic = `data:image/jpeg;base64,${response['data']['profilePic']}`;
                    sessionStorage.setItem('profilePic', response['data']['profilePic']);
                    sessionStorage.setItem('avatar', response['data']['smalPprofilePic']);
                    let noUpdateFlag = sessionStorage.getItem('FbEmployeeId') !== sessionStorage.getItem('beneficiaryId') ? true : false;
                    this.genericBeneficiaryPersonalDetailsLibraryService.imageProfileUpdated(noUpdateFlag);
                    this.toastr.success('Profile Pic Uploaded successfully', 'Success');
                }
                else {
                    CustomErrorToastComponent.showErrorToast(this.toastr, 'Profile Pic Upload Failed!');
                }
            });
        });
    }
    get raceArray() {
        return this.beneSelfDetailsForm.get('race');
    }
}
GenericBeneficiaryPersonalDetailsLibraryComponent.ɵfac = function GenericBeneficiaryPersonalDetailsLibraryComponent_Factory(t) { return new (t || GenericBeneficiaryPersonalDetailsLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.ReferenceLibraryService), i0.ɵɵdirectiveInject(i2$2.FormBuilder), i0.ɵɵdirectiveInject(i3.CacheCountryListService), i0.ɵɵdirectiveInject(i4$1.ToastrService), i0.ɵɵdirectiveInject(i2$1.MatDialog), i0.ɵɵdirectiveInject(i6.Store), i0.ɵɵdirectiveInject(i7.Router), i0.ɵɵdirectiveInject(i7.ActivatedRoute), i0.ɵɵdirectiveInject(GenericBeneficiaryPersonalDetailsLibraryService)); };
GenericBeneficiaryPersonalDetailsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GenericBeneficiaryPersonalDetailsLibraryComponent, selectors: [["lib-generic-beneficiary-personal-details-library"]], viewQuery: function GenericBeneficiaryPersonalDetailsLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(CustomQuestionnaireComponent, 1);
        i0.ɵɵviewQuery(HelpVideoOverlayLibraryComponent, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customQuestionsComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.helpVideoComponent = _t.first);
    } }, inputs: { updateEditButtonStatus: "updateEditButtonStatus", caseRequestShowDivs: "caseRequestShowDivs", benQuestShowDivs: "benQuestShowDivs", isViewMode: "isViewMode", documentType: "documentType", formDetails: "formDetails", beneficiaryData: "beneficiaryData", detailsAbout: "detailsAbout", editMode: "editMode", customQuestionsDisplay: "customQuestionsDisplay", isShowProfilePic: "isShowProfilePic", isShowVerify: "isShowVerify", isEditDisabled: "isEditDisabled", passportShow: "passportShow", primaryData: "primaryData", type: "type" }, outputs: { profileEditStatus: "profileEditStatus", personalDetails: "personalDetails", beneficiaryIdFromFB1: "beneficiaryIdFromFB1", hasFamily: "hasFamily", hasPassportChange: "hasPassportChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 3, consts: [[4, "ngIf"], ["class", "edit-beneficiary-profile", 3, "ngClass", 4, "ngIf"], ["class", "add-placeholder", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["id", "about", 1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], ["class", "row mt-2", 4, "ngIf"], [1, "row", "row-cols-5"], [1, "col", "mb-2"], ["id", "userName", 1, "label-light", "m-0", "common-bene-class-for-translation"], [1, "label-dark"], ["id", "firstName", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "requiredFields", 4, "ngIf"], ["id", "middleName", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "lastName", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "dob", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "gender", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "countryCode", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "mobile", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "col-4 mb-2", 4, "ngIf"], [1, "col-4", "mb-2"], ["id", "email", 1, "label-light", "m-0", "common-bene-class-for-translation"], [1, "label-dark", "wrap-word"], ["id", "placeOfBirth", 1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], ["id", "country1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "state1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "label-dark ", 4, "ngIf"], ["id", "city1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "citizenship1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "materialstatus1", 1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], [1, "row"], [1, "col-12"], ["id", "currentMaterialStatus", 1, "label-light", "m-0", "common-bene-class-for-translation"], [1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], [1, "col", "mb-2", "word-wrap"], [1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "mailingAddressDetails", 1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], ["id", "address1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "address2", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "area", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "country3", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "state3", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "city3", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "zipcode3", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "row row-cols-5", 4, "ngIf"], ["class", "pb-3", 4, "ngIf"], [1, "subProfileContent", "mb-3"], [1, "subTabProfile", 3, "selected"], ["id", "advancedDetails123", 1, "common-bene-class-for-translation"], ["id", "fAddress1", 1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], ["id", "address1d", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "address2d", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "area2d", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "country2d", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "state2d", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "label-dark", 4, "ngIf"], ["id", "city2d", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "zip2d", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "labelText mt-2 title-profile common-bene-class-for-translation", "id", "bioinfo", 4, "ngIf"], ["class", "labelText mt-2 title-profile common-bene-class-for-translation", "id", "additionalInfo", 4, "ngIf"], [1, "col-md-4"], [1, "form-group"], ["id", "visaSponsor1", 1, "label-light", "m-0", "common-bene-class-for-translation"], [1, "col-4", "pt-3"], ["type", "button", "class", "p-btn btn btn-primary mr-3", 3, "disabled", "click", 4, "ngIf"], [1, "col-12", "text-right"], [1, "back-button", "button-width-icon-left", "btn-pos-top-right", "btn", "btn-primary", 3, "disabled", "click"], [1, "fa", "fa-pencil"], [1, "common-bene-class-for-translation"], [1, "row", "mt-2"], [1, "col-md-2"], [1, "row", "profile-image-card"], [4, "ngIf", "ngIfElse"], ["viewOnly", ""], [1, "col", "profile-Header"], [1, "label-dark1"], [1, "wrap-word"], [1, "text-center", "imageBox"], [1, "rounded-circle", 3, "src"], [1, "requiredFields"], ["id", "sslN", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "lawfulResident", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "passport1", 1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], [1, "col"], ["id", "passNo_122", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "issueAuthority1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "dob1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "doe1", 1, "label-light", "m-0", "common-bene-class-for-translation"], [1, "row", "row-cols-12"], ["alt", "Signature", "class", "signatureImageBox", 3, "src", 4, "ngIf"], ["alt", "Signature", 1, "signatureImageBox", 3, "src"], [4, "ngFor", "ngForOf"], ["class", "customSections", 4, "ngFor", "ngForOf"], [1, "customSections"], [3, "isNewPortion", "viewQuestions", "loadedIn", "beneficiaryId", "isSection", "familyId"], [1, "pb-3"], ["id", "bioinfo", 1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], ["id", "Ethnicity", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "race", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "label-dark ", 4, "ngFor", "ngForOf"], ["id", "hairColor", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "eyeColor", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "weight", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "label-light pl-1", "id", "pounds", 4, "ngIf"], ["id", "pounds", 1, "label-light", "pl-1"], ["id", "height1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["class", "label-light pl-1", "id", "inches", 4, "ngIf"], ["id", "markidentification1", 1, "label-light", "m-0", "common-bene-class-for-translation"], ["id", "inches", 1, "label-light", "pl-1"], ["id", "additionalInfo", 1, "labelText", "mt-2", "title-profile", "common-bene-class-for-translation"], ["type", "button", 1, "p-btn", "btn", "btn-primary", "mr-3", 3, "disabled", "click"], [1, "edit-beneficiary-profile", 3, "ngClass"], [3, "formGroup", "ngSubmit", 4, "ngIf"], ["class", "row mt-4", 4, "ngIf"], [3, "formGroup", "ngSubmit"], ["f", "ngForm"], ["id", "about2a", 1, "labelText", "mt-2", "abt-p", "common-bene-class-for-translation"], [1, "col-3"], ["id", "userName", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "formControlName", "userName", "placeholder", "Enter your User Name", "readonly", "", 1, "im-input"], ["class", "col-3", 4, "ngIf"], ["class", "col-3", "formGroupName", "gender", 4, "ngIf"], ["class", "col-6", 4, "ngIf"], ["class", "col-3", "formArrayName", "emailContacts", 4, "ngIf"], ["id", "USCISOnlineAccount", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "formControlName", "uscisAccNumber", "placeholder", "USCIS Account No", "maxlength", "12", 1, "im-input", "mx-0"], ["class", "invalid-message common-bene-class-for-translation", "id", "pleaseenterNoOnly", 4, "ngIf"], ["id", "IRS_TxNumber", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "formControlName", "itin", "placeholder", "IRS Tax Number", "maxlength", "15", 1, "im-input"], ["class", "col-4", "formGroupName", "countryCode", 4, "ngIf"], ["class", "col-4", 4, "ngIf"], ["formArrayName", "address"], [3, "formGroupName", 4, "ngIf"], ["class", "row mt-4", "formGroupName", "cpyFromMailAddress", 4, "ngIf"], ["formArrayName", "address", 4, "ngIf"], ["class", "row mb-2", 4, "ngIf"], [1, "row", "mt-4", "mb-4"], [1, "position-relative"], ["class", "row paddingTop10 pb-3", 4, "ngIf"], ["id", "Advanced_Details11", 1, "common-bene-class-for-translation"], ["class", "row mt-4", "formGroupName", "cpyFromFrnAddress", 4, "ngIf"], ["class", "row mt-4", "formGroupName", "cpyFromPermAddress", 4, "ngIf"], ["formArrayName", "race", 4, "ngIf"], [1, "row", "pt-4", "pb-4"], ["class", "back-button d-inline-flex align-items-center pr-3 pl-3 mr-3", 3, "click", 4, "ngIf"], ["type", "submit", 1, "btn", "btn-success", "button-width-icon-left", "mr-3"], [1, "fa", "fa-floppy-o"], ["id", "save2save", 1, "common-bene-class-for-translation"], ["type", "button", "class", "back-button button-width-icon-left", 3, "click", 4, "ngIf"], ["class", "mt-4", 4, "ngIf"], ["type", "submit", 1, "btn", "btn-success", "button-width-icon-left", "btn-pos-top-right"], [1, "rounded-circle", 3, "src", "click"], [1, "material-icons", "edit-img-icon", 3, "click"], ["id", "title2a", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["id", "title", "formControlName", "title", "optionLabel", "name", "optionValue", "code", 3, "options"], ["pTemplate", "item"], ["defaultOption", ""], ["id", "selectTitle", 1, "common-bene-class-for-translation", 2, "color", "gray"], ["class", "label-cls common-bene-class-for-translation pl-1", "id", "fName1", 3, "required", 4, "ngIf"], ["class", "label-cls common-bene-class-for-translation pl-1", "id", "fName1", 4, "ngIf"], ["type", "text", "pattern", "^[\\D]*$", "formControlName", "fName", "placeholder", "Enter your First Name", 1, "im-input", 3, "ngClass"], ["class", "invalid-message", 4, "ngIf"], ["id", "fName1", 1, "label-cls", "common-bene-class-for-translation", "pl-1"], [1, "invalid-message"], ["id", "error_required", 1, "common-bene-class-for-translation"], ["id", "ALPHABETS_SPLCHARS", 1, "common-bene-class-for-translation"], ["id", "mName", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "pattern", "^[\\D]*$", "formControlName", "mName", "placeholder", "Enter your Middle Name", 1, "im-input", 3, "ngClass"], ["id", "ALPHABETS_SPLCHARS2", 1, "common-bene-class-for-translation"], ["class", "label-cls common-bene-class-for-translation pl-1", "id", "lNamw", 3, "required", 4, "ngIf"], ["class", "label-cls common-bene-class-for-translation pl-1", "id", "lNamw", 4, "ngIf"], ["type", "text", "pattern", "^[\\D]*$", "formControlName", "lName", "placeholder", "Enter your Last Name", 1, "im-input", 3, "ngClass"], ["id", "lNamw", 1, "label-cls", "common-bene-class-for-translation", "pl-1"], ["id", "required2_", 1, "common-bene-class-for-translation"], ["id", "ALPHABETS_SPLCHARS3_", 1, "common-bene-class-for-translation"], ["class", "col-12", 4, "ngIf"], ["class", "w-100", "formArrayName", "aliasName", 4, "ngIf"], [3, "checked", "change"], ["id", "doYouHaveAnotherName", 1, "common-bene-class-for-translation"], ["formArrayName", "aliasName", 1, "w-100"], ["formGroupName", "0", 1, "row"], [1, "col-3", "showAliasName"], ["id", "title_21", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "title"], [3, "value", 4, "ngFor", "ngForOf"], [1, "col-9"], ["id", "1_aliasName", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "formControlName", "fName", "placeholder", "Alias Name", 1, "im-input", "mw-100"], [3, "value"], ["formGroupName", "gender", 1, "col-3"], ["id", "2_1gender", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["formControlName", "id", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Gender", 3, "options"], ["id", "233_dob", 1, "label-cls", "common-bene-class-for-translation"], ["appearance", "outline", 1, "mt-0", "date-field"], ["formControlName", "dob", "matInput", "", "min", "1920-12-31", "placeholder", "MM/DD/YYYY", 3, "max", "matDatepicker", "click"], ["matSuffix", "", 3, "for"], ["dob", ""], [1, "col-6"], ["formArrayName", "phoneContacts"], [1, "row", "row-with-negative-margin", 3, "formGroupName"], ["formGroupName", "countryCode", 1, "col-6"], ["id", "countryCode_vcod", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["formControlName", "countryCode", "optionValue", "countryCode", "optionLabel", "labelWithCode", "filterBy", "countryName", "placeholder", "Select", 3, "options", "filter"], [1, "label-cls"], ["id", "mobNo", 1, "common-bene-class-for-translation"], ["id", "10DIGIT", 1, "common-bene-class-for-translation"], ["type", "text", "formControlName", "phoneNo", "minlength", "10", "maxlength", "10", "placeholder", "Enter", 1, "im-input", "col-md", 3, "ngClass"], ["id", "1_INVALID_NUMBER", 1, "common-bene-class-for-translation"], ["id", "2_MAXLENGTH", 1, "common-bene-class-for-translation"], ["id", "3_MINLENGTH", 1, "common-bene-class-for-translation"], ["formArrayName", "emailContacts", 1, "col-3"], ["class", "label-cls common-bene-class-for-translation", "id", "emailId__", 3, "required", 4, "ngIf"], ["class", "label-cls common-bene-class-for-translation", "id", "emailId__", 4, "ngIf"], ["id", "emailId__", 1, "label-cls", "common-bene-class-for-translation"], [3, "formGroupName"], ["type", "text", "formControlName", "email", "placeholder", "Enter", "pattern", "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$", 1, "im-input", 3, "ngClass"], ["id", "REQUIRED1__", 1, "label-cls", "common-bene-class-for-translation"], ["id", "__INVALID_EMAIL__", 1, "label-cls", "common-bene-class-for-translation"], ["id", "sslN-1", 1, "label-cls", "common-bene-class-for-translation"], [1, "ssn-field"], ["type", "text", "formControlName", "ssn", "placeholder", "SSN", 1, "im-input", "ssn-input", 3, "ngClass"], ["matSuffix", "", "matTooltip", "Show/Hide", 3, "click"], ["class", "invalid-message common-bene-class-for-translation", "id", "please_enter_9_digit", 4, "ngIf"], ["id", "please_enter_9_digit", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "pleaseenterNoOnly", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "_AreYouLawful_", 1, "label-cls", "mb-2", "common-bene-class-for-translation"], [1, "clearfix"], [1, "img-radio-button-label-container"], ["formControlName", "isLpr", "name", "isLpr", "inputId", "YES", 3, "value", "onClick"], ["for", "YES", 1, "img-radio-button-label", "common-bene-class-for-translation"], ["formControlName", "isLpr", "name", "isLpr", "inputId", "NO", 1, "ml-2", 3, "value", "onClick"], ["for", "NO", 1, "img-radio-button-label", "common-bene-class-for-translation"], [1, "col-4"], [1, "label-cls", "mb-2"], ["id", "greenCard", 1, "common-bene-class-for-translation"], ["id", "Ex.XXX0000000000", 1, "common-bene-class-for-translation"], ["type", "text", "formControlName", "greenCardNo", "maxlength", "13", "placeholder", "Enter your Green Card No.", 1, "im-input", 3, "ngClass"], ["class", "invalid-message common-bene-class-for-translation", "id", "_1_INVALID_FORMAT", 4, "ngIf"], ["id", "_1_INVALID_FORMAT", 1, "invalid-message", "common-bene-class-for-translation"], [1, "p-grid", "p-my-2"], ["name", "question", "id", "permanentResidentStatus", 1, "p-col-11", "common-bene-class-for-translation", "label-cls", "mt-2", "pl-2"], [1, "p-col-1"], ["formControlName", "lprThruMarriage", 3, "onChange"], [1, "mt-2", "p-col-12"], ["class", "lbl-text-2 common-bene-class-for-translation", "id", "AddPhotocopyGreencard", 4, "ngIf"], [2, "width", "100%", 3, "configurations"], ["id", "AddPhotocopyGreencard", 1, "lbl-text-2", "common-bene-class-for-translation"], [1, "row", "mt-4"], ["id", "_1_placeOfBirth_", 1, "labelText", "common-bene-class-for-translation"], ["formGroupName", "countryCode", 1, "col-4"], ["id", "country11", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["formControlName", "countryCode", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "Select", "filterBy", "countryName", 3, "options", "filter", "onChange"], ["id", "state11", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["formControlName", "birthStateProvinceCode", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "Select State", "filterBy", "stateProvinceName", 3, "options", "filter"], ["id", "country12", 1, "label-cls", "common-bene-class-for-translation"], ["class", "im-input", "formControlName", "birthStateProvinceName", "type", "text", "placeholder", "State", 4, "ngIf"], ["formControlName", "birthStateProvinceName", "type", "text", "placeholder", "State", 1, "im-input"], ["id", "_1city__11", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "birthCity", "type", "text", "placeholder", "City", 1, "im-input"], ["formGroupName", "ctznshipCountryCode"], ["id", "_1_Citizenship", 1, "label-cls", "common-bene-class-for-translation"], ["formGroupName", "ctznAcqrTypeId", 1, "selectionContainer"], ["class", "label-cls mb-2 common-bene-class-for-translation", "id", "CitizenshipWasAcquired", 4, "ngIf"], ["class", "float-left mt-2 p-field-checkbox", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "p-grid", "p-my-2", "pl-2"], ["name", "question", "id", "Naturalization", 1, "label-cls", "mt-2", "common-bene-class-for-translation"], ["formControlName", "hasCtznCrtfct", 3, "onChange"], ["id", "CitizenshipWasAcquired", 1, "label-cls", "mb-2", "common-bene-class-for-translation"], [1, "float-left", "mt-2", "p-field-checkbox", 3, "ngClass"], ["name", "ctznAcqrId", "formControlName", "ctznAcqrId", 3, "inputId", "value"], [1, "label-cls", "common-bene-class-for-translation", 3, "for", "id"], ["id", "CertificateNumber", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "ctznCrtfctNo", "type", "text", "placeholder", "Enter", "maxlength", "8", 1, "im-input"], ["id", "placeOfInsurance", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "ctznCrtfctIssPlace", "type", "text", "placeholder", "Enter", 1, "im-input"], ["id", "_D_teOfInsurance", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "ctznCrtfctIssDate", "matInput", "", "min", "1920-12-12", "placeholder", "MM/DD/YYYY", 3, "max", "matDatepicker", "click"], ["ctznCrtfctIssDate", ""], ["id", "1_MaterialStatus_2", 1, "labelText", "common-bene-class-for-translation"], ["formGroupName", "maritalStatus", 1, "col-4", "sele", "actionContainer"], ["id", "WhatIsYourCurrentMarital", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "id", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", "filterBy", "name", 3, "options", "filter", "onChange"], ["class", "col-4", "formGroupName", "countryOfMarriage", 4, "ngIf"], ["id", "date_of_marriage", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "marriageDate", "matInput", "", "min", "1920-12-12", "placeholder", "MM/DD/YYYY", 3, "max", "matDatepicker", "click"], ["marriageDate", ""], ["id", "p_laceOfMarriage_1", 1, "labelSubText", "common-bene-class-for-translation"], ["formGroupName", "countryOfMarriage", 1, "col-4"], ["id", "contryOfmarriage-2", 1, "label-cls", "common-bene-class-for-translation"], ["id", "stateOfMarriage_1", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "marriageStateProvinceCode", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "Select State", "filterBy", "stateProvinceName", 3, "options", "filter", "onChange"], ["formControlName", "marriageStateProvinceName", "type", "text", "placeholder", "State", 1, "im-input"], ["id", "stateOfMarriage_1222", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "cityOfMarriage", "type", "text", "placeholder", "City", 1, "im-input"], [1, "labelText", "common-bene-class-for-translation"], [1, "col-8"], [1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "id", "inCareOfName", "formControlName", "inCareOfName", "placeholder", "In Care Of", 1, "im-input", "col-md"], ["type", "text", "formControlName", "addressLine1", "placeholder", "Address 1", "maxLength", "150", 1, "im-input", "col-md"], ["pTooltip", "Enter Apartment, Suite, Floor number with the prefix Apt, Ste or Flr respectively. This will be automatically mapped to the Apartment, Suite and Floor fields in the forms", 1, "pi", "pi-info-circle"], ["type", "text", "formControlName", "addressLine2", "placeholder", "Address 2", "maxLength", "150", 1, "im-input", "col-md"], ["formControlName", "locality", "type", "text", "placeholder", "Area", 1, "im-input"], [1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["formControlName", "city", "type", "text", "placeholder", "City", 1, "im-input"], ["formControlName", "postCode", "type", "text", "placeholder", "Zip Code", "maxLength", "10", 1, "im-input", 3, "ngClass"], ["class", "invalid-message common-bene-class-for-translation", 4, "ngIf"], ["type", "text", "id", "inCareOfName", "formControlName", "county", "placeholder", "County", 1, "im-input", "col-md"], [1, "col-md-8"], ["formControlName", "dateRangeFrom", "matInput", "", "min", "1920-12-31", "placeholder", "MM/DD/YYYY", 3, "max", "matDatepicker", "click"], ["dateRangeFrom", ""], ["formControlName", "stateProvinceCode", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "Select State", "filterBy", "stateProvinceName", 3, "options", "filter", "onChange"], ["formControlName", "stateProvinceName", "type", "text", "placeholder", "State", 1, "im-input"], [1, "invalid-message", "common-bene-class-for-translation"], ["formGroupName", "cpyFromMailAddress", 1, "row", "mt-4"], ["id", "mailingAddressDetails_112", 1, "labelText", "common-bene-class-for-translation"], [1, "col-2", "pt-1"], ["id", "copyForm11", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], [1, "d-flex", "align-items-center", "gap-3"], ["class", "ml-2 p-field-checkbox", 4, "ngFor", "ngForOf"], [1, "ml-2", "p-field-checkbox"], ["formControlName", "mailCode", "name", "mailCode", 3, "inputId", "value", "onClick"], [1, "common-bene-class-for-translation", 3, "for", "id"], ["id", "add-1", 1, "label-cls", "common-bene-class-for-translation"], ["id", "add-2", 1, "common-bene-class-for-translation"], ["id", "ar1", 1, "label-cls", "common-bene-class-for-translation"], ["id", "coun-1", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["id", "cit-11", 1, "label-cls", "common-bene-class-for-translation"], ["id", "zp11", 1, "label-cls", "common-bene-class-for-translation"], ["id", "stat-1", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["id", "stat-1", 1, "label-cls", "common-bene-class-for-translation"], ["id", "ZIPCODE_ONLY_1_22", 1, "common-bene-class-for-translation"], ["id", "psDetails1", 1, "labelText", "common-bene-class-for-translation"], [1, "row", "mb-2"], [1, "col-12", "has-passport-outer"], ["formControlName", "hasPassport", "binary", "true", "inputId", "hasPass", 3, "onChange"], ["for", "hasPass", 1, "img-radio-button-label", "common-bene-class-for-translation"], ["formArrayName", "passport"], ["class", "col-8", 4, "ngIf"], ["class", "col-4", "formGroupName", "issueCountryCode", 4, "ngIf"], ["class", "label-cls common-bene-class-for-translation", "id", "passp_001", 4, "ngIf"], ["type", "text", "formControlName", "passportNo", "placeholder", "Passport #", "maxlength", "9", 1, "im-input", "mw-100"], ["id", "passp_001", 1, "label-cls", "common-bene-class-for-translation"], ["formGroupName", "issueCountryCode", 1, "col-4"], ["id", "isAuth_0909", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["formControlName", "countryCode", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "Select", "filterBy", "countryName", 3, "options", "filter"], ["id", "dateOfIssues_9090", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "issueDate", "matInput", "", "min", "1920-12-12", "placeholder", "MM/DD/YYYY", 3, "max", "matDatepicker", "click"], ["issueDate", ""], ["id", "dateOfExp_8080", 1, "label-cls", "common-bene-class-for-translation"], ["placeholder", "MM/DD/YYYY", "matInput", "", "formControlName", "expiryDate", "max", "9999-12-31", 3, "matDatepicker", "min", "change", "click"], ["expiryDate", ""], [1, "row", "paddingTop10", "pb-3"], ["class", "pl-3 pr-2 linehgt10", 4, "ngIf"], [1, ""], [1, "signtext"], ["type", "button", "title", ".png only", 1, "signaturePromptBtn", "btn", "btn-lg", 3, "click"], ["class", "paddingLeft10  common-bene-class-for-translation paddingRight10", "id", "upSign1", 4, "ngIf"], ["class", "common-bene-class-for-translation", "id", "chngeSig001", 4, "ngIf"], [1, "row", "col-12", "linehgt10"], [1, "pl-3", "pr-2", "linehgt10"], ["id", "upSign1", 1, "paddingLeft10", "common-bene-class-for-translation", "paddingRight10"], ["id", "chngeSig001", 1, "common-bene-class-for-translation"], [3, "isNewPortion", "viewQuestions", "loadedIn", "beneficiaryId", "isSection", "familyId", "refreshList"], ["formGroupName", "cpyFromFrnAddress", 1, "row", "mt-4"], ["id", "frn89", 1, "labelText", "common-bene-class-for-translation"], [1, "col-3", "pt-1"], ["id", "cpy76", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], [1, "col-md-12", "mb-2"], [1, "mb-0", "label-cls"], ["id", "note4233", 1, "common-bene-class-for-translation"], ["id", "whoseCurrentAddress4233", 1, "common-bene-class-for-translation"], ["pTooltip", "If you are applying from your country of origin (i.e., outside the US), enter your \"Non-US Address\" details under \"Foreign Address\" also.", 1, "pi", "pi-info-circle", 2, "color", "#01a0da"], ["formControlName", "frnCode", "name", "frnCode", 3, "inputId", "value", "onClick"], [3, "for"], [1, "common-bene-class-for-translation", 3, "id"], ["id", "currentad-1", 1, "label-cls", "common-bene-class-for-translation"], ["id", "currentad-2", 1, "common-bene-class-for-translation"], ["id", "currentArea-1", 1, "label-cls", "common-bene-class-for-translation"], ["id", "currentCountry-11", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["formControlName", "countryCode", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "Select", "styleClass", "country-dd", "filterBy", "countryName", 3, "options", "filter", "onChange"], ["id", "city234", 1, "label-cls", "common-bene-class-for-translation"], ["id", "zp234", 1, "label-cls", "common-bene-class-for-translation"], ["class", "invalid-message common-bene-class-for-translation", "id", "er3", 4, "ngIf"], ["id", "currntState-rw3", 1, "label-cls", "ddLabel", "common-bene-class-for-translation"], ["formControlName", "stateProvinceCode", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "Select State", "filterBy", "stateProvinceName", 3, "options", "filter"], ["id", "st234", 1, "label-cls", "common-bene-class-for-translation"], ["id", "er3", 1, "invalid-message", "common-bene-class-for-translation"], ["formGroupName", "cpyFromPermAddress", 1, "row", "mt-4"], [1, "col-4", "pt-1"], ["formControlName", "permCode", "name", "permCode", 3, "value", "onClick"], [1, "mt-1", "common-bene-class-for-translation", 3, "for"], ["formControlName", "locality", "type", "text", "placeholder", "Locality", 1, "im-input"], ["id", "bi2", 1, "labelText", "common-bene-class-for-translation"], ["class", "selectionContainer", "formGroupName", "ethnicity", 4, "ngIf"], ["formGroupName", "ethnicity", 1, "selectionContainer"], ["id", "rth02221", 1, "label-cls", "mb-2", "common-bene-class-for-translation"], ["class", "col-3 mt-2 p-0 p-field-checkbox", 4, "ngFor", "ngForOf"], [1, "col-3", "mt-2", "p-0", "p-field-checkbox"], ["name", "ethnicityId", "formControlName", "ethnicityId", 3, "inputId", "value"], [1, "mb-0", 3, "for"], [1, "label-cls", "common-bene-class-for-translation", 3, "id"], ["formArrayName", "race"], ["id", "race-5", 1, "label-cls", "pl-3", "common-bene-class-for-translation"], [1, "row", "mt-2", 2, "display", "block"], [1, "col-4", 2, "display", "inline-block"], ["binary", "true", 3, "label", "formControl"], ["id", "hColor", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "hairColor", "optionLabel", "name", "optionValue", "code", "placeholder", "Select", 3, "options"], ["id", "eColor", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "eyeColor", "optionLabel", "name", "optionValue", "code", "placeholder", "Select", 3, "options"], ["id", "wforweight", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "formControlName", "weight", "placeholder", "Enter", 1, "im-input", 3, "ngClass"], ["class", "invalid-message common-bene-class-for-translation", "id", "err098", 4, "ngIf"], ["id", "err098", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "hforheight", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "formControlName", "height", "placeholder", "Enter", 1, "im-input", 3, "ngClass"], ["class", "invalid-message common-bene-class-for-translation", "id", "er4562", 4, "ngIf"], ["id", "er4562", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "markidentification-2246w3e322", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "formControlName", "identificationMark", "placeholder", "Enter", 1, "im-input", "mw-100"], ["id", "addInfo322323-3", 1, "labelText", "common-bene-class-for-translation"], ["id", "visaSponsor-33987654", 1, "label-cls", "common-bene-class-for-translation"], ["formControlName", "visaSponsor", "type", "text", 1, "im-input", "m-0"], [1, "back-button", "d-inline-flex", "align-items-center", "pr-3", "pl-3", "mr-3", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-chevron-circle-left", "pr-1"], ["id", "backtoback", 1, "common-bene-class-for-translation"], ["type", "button", 1, "back-button", "button-width-icon-left", 3, "click"], [1, "fa", "fa-times-circle"], ["id", "cancel-35436432", 1, "common-bene-class-for-translation"], [1, "mt-4"], ["id", "addPassportPhotocoty-23232", 1, "labelText", "common-bene-class-for-translation"], ["class", "lbl-text-2 common-bene-class-for-translation", "id", "addiDco-1", 4, "ngIf"], ["id", "addiDco-1", 1, "lbl-text-2", "common-bene-class-for-translation"], [1, "add-placeholder"], ["mat-fab", "", "color", "primary", 1, "btn", 3, "disabled", "click"], ["matTooltip", "Create Profile"], ["id", "pro-22", 1, "label-dark", "mt-3", "common-bene-class-for-translation"]], template: function GenericBeneficiaryPersonalDetailsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GenericBeneficiaryPersonalDetailsLibraryComponent_div_0_Template, 296, 80, "div", 0);
        i0.ɵɵtemplate(1, GenericBeneficiaryPersonalDetailsLibraryComponent_div_1_Template, 3, 5, "div", 1);
        i0.ɵɵtemplate(2, GenericBeneficiaryPersonalDetailsLibraryComponent_div_2_Template, 7, 2, "div", 2);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.editDetails && !ctx.showAddIcon);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.editDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.editModeVal && ctx.showAddIcon);
    } }, directives: [i9.NgIf, i10.Accordion, i10.AccordionTab, i11.Header, i12.MatCard, i9.NgForOf, i13.CustomQuestionnaireComponent, i9.NgClass, i2$2.ɵangular_packages_forms_forms_ba, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.FormControlName, i2$2.MaxLengthValidator, i2$2.FormArrayName, i14.MatDivider, i15.Dropdown, i11.PrimeTemplate, i2$2.PatternValidator, i16.MatCheckbox, i2$2.FormGroupName, i17.MatFormField, i18.MatSelect, i19.MatOption, i20.MatInput, i21.MatDatepickerInput, i21.MatDatepickerToggle, i17.MatSuffix, i21.MatDatepicker, i2$2.MinLengthValidator, i22.MatIcon, i23.RadioButton, i24.InputSwitch, i25.FileUploadDeafultLibraryComponent, i26.Tooltip, i27.Checkbox, i2$2.FormControlDirective, i28.SimpleFileUploadComponent], pipes: [ImgDateFormatPipe, i9.DatePipe], styles: [".personalDetailContainer[_ngcontent-%COMP%]{color:rgba(0,0,0,.87)}.personalDetailContainer[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:13px!important;color:grey!important;margin:0!important}.personalDetailContainer[_ngcontent-%COMP%]   .boldHead[_ngcontent-%COMP%]{font-size:12px;margin-bottom:.2rem!important}.personalDetailContainer[_ngcontent-%COMP%]   .padBootom10[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{padding:20px 0 10px;font-weight:600;font-size:18px;color:#2f4f4f}.personalDetailContainer[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:small}.personalDetailContainer[_ngcontent-%COMP%]   .profileName[_ngcontent-%COMP%]{font-size:1.5em}.personalDetailContainer[_ngcontent-%COMP%]   .profileEmail[_ngcontent-%COMP%]{color:#00f}.personalDetailContainer[_ngcontent-%COMP%]   .paddingTop1[_ngcontent-%COMP%]{padding-top:1em}.personalDetailContainer[_ngcontent-%COMP%]   .headers[_ngcontent-%COMP%]{font-size:1.5em}.personalDetailContainer[_ngcontent-%COMP%]   .dashedBottomBorder[_ngcontent-%COMP%]{border-bottom:1px dashed grey}.personalDetailContainer[_ngcontent-%COMP%]   .dashedRightBorder[_ngcontent-%COMP%]{padding-right:10px;border-right:1px dashed grey}.personalDetailContainer[_ngcontent-%COMP%]   .hideFile[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{display:none}.personalDetailContainer[_ngcontent-%COMP%]   .margin1rem[_ngcontent-%COMP%]{margin-left:1rem}.personalDetailContainer[_ngcontent-%COMP%]   .marginTop[_ngcontent-%COMP%]{margin-top:1rem}.personalDetailContainer[_ngcontent-%COMP%]   .mat-form-field[_ngcontent-%COMP%]:not(.date-field):not(.example-chip-list){margin-top:-13px!important;width:100%}.personalDetailContainer[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{border-top:none!important;padding:15px 0!important;top:-3px}.small-profile-img[_ngcontent-%COMP%]{width:100px;height:100px;cursor:pointer!important}.titleBox[_ngcontent-%COMP%]{background-color:#f1f0f0}.paddingBottom10[_ngcontent-%COMP%]{padding-bottom:10px}.paddingLeft10[_ngcontent-%COMP%]{padding-left:10px}.paddingTop10[_ngcontent-%COMP%]{padding-top:10px}.paddingBottom30[_ngcontent-%COMP%]{padding-bottom:30px}.width20[_ngcontent-%COMP%]{width:20%}.width80[_ngcontent-%COMP%]{width:80%}.custom-dialog[_ngcontent-%COMP%]   .mat-dialog-container[_ngcontent-%COMP%]{overflow:hidden!important}.cursorPointer[_ngcontent-%COMP%]{cursor:pointer!important}.imageBox[_ngcontent-%COMP%]{width:100px;height:100px}.opacity1[_ngcontent-%COMP%]{opacity:1;z-index:1}.smallFont[_ngcontent-%COMP%]{font-size:small}.profile-gap[_ngcontent-%COMP%]{margin-top:20px}.readonly-data[_ngcontent-%COMP%]{font-size:14px;line-height:22px;border:none;font-weight:600;color:#465f7c}.ssn-field[_ngcontent-%COMP%]{border:1.5px solid #a3a6b4;border-radius:.4rem;display:flex;align-items:center;height:40px;font-size:15px;color:#000;box-shadow:0 10px 10px 0 hsla(0,0%,96.5%,.8);padding-right:.5rem!important}.ssn-input[_ngcontent-%COMP%]{border-left:0!important;border-right:0!important;border-top-right-radius:0;border-bottom-right-radius:0;box-shadow:none!important}.ssn-input-hide[_ngcontent-%COMP%]{-webkit-text-security:disc}.selectionContainer[_ngcontent-%COMP%]{display:block}.selectionContainer[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:inline-block}.wrap-word[_ngcontent-%COMP%]{word-break:break-all}.label-dark[_ngcontent-%COMP%]{line-height:20px}.row-with-negative-margin[_ngcontent-%COMP%]{margin-left:-15px;margin-right:-15px}.profile-image-card[_ngcontent-%COMP%]{min-height:150px;box-shadow:0 0 0 rgba(0,0,0,.075)!important}.imageBox[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{position:relative}.edit-img-icon[_ngcontent-%COMP%], .imageBox[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border:1px solid #dee2e6!important}.edit-img-icon[_ngcontent-%COMP%]{background:#fff 0 0 no-repeat padding-box!important;padding:.3rem!important;border-radius:50%!important;top:55%!important;left:70%!important;position:absolute!important;cursor:pointer!important}.profile-Header[_ngcontent-%COMP%]{padding:5% 10px}.label-dark1[_ngcontent-%COMP%]{font-weight:600;margin:0;padding-right:5px}.rounded-circle[_ngcontent-%COMP%]{width:100px;height:100px;border:1px #dee2e6}.imageBox[_ngcontent-%COMP%]{width:120px;height:120px}  .p-accordion .personal-details-header p-accordiontab:first-child .p-accordion-header .p-accordion-header-link{background:transparent!important}.abt-p[_ngcontent-%COMP%]{font-size:18px!important;padding-left:20px}.title-profile[_ngcontent-%COMP%]{padding-left:15px;font-size:16px!important;padding-bottom:15px!important;margin-bottom:15px}.btn-pos-top-right[_ngcontent-%COMP%]{position:absolute;top:-3.7em;right:4px}.invalidBtn[_ngcontent-%COMP%]{background-color:#6ac2e7!important;cursor:not-allowed!important}.addSubTabs[_ngcontent-%COMP%]{border-radius:20px}.word-wrap[_ngcontent-%COMP%]{word-break:break-word}.custom-dialog[_ngcontent-%COMP%]   .mat-dialog-container[_ngcontent-%COMP%]{background-color:#ecebeb!important;padding:0!important;width:500px!important;height:400px!important}.signatureImageBox[_ngcontent-%COMP%]{border:1px dotted;max-width:200px;max-height:200px;padding:5px;margin-bottom:5px}.signaturePromptBtn[_ngcontent-%COMP%]{font-size:15px!important;padding:0!important;color:#2196f3;border-bottom:2px solid;border-radius:0!important;height:20px;background:transparent}.signtext[_ngcontent-%COMP%]{margin-bottom:0;padding-top:5px}.signaturePromptBtn[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{padding:0}.linehgt10[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{line-height:10px}  .p-checkbox-label,   span.mat-checkbox-label>span{font-size:14px!important;font-family:Source sans pro!important}.signatureImageBox[_ngcontent-%COMP%]{min-width:230px;min-height:83px}  .showAliasName .mat-form-field-infix{margin-top:-1em!important}.label-cls[_ngcontent-%COMP%]   .pi-info-circle[_ngcontent-%COMP%]{font-size:14px!important;color:#01a0da!important}.back-button[_ngcontent-%COMP%]   .fa-chevron-circle-left[_ngcontent-%COMP%]{font-size:1.5rem}.disabledView[_ngcontent-%COMP%]{pointer-events:none}.ddLabel[_ngcontent-%COMP%]{padding-bottom:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryPersonalDetailsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-generic-beneficiary-personal-details-library',
                templateUrl: `./generic-beneficiary-personal-details-library.component.html`,
                styleUrls: ['./generic-beneficiary-personal-details-library.component.scss']
            }]
    }], function () { return [{ type: i1$1.ReferenceLibraryService }, { type: i2$2.FormBuilder }, { type: i3.CacheCountryListService }, { type: i4$1.ToastrService }, { type: i2$1.MatDialog }, { type: i6.Store }, { type: i7.Router }, { type: i7.ActivatedRoute }, { type: GenericBeneficiaryPersonalDetailsLibraryService }]; }, { updateEditButtonStatus: [{
            type: Input,
            args: ['updateEditButtonStatus']
        }], caseRequestShowDivs: [{
            type: Input
        }], benQuestShowDivs: [{
            type: Input
        }], isViewMode: [{
            type: Input
        }], documentType: [{
            type: Input
        }], formDetails: [{
            type: Input
        }], customQuestionsComponent: [{
            type: ViewChild,
            args: [CustomQuestionnaireComponent]
        }], beneficiaryData: [{
            type: Input
        }], helpVideoComponent: [{
            type: ViewChild,
            args: [HelpVideoOverlayLibraryComponent, { static: false }]
        }], profileEditStatus: [{
            type: Output
        }], personalDetails: [{
            type: Output
        }], beneficiaryIdFromFB1: [{
            type: Output
        }], hasFamily: [{
            type: Output
        }], detailsAbout: [{
            type: Input
        }], editMode: [{
            type: Input
        }], customQuestionsDisplay: [{
            type: Input
        }], isShowProfilePic: [{
            type: Input
        }], isShowVerify: [{
            type: Input
        }], isEditDisabled: [{
            type: Input
        }], passportShow: [{
            type: Input
        }], hasPassportChange: [{
            type: Output
        }], primaryData: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

const routes = [
    {
        path: '',
        component: GenericBeneficiaryPersonalDetailsLibraryComponent
    }
];
class GenericBeneficiaryPersonalDetailsLibraryModule {
}
GenericBeneficiaryPersonalDetailsLibraryModule.ɵfac = function GenericBeneficiaryPersonalDetailsLibraryModule_Factory(t) { return new (t || GenericBeneficiaryPersonalDetailsLibraryModule)(); };
GenericBeneficiaryPersonalDetailsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: GenericBeneficiaryPersonalDetailsLibraryModule });
GenericBeneficiaryPersonalDetailsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatDialogModule,
            ImageCropperModule,
            MatIconModule,
            DropdownModule,
            DialogModule,
            ButtonModule,
            PaginatorModule,
            MultiSelectModule,
            InputTextareaModule,
            MatExpansionModule,
            ConfirmDialogModule,
            AccordionModule,
            MatDatepickerModule,
            DeleteDialogLibraryModule,
            MatSidenavModule,
            MatListModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            MatCardModule,
            MatCheckboxModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatRadioModule,
            MatSelectModule,
            MatChipsModule,
            MatTableModule,
            SaveAsDraftModule,
            FileUploadLibraryModule,
            FileUploadDeafultLibraryModule,
            FileDownloadLibraryModule,
            HelpVideoOverlayLibraryModule,
            CustomQuestionnaireModule,
            SimpleFileUploadModule,
            RouterModule.forChild(routes)
        ], RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GenericBeneficiaryPersonalDetailsLibraryModule, { declarations: [GenericBeneficiaryPersonalDetailsLibraryComponent, SignatureUploadComponent, ProfilePictureUploadComponent, ImgDateFormatPipe], imports: [PrimengLibraryModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        ImageCropperModule,
        MatIconModule,
        DropdownModule,
        DialogModule,
        ButtonModule,
        PaginatorModule,
        MultiSelectModule,
        InputTextareaModule,
        MatExpansionModule,
        ConfirmDialogModule,
        AccordionModule,
        MatDatepickerModule,
        DeleteDialogLibraryModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatCardModule,
        MatCheckboxModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSelectModule,
        MatChipsModule,
        MatTableModule,
        SaveAsDraftModule,
        FileUploadLibraryModule,
        FileUploadDeafultLibraryModule,
        FileDownloadLibraryModule,
        HelpVideoOverlayLibraryModule,
        CustomQuestionnaireModule,
        SimpleFileUploadModule, i7.RouterModule], exports: [GenericBeneficiaryPersonalDetailsLibraryComponent, RouterModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryPersonalDetailsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [GenericBeneficiaryPersonalDetailsLibraryComponent, SignatureUploadComponent, ProfilePictureUploadComponent, ImgDateFormatPipe],
                imports: [
                    PrimengLibraryModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDialogModule,
                    ImageCropperModule,
                    MatIconModule,
                    DropdownModule,
                    DialogModule,
                    ButtonModule,
                    PaginatorModule,
                    MultiSelectModule,
                    InputTextareaModule,
                    MatExpansionModule,
                    ConfirmDialogModule,
                    AccordionModule,
                    MatDatepickerModule,
                    DeleteDialogLibraryModule,
                    MatSidenavModule,
                    MatListModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatChipsModule,
                    MatTableModule,
                    SaveAsDraftModule,
                    FileUploadLibraryModule,
                    FileUploadDeafultLibraryModule,
                    FileDownloadLibraryModule,
                    HelpVideoOverlayLibraryModule,
                    CustomQuestionnaireModule,
                    SimpleFileUploadModule,
                    RouterModule.forChild(routes)
                ],
                exports: [GenericBeneficiaryPersonalDetailsLibraryComponent, RouterModule]
            }]
    }], null, null); })();

/*
 * Public API Surface of generic-beneficiary-personal-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GenericBeneficiaryPersonalDetailsLibraryComponent, GenericBeneficiaryPersonalDetailsLibraryModule, GenericBeneficiaryPersonalDetailsLibraryService };
//# sourceMappingURL=generic-beneficiary-personal-details-library.js.map
